import React, { useState, useEffect } from "react";
import Login from "./Login";
import Register from "./Register";
import { auth } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";

const galopCards = [
  { text: " hesten kan ikke følge med og bliver stående.", effect: 0 },
  { text: " viser fin galop og rykker 2 felter frem.", effect: 2 },
  { text: " viser svag galop. Slip tøjlerne.", effect: 1 },
  { text: " udviser stærkt tempo og flyttes 3 felter frem.", effect: 3 },
  { text: " presses let og rykker 1 felt frem.", effect: 1 },
  { text: " yder fin galop og rykker 3 felter frem.", effect: 3 },
  { text: " kan ikke følge med og bliver stående.", effect: 0 },
  { text: " presses og rykker 1 ekstra felt frem.", effect: 1 },
  { text: " styrter. Hesten står over.", effect: 0 },
  { text: " forceres og rykker 2 felter frem.", effect: 2 },
  { text: " har uro i sadlen og rykker 2 felter frem.", effect: 2 },
  { text: " udviser stærkt tempo og flyttes 3 felter frem.", effect: 3 },
  { text: " udviser super galop og flyttes 6 felter frem.", effect: 6 },
  { text: " kan ikke følge med og bliver stående.", effect: 0 },
  { text: " yder fin galop og rykker 2 felter ekstra frem.", effect: 2 },
  { text: " viser svag galop. Slip tøjlerne.", effect: 1 },
  { text: " hesten kan ikke følge med og bliver stående.", effect: 0 },
  { text: " presses let og rykker 1 felt frem.", effect: 1 },
  { text: " viser fin galop og rykker 3 felter frem.", effect: 3 },
  { text: " udviser stærkt tempo og flyttes 3 felter frem.", effect: 3 },
  { text: " presses og rykker 1 felt frem.", effect: 1 },
  { text: " styrter. Hesten bliver stående.", effect: 0 },
  { text: " forceres og rykker 2 felter ekstra frem.", effect: 2 },
  { text: " har uro i sadlen og rykker 2 felter frem.", effect: 2 },
  { text: " udviser stærkt tempo og flyttes 3 felter frem.", effect: 3 }
];

const chanceCards = [
  { text: "Banen må repareres. Betal 4.000 kr til Horsetrack & Stables A/S💰", effect: -4000 },
  { text: "💰Krise. Gælder alle - Betal 35% af deres kontanter.", effect: 0 }, 
  { text: "💰Staldtips. Sats 1000 kr. på en hest, hvis du har kontanter.", effect: 0 },
  { text: "💰i overskud.", effect: 10000 },
  { text: "💰 For TAXI kørsel - Kom sikkert hjem med BornTAXI ApS💰", effect: -1000 },
  { text: "Affaldshåndtering hos Hestepærer Affald A/S💰", effect: -3000 },
  { text: "Jockeybetaling. Betal 3.000 til Jockeytjenesten A/S💰", effect: -3000 },
  { text: "Køb foder for 4.000 kr. hos Hestepleje og foder A/S💰", effect: -4000 },
  { text: "Betal for spisning 2500 kr. til Restaurant Hesteskoen A/S💰", effect: -2500 },
  { text: "Betal for udstyr 3000 kr. til Præmier og Pokaler A/S💰", effect: -3000 },
  { text: "💰 Udbytte - totosyndikatet giver afkast", effect: 0 },
  { text: "Betal for annonce 2.000 kr. til Galoptidende A/S💰", effect: -2000 },
  { text: "Betal for ny beklædning 4.000 kr. til Ryttershoppen A/S💰", effect: -4000 },
  { text: "Stald-leje. Betal 5.500 kr. til A/S Galopstald💰", effect: -5500 },
  { text: "Dyrlægeregning. Betal 3.000 kr. til Dyrlægegården A/S💰", effect: -3000 },
  { text: "💰i indtægt fra hoppeauktionen", effect: 10000 },
  { text: "💰i indtægt fra følauktionen", effect: 15000 },
  { text: "Handelsplads. Betal 3.000 kr. til Hesteargenturet A/S💰", effect: -3000 },
  { text: "💰Staldtips. Sats 1000 kr. på en hest, hvis du har kontanter.", effect: 0 },
  { text: "💰Fremgang. Gælder alle - Forøger kontanter med 40%.", effect: 0 },
  { text: "💰i lotterigevinst", effect: 10000 },
  { text: "💰Din hest er halt og tages ud af løbet. Er den forsikret, udbetales erstatning.", effect: 0 },
  { text: "Stald-leje. Betal 5.500 kr. til A/S Galopstald💰", effect: -5500 },
  { text: "Betal for udstyr 3000 kr. til Præmier og Pokaler A/S💰", effect: -3000 },
  { text: "Hestetræning. Betal 5.000 til Trænertjenesten A/S💰", effect: -5000 },
  { text: "💰 Udbytte - totosyndikatet giver afkast", effect: 0 },
  { text: "💰 For TAXI kørsel - Kom sikkert hjem med BornTAXI ApS💰", effect: -1000 },
  { text: "Dyrlægeregning. Betal 3.000 kr. til Dyrlægegården A/S💰", effect: -3000 },
  { text: "Jockeybetaling. Betal 5.000 til Jockeytjenesten A/S💰", effect: -5000 },
  { text: "Betal for spisning 2500 kr. til Restaurant Hesteskoen A/S💰", effect: -2500 },
  { text: "💰Staldtips. Sats 1000 kr. på en hest, hvis du har kontanter.", effect: 0 },
  { text: "Banen må repareres. Betal 4.000 kr. til Horsetrack & Stable A/S💰", effect: -4000 },
  { text: "Betal for annonce 2.000 kr. til Galoptidende A/S💰", effect: -2000 },
  { text: "Betal for ny beklædning 4.000 kr. til Ryttershoppen A/S💰", effect: -4000 },
  { text: "Køb foder for 4.000 kr. hos Hestepleje og Foder A/S💰", effect: -4000 },
  { text: "💰i underskud", effect: -5000 },
  { text: "Affaldshåndtering hos Hestepærer Affald A/S💰", effect: -3000 },
  { text: "Handelsplads. Betal 3.000 kr. til Hesteargenturet A/S💰", effect: -3000 },
  { text: "Hestetræning. Betal 5.000 til Trænertjenesten A/S💰", effect: -5000 },
  { text: "💰i lotterigevinst", effect: 10000 }
];

const prizeStructure = [
    { first: 40000, second: 30000, third: 20000, forth: 15000 },
    { first: 50000, second: 40000, third: 25000, forth: 20000 },
    { first: 70000, second: 55000, third: 35000, forth: 25000 },
    { first: 75000, second: 60000, third: 45000, forth: 35000 },
    { first: 70000, second: 55000, third: 30000, forth: 25000 },
    { first: 90000, second: 70000, third: 50000, forth: 35000 },
    { first: 60000, second: 50000, third: 40000, forth: 30000 },
    { first: 80000, second: 60000, third: 45000, forth: 30000 },
    { first: 60000, second: 40000, third: 20000, forth: 15000 },
    { first: 100000, second: 80000, third: 50000, forth: 45000 },
];
const raceProgram = [
  {
    name: "Løb 1",
    description: "🐴 Første løb er kun for 2-åringer og alle har automatisk fået tildelt en 2-åring, så alle kan være med😉.",
    condition: horse => horse.age === 2,
    prizes: prizeStructure[0],
  },
  {
    name: "Løb 2",
    description: "💐  Forårsløb for alle heste. Har du kontanter kan du købe endnu en hest, så er du klar til de næste løb.",
    condition: horse => true,
    prizes: prizeStructure[1],
  },
  {
    name: "Løb 3",
    description: "⚠️ Dette løb er kun for 3-åringer. Ejer du ikke en 3-åring må du på hestemarkedet og købe en.",
    condition: horse => horse.age === 3,
    prizes: prizeStructure[2],
  },
  {
    name: "Løb 4",
    description: "🕧 Kun for heste der ikke tidligere har vundet. Har dine heste vundet må du købe en anden for at kunne deltage.",
    condition: horse => horse.wins === 0,
    prizes: prizeStructure[3],
  },
  {
    name: "Løb 5",
    description: "⚠️ Dette løb er kun for 4-åringer. Ejer du ikke en 4-åring kan du købe på hestemarkedet.",
    condition: horse => horse.age === 4,
    prizes: prizeStructure[4],
  },
  {
  name: "Løb 6",
  description: "💫 For alle heste. Heste der har vundet et løb står over i første og anden runde.",
  condition: (horse, round) => round > 2 || horse.wins === 0,
  prizes: prizeStructure[5],
},
  {
    name: "Løb 7",
    description: "⏱ ️Sprinterløb for alle heste. Et kort løb, hvor målstregen er flyttet til felt 52. Fuld fart fra start....",
    condition: horse => true,
    prizes: prizeStructure[6],
  },
  {
    name: "Løb 8",
    description: "🏆 GRAND PRIX for 4-åringer eller yngre heste, der har mindst 1 sejr 🐴.",
    condition: horse => (horse.age === 4 || horse.wins > 0) && horse.age <= 4,
    prizes: prizeStructure[7],
  },
  {
    name: "Løb 9",
    description: "💫 For heste der ikke har vundet. Det er nu du skal have en sejr i hus, så du kan deltage i finalen - DERBYET.",
    condition: horse => horse.wins === 0,
    prizes: prizeStructure[8],
  },
  {
    name: "Løb 10",
    description: "🎉 DERBY for 5-åringer - eller yngre heste med mindst 1 sejr.",
    condition: horse => horse.age === 5 || (horse.age < 5 && horse.wins > 0),
    prizes: prizeStructure[9],
  }
];
const galopFields = [2, 10, 18, 24, 29, 36, 45, 54, 60, 66];
const chanceFields = [4, 12, 20, 33, 38, 47, 56, 64];

const DerbyLite = () => {
  useEffect(() => {
  document.body.style.backgroundColor = "#F7F3AC"; // Lys gul baggrund
  return () => {
    document.body.style.backgroundColor = ""; // Nulstil når komponenten unmountes
  };
}, []);

const saveGame = () => {
  try {
    const saveState = {
      // Spillerdata
      players,
      aiPlayers,
      numAIs,
      playerName,
      numPlayers,
      playerStats,
      playerLoans,
      playerHorses,
      playerColors,

      // Indsatser
      playerBets,
      playerExtraBets,
      selectedBets,
      selectedRaceHorse,

      // Løbsdag / sæson
      currentRace,
      currentRaceIndex,
      currentRound,
      raceCount,
      raceWinner,
      winningMessage,
      betWinnersMessage,
      horseWins,
      seasonLength,
      seasonHistory,
      seasonResults,
      season: JSON.parse(localStorage.getItem("derbySeason") || "[]"),
      shuffledHorsesByAge,
      selectedAge,
      shownRaces,
      totalRaces,
      firstPlayerIndex,

      // Heste & marked
      trackLength,
      activeHorses,
      horseBasePrice,
      horseMarketMessage,
      loanSelections,
      bonusGiven,

      // Forsikring, økonomi, bank
      insuredHorses,
      insuredPlayersThisRace,
      bankBalance,
      bankLog,
      investmentMessage,
      selectedInvestor,
      finalInterestPaid,
      interestAppliedRace,

      // Selskaber & investeringer
      companies,
      obligations,
      totoShares,
      totoShareValues,
      andelsBank,
      andelsBankShareValues,
      andelsBankCarryover,

      // Toto
      totoSyndicate,
      totoPayoutGiven,
      raceOdds,

      // UI / tilstande der styrer spillet
      gameStarted,
      gameOver,
      isRacePaused,
      raceStarted,
      showRaceView,
      showBetForm,
      showRaceProgram,
      showProgram,
      showHelp,
      showHorseMarket,
      showPrizesBox,
      showCompanyDoc,
      showFinancialDoc,
      showSeasonBox,
      showWelcome,
      showTotoSharePopup,
      showTotoPayoutPopup,
      showHaltPopup,
      RaceInfoShown,

      // Chancekort, galop, hændelser
      gallopMessages,
      chanceMessages,
      fadeOutChance,
      pendingGalopCards,
      haltOccurred,
      haltAlreadyThisRace,
      kriseUsedThisRace,
      fremgangUsedThisRace,
      staldtipsMessages,

      // Farver
      horseColors,
    };

    localStorage.setItem("derbySave", JSON.stringify(saveState));
    alert("💾 Spillet er gemt!");
  } catch (err) {
    console.error("Fejl da spillet skulle gemmes:", err);
    alert("❗ Der opstod en fejl da spillet skulle gemmes.");
  }
};

// 🔁 HENT SPIL
const loadGame = () => {
  try {
    const saved = localStorage.getItem("derbySave");
    if (!saved) {
      alert("❗ Ingen gemt spiltilstand fundet.");
      return;
    }

    const S = JSON.parse(saved);

    // Spillerdata
    setPlayers(S.players || []);
    setAiPlayers(S.aiPlayers || []);
    setNumAIs(S.numAIs || 0);
    setPlayerName(S.playerName || "");
    setNumPlayers(S.numPlayers || 0);
    setPlayerStats(S.playerStats || {});
    setPlayerLoans(S.playerLoans || {});
    setPlayerHorses(S.playerHorses || {});
    setPlayerColors(S.playerColors || {});

    // Indsatser
    setPlayerBets(S.playerBets || {});
    setPlayerExtraBets(S.playerExtraBets || {});
    setSelectedBets(S.selectedBets || {});
    setSelectedRaceHorse(S.selectedRaceHorse || {});

    // Løbsdag / sæson
    setCurrentRace(S.currentRace || 1);
    setCurrentRaceIndex(S.currentRaceIndex || 0);
    setCurrentRound(S.currentRound || 0);
    setRaceCount(S.raceCount || 0);
    setRaceWinner(S.raceWinner || null);
    setWinningMessage(S.winningMessage || "");
    setBetWinnersMessage(S.betWinnersMessage || "");
    setHorseWins(S.horseWins || {});
    setSeasonLength(S.seasonLength || 10);
    setSeasonHistory(S.seasonHistory || []);
    setSeasonResults(S.seasonResults || []);
    setShuffledHorsesByAge(S.shuffledHorsesByAge || {});
    setSelectedAge(S.selectedAge || "3");
    setShownRaces(S.shownRaces || []);
    setTotalRaces(S.totalRaces || 10);
    setFirstPlayerIndex(S.firstPlayerIndex || 0);

    // Heste & marked
    setTrackLength(S.trackLength || 75);
    setActiveHorses(S.activeHorses || {});
    setHorseBasePrice(S.horseBasePrice || 0);
    setHorseMarketMessage(S.horseMarketMessage || "");
    setLoanSelections(S.loanSelections || {});
    setBonusGiven(S.bonusGiven || {});

    // Bank, forsikring, økonomi
    setInsuredHorses(S.insuredHorses || {});
    setInsuredPlayersThisRace(S.insuredPlayersThisRace || []);
    setInsuranceMessages([]);
    setBankBalance(S.bankBalance || 0);
    setBankLog(S.bankLog || []);
    setBankMessages([]);
    setLoanMessages([]);
    setLoadedFromSave(true);
    setInvestmentMessage(S.investmentMessage || "");
    setSelectedInvestor(S.selectedInvestor || null);
    setFinalInterestPaid(S.finalInterestPaid || false);
    setInterestAppliedRace(S.interestAppliedRace || false);

    // Selskaber og investeringer
    setCompanies(S.companies || {});
    setObligations(S.obligations || {});
    setTotoShares(S.totoShares || { total: 10, owners: {} });
    setTotoShareValues(S.totoShareValues || {});
    setAndelsBank(S.andelsBank || { total: 6, price: 50000, owners: {}, boughtThisRace: {}, lotteryPlayer: null });
    setAndelsBankShareValues(S.andelsBankShareValues || {});
    setAndelsBankCarryover(S.andelsBankCarryover || 0);
    setTotoSyndicate(S.totoSyndicate || {});
    setTotoPayoutGiven(S.totoPayoutGiven || false);
    setRaceOdds(S.raceOdds || {});

    // UI-styring
    setGameStarted(S.gameStarted || false);
    setGameOver(S.gameOver || false);
    setIsRacePaused(S.isRacePaused || false);
    setRaceStarted(S.raceStarted || false);
    setShowRaceView(S.showRaceView || false);
    setShowBetForm(S.showBetForm || false);
    setShowRaceProgram(S.showRaceProgram || false);
    setShowProgram(S.showProgram || false);
    setShowHelp(S.showHelp || false);
    setShowHorseMarket(S.showHorseMarket || false);
    setShowPrizesBox(S.showPrizesBox || false);
    setShowCompanyDoc(S.showCompanyDoc || null);
    setShowFinancialDoc(S.showFinancialDoc || null);
    setShowSeasonBox(S.showSeasonBox || false);
    setShowWelcome(S.showWelcome || false);
    setShowTotoSharePopup(S.showTotoSharePopup || false);
    setShowTotoPayoutPopup(S.showTotoPayoutPopup || false);
    setShowHaltPopup(S.showHaltPopup || null);
    setRaceInfoShown(S.RaceInfoShown || false);

    // Hændelser
    setGallopMessages(S.gallopMessages || []);
    setChanceMessages(S.chanceMessages || []);
    setFadeOutChance(S.fadeOutChance || false);
    setPendingGalopCards(S.pendingGalopCards || []);
    setHaltOccurred(S.haltOccurred || false);
    setHaltAlreadyThisRace(S.haltAlreadyThisRace || false);
    setKriseUsedThisRace(S.kriseUsedThisRace || false);
    setFremgangUsedThisRace(S.fremgangUsedThisRace || false);
    setStaldtipsMessages(S.staldtipsMessages || []);

    // Farver
    setHorseColors(S.horseColors || {});

    alert("📂 Spillet er indlæst!");
  } catch (err) {
    console.error("Fejl ved indlæsning:", err);
    alert("❗ Kunne ikke indlæse spillet.");
  }
};
  const [trackLength, setTrackLength] = useState(75); // default 75 felter
  const [firstPlayerIndex, setFirstPlayerIndex] = useState(0);
  const [players, setPlayers] = useState([]);
  const [playerStats, setPlayerStats] = useState({});
  const [playerHorses, setPlayerHorses] = useState({});
  const [playerBets, setPlayerBets] = useState({}); // Normal totalisator-indsats
  const [playerExtraBets, setPlayerExtraBets] = useState({}); // Ekstra indsats fra chancekort
  const [currentRound, setCurrentRound] = useState(0);
  const [raceWinner, setRaceWinner] = useState(null);
  const [winningMessage, setWinningMessage] = useState(""); // Vinderbesked for løbet
  const [betWinnersMessage, setBetWinnersMessage] = useState(""); // Besked for totalisatorgevinst(er)
  const [gameStarted, setGameStarted] = useState(false);
  const [raceStarted, setRaceStarted] = useState(false);
  const [kriseUsedThisRace, setKriseUsedThisRace] = useState(false);
  const [fremgangUsedThisRace, setFremgangUsedThisRace] = useState(false);
  const [gallopMessages, setGallopMessages] = useState([]);
  const [chanceMessages, setChanceMessages] = useState([]);
  const [fadeOutChance, setFadeOutChance] = useState(false);
  const [currentRace, setCurrentRace] = useState(1);
  const [currentRaceIndex, setCurrentRaceIndex] = useState(0);
  const [gameOver, setGameOver] = useState(false);
  const [pendingGalopCards, setPendingGalopCards] = useState([]);
  const [haltAlreadyThisRace, setHaltAlreadyThisRace] = useState(false);
  const haltLockRef = React.useRef(false);
  const [playerName, setPlayerName] = useState("");
  const [playerLoans, setPlayerLoans] = useState({});
  const [bankMessages, setBankMessages] = useState([]);
  const [horseMarketMessage, setHorseMarketMessage] = useState("");
  const [selectedInvestor, setSelectedInvestor] = useState("");
  const [investmentMessage, setInvestmentMessage] = useState("");
  const [numPlayers, setNumPlayers] = useState(4);
  const [totalRaces, setTotalRaces] = useState(10); // standard kan være 8, eller hvad du foretrækker
  const [showBetForm, setShowBetForm] = useState(false);

  const [selectedBets, setSelectedBets] = useState({});
  const playerCount = players.length;
  const trackHeight = Math.max(140, 49 * playerCount + 20);
  const startFrameHeight = Math.max(430, 45 * playerCount + 20); 
  const [finalInterestPaid, setFinalInterestPaid] = useState(false);
  const [showWelcome, setShowWelcome] = useState(true);
  const [raceCount, setRaceCount] = useState(0);
  const [showRaceProgram, setShowRaceProgram] = useState(false);
  const [showProgram, setShowProgram] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [showHorseMarket, setShowHorseMarket] = useState(false);
  const currentPlayer = players[0];
  const [RaceInfoShown, setRaceInfoShown] = useState(false);
  const [selectedAge, setSelectedAge] = useState(2);
  const allOwnedHorses = Object.values(playerHorses).flat().map(horse => horse.name);
  const [selectedRaceHorse, setSelectedRaceHorse] = useState({});
  const [horseWins, setHorseWins] = useState({});
  const [showRaceView, setShowRaceView] = useState(false);
  const [insuredHorses, setInsuredHorses] = useState({});
  const [haltOccurred, setHaltOccurred] = useState(false);
  const [horseBasePrice, setHorseBasePrice] = useState({});
  const [showTotoPayoutPopup, setShowTotoPayoutPopup] = useState(null);
  const [loanSelections, setLoanSelections] = useState({});
  const maxPrizeIndex = prizeStructure.length - 1;
  const derivedRaceIndex = currentRace - 1;
  const [isRacePaused, setIsRacePaused] = useState(false);
  const [seasonLength, setSeasonLength] = useState(() => {const saved = localStorage.getItem("seasonLength");
  return saved ? parseInt(saved) : 5; // fallback til 5 løbsdage
});
  const [bonusGiven, setBonusGiven] = useState({});
  const [shownRaces, setShownRaces] = useState([]);
  const [horseColors, setHorseColors] = useState({});
  const [hoverImage, setHoverImage] = useState(null);
  const [playerColors, setPlayerColors] = useState({});
  const [raceOdds, setRaceOdds] = useState(20); // standardodds (ændres efter løbet)
  const [totoPayoutGiven, setTotoPayoutGiven] = useState(false);
  const [showPrizesBox, setShowPrizesBox] = useState(false);
  const [showHaltPopup, setShowHaltPopup] = useState(null);
  const [seasonHistory, setSeasonHistory] = useState([]);
  const [seasonResults, setSeasonResults] = useState([]);
  const [showCompanyDoc, setShowCompanyDoc] = useState(null);
  const [showFinancialDoc, setShowFinancialDoc] = useState(null);
  const [showSeasonBox, setShowSeasonBox] = useState(false);
  const [activeHorses, setActiveHorses] = useState({});
  const [numAIs, setNumAIs] = useState(5); // default 5 AI spillere
  const [aiPlayers, setAiPlayers] = useState([]);
  const [loanMessages, setLoanMessages] = useState([]);
  const [insuredPlayersThisRace, setInsuredPlayersThisRace] = useState({});
  const [insuranceMessages, setInsuranceMessages] = useState([]);
  const [interestAppliedRace, setInterestAppliedRace] = useState(null);
  const [bankBalance, setBankBalance] = useState(0);
  const [staldtipsMessages, setStaldtipsMessages] = useState([]);
  const [loadedFromSave, setLoadedFromSave] = useState(false);
  const [bankLog, setBankLog] = useState([]);
  const [user, setUser] = useState(null);
const [authMode, setAuthMode] = useState("login"); // "login" eller "register"

  const kr = (value) => Math.round(value).toLocaleString("da-DK");
  const [totoShares, setTotoShares] = useState({total: 10,   // samlet antal aktier
  owners: {} 
  });
  
  // 💰 Aktieværdier (forøgelse ved afkast)
const [totoShareValues, setTotoShareValues] = useState({});
// struktur: { Allan: samlet værdi af aktier, AI1: ... }
const [showTotoSharePopup, setShowTotoSharePopup] = useState(null);

// 🏦 Andelsbanken – separat fra Totosyndikatet
// 6 andele pr. løbsdag. Ejerskab og køb pr. løb nulstilles
// ved næste løbsdag, mens bankens restsaldo føres videre.
const [andelsBank, setAndelsBank] = useState({
  total: 6,
  price: 50000,
  owners: {},
  boughtThisRace: {},
  lotteryPlayer: null
});
const [andelsBankShareValues, setAndelsBankShareValues] = useState({});
const [andelsBankCarryover, setAndelsBankCarryover] = useState(0);

  // --- Lånerenter (samme fade-logic men tydelig hensigt)
const addLoanInterestMessage = (text, timeout = 12000) => {
  const id = Date.now() + Math.random();
  const newMsg = { id, text, fading: false };
  setLoanMessages(prev => [...prev, newMsg]);

  // Fade
  setTimeout(() => {
    setLoanMessages(prev =>
      prev.map(msg => (msg.id === id ? { ...msg, fading: true } : msg))
    );
  }, Math.max(1000, timeout - 2000));

  // Fjern helt
  setTimeout(() => {
    setLoanMessages(prev => prev.filter(msg => msg.id !== id));
  }, timeout);
};

  useEffect(() => {
  if (showBetForm && !raceStarted) {
    setTimeout(() => {
      runAIActions();
    }, 10);
  }
}, [showBetForm, raceStarted]);
useEffect(() => {
    setCurrentRaceIndex(currentRace - 1);
  }, [currentRace]);
  
  useEffect(() => {
  const saved = JSON.parse(localStorage.getItem("derbySeason")) || [];

  if (saved.length > 0) {
    setSeasonHistory(saved);

    // Beregn summeret sæsonstilling
    const samlet = {};

saved.forEach(spil => {
  spil.forEach(entry => {
    const name = entry.name;

    if (!samlet[name]) {
      samlet[name] = {
        total: 0,
        spil: 0,
        netCash: 0,
        companyValue: 0,
        secureInvestmentValue: 0,
        obligationValue: 0,
        horsesValue: 0,
        totoValue: 0,
        andelsBankValue: 0
      };
    }

    samlet[name].total += Math.round(entry.seasonDayValue ?? 0);
    samlet[name].spil += 1;

    samlet[name].netCash = Math.round(
      entry.netCash ?? ((entry.cash ?? 0) - (entry.debt ?? 0))
    );

    samlet[name].companyValue =
      Math.round(entry.companyValue ?? 0);

    samlet[name].secureInvestmentValue =
      Math.round(entry.secureInvestmentValue ?? 0);

    samlet[name].obligationValue =
      Math.round(entry.obligationValue ?? 0);
	  
      samlet[name].horsesValue +=
        Math.round(entry.horsesValue ?? 0);

      samlet[name].totoValue +=
        Math.round(
          entry.totoValue ??
          entry.shareValue ??
          0
        );

      samlet[name].andelsBankValue +=
        Math.round(entry.andelsBankValue ?? 0);
  });
});

// På sidste løbsdag lægges de værdier, som er videreført gennem sæsonen,
// til den samlede sæsonscore. De skal kun med én gang – ved sæsonens slutning.
if (saved.length >= seasonLength) {
  Object.values(samlet).forEach(data => {
    data.total += Math.round(data.netCash || 0);
    data.total += Math.round(data.companyValue || 0);
    data.total += Math.round(data.secureInvestmentValue || 0);
    data.total += Math.round(data.obligationValue || 0);
  });
}

const sorteret = Object.entries(samlet)
  .map(([navn, data]) => ({
    navn,
    ...data,
    visningsTotal:
      saved.length >= seasonLength
        ? data.total
        : data.total +
          (data.netCash || 0) +
          (data.companyValue || 0) +
          (data.secureInvestmentValue || 0) +
          (data.obligationValue || 0)
  }))
  .sort((a, b) => b.visningsTotal - a.visningsTotal);

setSeasonResults(sorteret);
  }
}, []);

  // --- Galop-beskeder (under løb)
const addGallopMessages = (text, timeout = 6000) => {
  const id = Date.now() + Math.random();
  const newMsg = { id, text, fading: false };
  setGallopMessages(prev => [...prev, newMsg]);

  setTimeout(() => {
    setGallopMessages(prev => prev.map(msg => (msg.id === id ? { ...msg, fading: true } : msg)));
  }, Math.max(1000, timeout - 2000));

  setTimeout(() => {
    setGallopMessages(prev => prev.filter(msg => msg.id !== id));
  }, timeout);
};
  
  // --- Bank-beskeder (under løb)
const addBankMessages = (text, timeout = 6000) => {
  const id = Date.now() + Math.random();
  const newMsg = { id, text, fading: false };
  setBankMessages(prev => [...prev, newMsg]);

  setTimeout(() => {
    setBankMessages(prev => prev.map(msg => (msg.id === id ? { ...msg, fading: true } : msg)));
  }, Math.max(1000, timeout - 2000));

  setTimeout(() => {
    setBankMessages(prev => prev.filter(msg => msg.id !== id));
  }, timeout);
};

// --- Forsikrings-beskeder (før løb)
const addInsuranceMessage = (text, timeout = 5000) => {
  const id = Date.now() + Math.random();
  const newMsg = { id, text, fading: false };
  setInsuranceMessages(prev => [...prev, newMsg]);

  setTimeout(() => {
    setInsuranceMessages(prev => prev.map(msg => (msg.id === id ? { ...msg, fading: true } : msg)));
  }, Math.max(1000, timeout - 2000));

  setTimeout(() => {
    setInsuranceMessages(prev => prev.filter(msg => msg.id !== id));
  }, timeout);
};

// 🎲 Totosyndikatet – saldo og faste væddemål
const [totoSyndicate, setTotoSyndicate] = useState({
  balance: 0,
  history: [],
  betsByRace: {
    1: { colors: ["⚪", "🔴"], amount: 5000 },
    2: { colors: ["🔵", "🟡"], amount: 5000 },
    3: { colors: ["🔵", "⚪"], amount: 5000 },
    4: { colors: ["🔴", "🟡"], amount: 5000 },
    5: { colors: ["⚪", "🔵"], amount: 8000 },
    6: { colors: ["🔴", "🟡"], amount: 8000 },
    7: { colors: ["⚪", "🟡"], amount: 8000 },
    8: { colors: ["🔵", "🔴"], amount: 8000 },
    9: { colors: ["🔴", "🟡"], amount: 8000 },
    10: { colors: ["⚪", "🔵"], amount: 10000 }
  }
});

const horseColorGifMap = {
  "🔴": "horsered.gif",
  "🟡": "horseyellow.gif",
  "🔵": "horseblue.gif",
  "⚪": "horsewhite.gif"
};

const horseStartPrice = {
  2: 20000,
  3: 35000,
  4: 50000,
  5: 75000
};
const endRace = () => {
  setPlayerHorses(prev => {
    const updatedHorses = { ...prev };
    Object.keys(updatedHorses).forEach(player => {
      updatedHorses[player] = updatedHorses[player].map(horse => ({
        ...horse,
        position: 0 // Nulstil position efter løb
      }));
    });
    return updatedHorses;
  });

  setActiveHorses({}); // Fjern alle heste fra aktiv deltagelse
};
  const globalEligibleHorses = players.flatMap(player =>
  (playerHorses[player] || []).filter(horse => {
    // 🏇 Løb 6: Alle heste er gyldige til løbet.
    // Heste med 1 eller flere sejre skal kun stå over
    // i første og anden runde – de må ikke blokere starten.
    if (derivedRaceIndex === 5) {
      return true;
    }
    // Alle andre løb bruger deres normale betingelser.
    return raceProgram[derivedRaceIndex].condition(horse, 1);
  })
);
  const selectRaceHorse = (player, horseName) => {
  setActiveHorses(prev => ({
    ...prev,
    [player]: horseName // Spilleren vælger aktiv hest til løbet
  }));
};
let firstPrize = prizeStructure[derivedRaceIndex].first;
let secondPrize = prizeStructure[derivedRaceIndex].second;
let thirdPrize = prizeStructure[derivedRaceIndex].third;
let forthPrize = prizeStructure[derivedRaceIndex].forth;
const currentPrizes = prizeStructure[derivedRaceIndex];

const nextPrizes =
  prizeStructure[derivedRaceIndex + 1] || prizeStructure[derivedRaceIndex];

	useEffect(() => {
  // Hvis det er løb 7 (index 6), sæt til 52, ellers 75
  if (derivedRaceIndex === 6) {
    setTrackLength(52);
  } else {
    setTrackLength(75);
  }
}, [derivedRaceIndex]);

useEffect(() => {
  shuffleHorseNames(); // kald den én gang når komponenten loader
}, []);
useEffect(() => {
  if (derivedRaceIndex === 2 && !shownRaces.includes(2)) {
    setRaceInfoShown(true);
    setShownRaces(prev => [...prev, 2]); // markér løb 3 som vist
  }
}, [derivedRaceIndex, shownRaces]);

useEffect(() => {
  if (derivedRaceIndex === 4 && !shownRaces.includes(4)) {
    setRaceInfoShown(true);
    setShownRaces(prev => [...prev, 4]); // markér løb 5 som vist
  }
}, [derivedRaceIndex, shownRaces]);

useEffect(() => {
  const shouldRun =
    raceStarted &&
    showRaceView &&
    !showHaltPopup &&
    !showTotoSharePopup &&  // <--- tilføjet, så totopopup også pauser løbet
    !raceWinner;

  if (!shouldRun) {
    setIsRacePaused(false);
    return;
  }
  setIsRacePaused(true);

  const interval = setInterval(() => {
    nextRound();
  }, 1100);

  return () => clearInterval(interval);
}, [raceStarted, showRaceView, showHaltPopup, showTotoSharePopup, raceWinner, currentRound]); // ✅ tilføjet

// Køb hest – opdateret til at tage valgfrit navn på hest
const buyHorse = (player, targetAge, horseName = null) => {
  const ageKey = targetAge ? parseInt(targetAge) : parseInt(selectedAge);

  if (!shuffledHorsesByAge[ageKey]) {
setHorseMarketMessage(`${player} har valgt en ugyldig årgang - ${selectedHorse} (${ageKey} år).`);
setTimeout(() => setHorseMarketMessage(""), 5000);
return;
  }

  // Tjek om spilleren allerede har en hest i denne årgang
  const existingHorse = (playerHorses[player] || []).find(h => h.age === ageKey);
  if (existingHorse) {
setHorseMarketMessage(`${player} ejer allerede en ${ageKey}-årig hest (${existingHorse.name}).`);
setTimeout(() => setHorseMarketMessage(""), 5000);
    return;
  }

  const allOwnedHorses = Object.values(playerHorses).flat().map(h => h.name);
  const availableHorses = shuffledHorsesByAge[ageKey].names.filter(name => !allOwnedHorses.includes(name));

  if (availableHorses.length === 0) {
setHorseMarketMessage(`Ingen ledige heste i denne årgang - ${selectedHorse} (${ageKey} år).`);
setTimeout(() => setHorseMarketMessage(""), 5000);
    return;
  }

  const selectedHorse = horseName && availableHorses.includes(horseName)
    ? horseName
    : availableHorses[0];

  const previousWins = horseWins[selectedHorse] || 0;
  const basePrice = horseBasePrice[selectedHorse] || shuffledHorsesByAge[ageKey].price;
  const adjustedPrice = previousWins > 0 ? Math.floor(basePrice * (1.25 ** previousWins)) : basePrice;

  if (playerStats[player].money < adjustedPrice) {
setHorseMarketMessage(`${player} har ikke råd til ${selectedHorse} (${ageKey} år).`);
setTimeout(() => setHorseMarketMessage(""), 5000);
    return;
  }

  const newHorse = {
    name: selectedHorse,
    age: ageKey,
    wins: previousWins,
    price: adjustedPrice,
    position: 0
  };

  setPlayerHorses(prev => ({
    ...prev,
    [player]: [...(prev[player] || []), newHorse]
  }));

  setPlayerStats(prev => ({
    ...prev,
    [player]: { ...prev[player], money: prev[player].money - adjustedPrice }
  }));

  if (!horseBasePrice[selectedHorse]) {
    setHorseBasePrice(prev => ({
      ...prev,
      [selectedHorse]: basePrice
    }));
  }

setHorseMarketMessage(`${player} har købt ${selectedHorse} (${ageKey} år) for ${adjustedPrice.toLocaleString()} kr.`);
};
setTimeout(() => setHorseMarketMessage(""), 5000);
const sellHorse = (player, horse) => {
  // Beregn hestens aktuelle værdi baseret på grundpris og sejre
  const basePrice = shuffledHorsesByAge[horse.age]?.price || horse.price;
  const wins = horse.wins || 0;
  const sellPrice = Math.round(basePrice * Math.pow(1.25, wins));

  setHorseWins(prevWins => ({
    ...prevWins,
    [horse.name]: wins
  }));

  setPlayerHorses(prev => ({
    ...prev,
    [player]: prev[player].filter(h => h.name !== horse.name)
  }));

  setPlayerStats(prev => ({
    ...prev,
    [player]: {
      ...prev[player],
      money: (prev[player]?.money || 0) + sellPrice
    }
  }));

setHorseMarketMessage(`${player} har solgt ${horse.name} for ${sellPrice.toLocaleString()} kr.`);
};
setTimeout(() => setHorseMarketMessage(""), 5000);
const HorseMarket = ({ player, playerStats, playerHorses, setPlayerHorses, setPlayerStats, closePopup }) => {
  const [selectedAge, setSelectedAge] = useState(2);
  };
  const [shuffledHorsesByAge, setShuffledHorsesByAge] = useState({});

const shuffleArray = (arr) => {
  return [...arr].sort(() => Math.random() - 0.5);
};

const shuffleHorseNames = () => {
  const horses = {
    2: { names: ["Rigoletto", "Caruso", "Figaro", "Patrix", "Isolde", "Tristan", "Stargate"], price: 20000 },
    3: { names: ["Rusch", "Orkan", "Comet", "Vitesse", "Nicodemus", "Rapid", "AnnaBella"], price: 35000 },
    4: { names: ["SweetSue", "RoseRoom", "Solitude", "Avalon", "Whispering", "Sunrise", "Pegasus"], price: 50000 },
    5: { names: ["Castor", "Aldebaran", "Rigel", "Pollux", "Cassiopeja", "Mustang", "Lotus"], price: 75000 }
  };

  const shuffled = {};
  Object.entries(horses).forEach(([age, data]) => {
    shuffled[age] = {
      ...data,
      names: shuffleArray(data.names)
    };
  });

  setShuffledHorsesByAge(shuffled);
};

  const investmentForPlayer = (player) => {
    const rawInvestment = Object.values(companies)
      .filter(company => company.owner === player)
      .reduce((acc, company) => acc + company.price, 0);
    return Math.round(rawInvestment);
  };
  
  useEffect(() => {
  if (!players || players.length === 0) return;
  const jockeyColors = ["🔴", "🟡", "🔵", "⚪"];
  const newPlayerColors = {};
  const newHorseColors = {};

  players.forEach(player => {
    newPlayerColors[player] = jockeyColors[Math.floor(Math.random() * jockeyColors.length)];
  });

  Object.values(playerHorses || {}).forEach(horsesList => {
    horsesList.forEach(horse => {
      newHorseColors[horse.name] = jockeyColors[Math.floor(Math.random() * jockeyColors.length)];
    });
  });

  setPlayerColors(newPlayerColors);
  setHorseColors(newHorseColors);

  if (typeof addBankMessages === "function") {
    addBankMessages("🎨 Nye jockeyfarver er blevet tildelt for dette løb!");
  }
}, [currentRace]); // 👈 Kør kun når løbsnummer ændrer sig
  
  useEffect(() => {
  const storedName = localStorage.getItem("playerName");
  if (storedName) {
    setPlayerName(storedName);
  }
}, []);
  
  useEffect(() => {
  if (!showHorseMarket) return;

  const player = showHorseMarket;
  const horses = playerHorses[player] || [];

  const updatedBonus = { ...bonusGiven };
  const updatedStats = { ...playerStats };

  const ages = new Set(horses.map(h => h.age));
  const has2to4 = ages.has(2) && ages.has(3) && ages.has(4);
  const hasAll = has2to4 && ages.has(5);

  if (has2to4 && !updatedBonus[player]?.trio) {
    updatedStats[player].money += 30000;
    updatedBonus[player] = { ...(updatedBonus[player] || {}), trio: true };
	updateBank(-30000, `Bonus for 3 forskellige årgange til ${player}`);
  }

  if (hasAll && !updatedBonus[player]?.fullSet) {
    updatedStats[player].money += 30000;
    updatedBonus[player] = { ...(updatedBonus[player] || {}), fullSet: true };
	updateBank(-30000, `Bonus for fuld stald til ${player}`);
  }

   setPlayerStats(updatedStats);
  setBonusGiven(updatedBonus);
}, [playerHorses, showHorseMarket]);
  
  const addPlayer = () => {
    const trimmedName = playerName.trim();
    if (!trimmedName) {
      alert("Indtast venligst et gyldigt navn.");
      return;
    }
    if (players.includes(trimmedName)) {
      alert("Denne spiller er allerede tilføjet.");
      return;
    }
    setPlayers(prevPlayers => [...prevPlayers, trimmedName]);
    setPlayerName("");
  };
  const raceHorseNames = players
  .map(player => playerHorses[player] && playerHorses[player][0]?.name)
  .filter(Boolean);
  
   const payInterestsAndDividends = () => {
  let newStats = { ...playerStats };

  Object.entries(companies).forEach(([companyName, company]) => {
  if (!company.owner) return;

  // 🚕 TAXI-afkast
  if (companyName.includes("BornTAXI")) {
    newStats[company.owner].money += company.fee;
    addInsuranceMessage(
      `🚕 ${company.owner} modtager ${company.fee.toLocaleString()} kr. i afkast fra ${companyName}.`
    );
  }

  // 🏨 Hotel-afkast
  if (companyName.includes("Hotel")) {
    newStats[company.owner].money += company.fee;
    addInsuranceMessage(
      `🏨 ${company.owner} modtager ${company.fee.toLocaleString()} kr. i afkast fra ${companyName}.`
    );
  }

  // 🚗 BronzeCar-afkast
  if (companyName.includes("BronzeCar")) {
    newStats[company.owner].money += company.fee;
    addInsuranceMessage(
      `🚗 ${company.owner} modtager ${company.fee.toLocaleString()} kr. i afkast fra ${companyName}.`
    );
  }
});

  setPlayerStats(newStats);
};
const payInsurancePremiums = (
  nextRaceIndex,        // hvilket løb vi er på vej ind i (1 = første løb)
  statsOverride = null, // optional: et stats-objekt (fx updatedStats)
  playersOverride = null, // optional: liste over spillere (fx allPlayers)
  companiesOverride = null // optional: companies-objekt
) => {
  // Brug overrides hvis de er leveret, ellers brug state
  let newStats = statsOverride ? { ...statsOverride } : { ...playerStats };
  const usePlayers = playersOverride || players;
  const useCompanies = companiesOverride || companies;

  // Hvis vi er på vej ind i løb 1 -> vis info om ingen forsikring
  if (nextRaceIndex === 1) {
    addInsuranceMessage(
      "❌ Ingen forsikringer i første løb. Ved halt hest sælges den for 5.000 kr.ℹ️"
    );
    setPlayerStats(newStats);
    // Ingen spillere forsikret i løb 1
    setInsuredPlayersThisRace({});
    return;
  }

  // Fra 2. løb og frem
const forsikringsEntry = Object.entries(useCompanies || {}).find(
  ([name]) => name.includes("Galopforsikring")
);
if (!forsikringsEntry) {
  setPlayerStats(newStats);
  setInsuredPlayersThisRace({});
  return;
}

const [forsikringNavn, info] = forsikringsEntry;
const forsikringEjer = info.owner;
let totalBetalte = 0;

// Ny map over hvem der har betalt denne runde
const paidThisRound = {};

usePlayers.forEach((player) => {
  if (!newStats[player]) {
    addInsuranceMessage(`⚠️ Internt: mangler stats for ${player}.`);
    paidThisRound[player] = false;
    return;
  }

  if (newStats[player].money >= 1500) {
    newStats[player].money -= 1500;
    totalBetalte += 1500;
    addInsuranceMessage(`💼 ${player} betaler 1.500 kr. i forsikringspræmie.`);
    paidThisRound[player] = true;
  } else {
    addInsuranceMessage(`⚠️ ${player} har ikke råd til forsikringspræmien.`);
    paidThisRound[player] = false;
  }
});

// 💰 Fordel indtægten — enten til ejer eller banken
if (totalBetalte > 0) {
  if (forsikringEjer) {
    // 📈 Ejer modtager præmier
    if (!newStats[forsikringEjer]) newStats[forsikringEjer] = { money: 0, wins: 0 };
    newStats[forsikringEjer].money += totalBetalte;

    addInsuranceMessage(
      `📄 ${forsikringEjer} modtager i alt ${totalBetalte.toLocaleString()} kr. i præmier fra ${forsikringNavn}.`
    );

    // Banken får ingen ændring – men vi kan stadig logge det som note
    updateBank(0, `Forsikringspræmier betalt til ${forsikringEjer} (${totalBetalte.toLocaleString()} kr.)`);

  } else {
    // 🏦 Banken ejer forsikringen → modtager pengene
    updateBank(+totalBetalte, `Forsikringspræmier fra ${forsikringNavn}`);

    addInsuranceMessage(
      `🏦 Banken modtager i alt ${totalBetalte.toLocaleString()} kr. i præmier fra ${forsikringNavn}.`
    );
  }
}
// Gem stats og hvem der er dækket
setPlayerStats(newStats);
setInsuredPlayersThisRace(paidThisRound);
};
  const bankRelatedActions = [
  "💰Krise",
  "i overskud💰",
  "i overskud fra hoppeaktionen💰",
  "i overskud fra følauktionen💰",
  "💰Fremgang",
  "i underskud💰",
  "i lotterigevinst💰"
];

// Funktion der kører AI-hændelser for hver AI-spiller
const runAIActions = () => {
  const nextCompanies         = { ...companies };
  const nextSelectedRaceHorse = { ...selectedRaceHorse };
  const nextSelectedBets      = { ...selectedBets };

  const nextPlayerStats = Object.fromEntries(
    Object.entries(playerStats).map(([player, stats]) => [
      player,
      { ...stats }
    ])
  );

  const nextPlayerHorses    = { ...playerHorses };
  const nextPlayerLoans     = { ...playerLoans };
  const nextPlayerExtraBets = { ...playerExtraBets };

  const racesLeft = totalRaces - currentRace;

  // --------------------------------------------------
  // LOKALE PULJER
  // --------------------------------------------------

  // Obligationer
  let remainingObligations = obligations?.total || 0;

  const nextObligationOwners = {
    ...(obligations?.owners || {})
  };

  // TOTO-aktier – egen pulje, helt separat fra Andelsbanken
  const totoSoldShares =
  Object.values(totoShares?.owners || {})
    .reduce((a, b) => a + b, 0);

let remainingTotoShares =
  (totoShares?.total || 10) -
  totoSoldShares;

const nextTotoShareOwners = {
  ...(totoShares?.owners || {})
};

  // ANDELSBANK – egen pulje og eget køb pr. løb
  const andelsBankSoldShares =
  Object.values(andelsBank?.owners || {})
    .reduce((a, b) => a + b, 0);

let remainingAndelsBankShares =
  (andelsBank?.total || 6) -
  andelsBankSoldShares;

const nextAndelsBankOwners = {
  ...(andelsBank?.owners || {})
};

  const nextAndelsBankBoughtThisRace = {
    ...(andelsBank?.boughtThisRace || {})
  };

  // --------------------------------------------------
  // HJÆLPEFUNKTIONER
  // --------------------------------------------------

  const aiMissingBonusAge = (player) => {
    const horses = nextPlayerHorses[player] || [];

    const ages = new Set(
      horses.map(h => h.age)
    );

    const has3 = ages.has(3);
    const has4 = ages.has(4);
    const has2 = ages.has(2);

    return !has2 && has3 && has4 ? 2 : null;
  };

  const isSpecialCompany = (name) => (
    name.includes("Hotel Hesteløkken") ||
    name.includes("BornTAXI") ||
    name.includes("Galopforsikring") ||
    name.includes("BronzeCar")
  );

  aiPlayers.forEach(player => {

    // --------------------------------------------------
    // STARTVÆRDIER
    // --------------------------------------------------

    let cash =
      nextPlayerStats[player]?.money || 0;

    let loan =
      nextPlayerLoans[player] || 0;

    let stable =
      nextPlayerHorses[player] || [];

    const normalBuffer =
      racesLeft <= 2 ? 30000 : 20000;

    const investmentBuffer =
      racesLeft <= 2 ? 30000 : 15000;

    // --------------------------------------------------
    // FUNKTION TIL AT GEMME CASH/LOAN
    // --------------------------------------------------

    const saveFinancialState = () => {
      nextPlayerStats[player].money = cash;
      nextPlayerLoans[player] = loan;
    };

    // ------------------Ok--------------------------------
    // 1) AI SKAL HAVE EN VALGBAR LØBSHEST
    // --------------------------------------------------

    // AI må kun eje én hest i hver årgang.
    const ownedAges = new Set(
      stable.map(h => Number(h.age))
    );

    // Heste som allerede ejes af nogen.
    const getOwnedNames = () =>
      Object.values(nextPlayerHorses)
        .flat()
        .map(h => h.name);


    // --------------------------------------------------
    // HJÆLPEFUNKTION:
    // FIND BEDSTE EGNEDE HEST I AI'ENS STALD
    // --------------------------------------------------

    const selectBestRaceHorse = (horses) => {

      let suitable =
        horses.filter(h =>
          raceProgram[derivedRaceIndex].condition(
            h,
            currentRound
          )
        );

      // Løb 9 er kun for heste uden sejre.
      if (currentRace === 9) {
        suitable =
          suitable.filter(
            h => (h.wins || 0) === 0
          );
      }

      if (suitable.length === 0) {
        return null;
      }

      // Løb 8:
      // 4-åring prioriteres.
      if (currentRace === 8) {

        const fourYearOld =
          suitable.find(
            h => Number(h.age) === 4
          );

        if (fourYearOld) {
          return fourYearOld;
        }
      }

      // Løb 10:
      // 5-åring prioriteres.
      if (currentRace === 10) {

        const fiveYearOld =
          suitable.find(
            h => Number(h.age) === 5
          );

        if (fiveYearOld) {
          return fiveYearOld;
        }
      }

      // Alle øvrige:
      // Ældste egnede hest først.
      // Ved samme alder vinder flest sejre.
      return [...suitable].sort(
        (a, b) =>
          Number(b.age || 0) -
            Number(a.age || 0) ||
          (b.wins || 0) -
            (a.wins || 0)
      )[0];
    };


    // --------------------------------------------------
    // FIND DEN HEST AI ALLEREDE EJER
    // --------------------------------------------------

    let existingRaceHorse =
      selectBestRaceHorse(stable);

    let chosen =
      existingRaceHorse;

    // --------------------------------------------------
    // LØB 9:
    // HVIS AI HAR FULD STALD, MEN INGEN HEST UDEN SEJR
    // SKAL AI SELV SÆLGE EN HEST OG KØBE EN NY.
    // --------------------------------------------------

    if (
      currentRace === 9 &&
      !chosen &&
      stable.length >= 4
    ) {

      const globallyOwnedNames =
        getOwnedNames();

      // Find en ledig 0-sejrs hest i en årgang,
      // som AI allerede ejer.
      //
      // Den årgang kan frigøres ved at sælge AI's
      // nuværende hest i samme årgang.
      const possibleReplacements =
        stable
          .map(oldHorse => {

            const age = Number(oldHorse.age);

            const availableReplacement =
              (shuffledHorsesByAge?.[age]?.names || [])
                .filter(name =>
                  !globallyOwnedNames.includes(name)
                )
                .map(name => ({
                  name,
                  age,
                  wins: horseWins[name] || 0,
                  price:
                    shuffledHorsesByAge[age]?.price || 0
                }))
                .filter(h => h.wins === 0)
                [0];

            if (!availableReplacement) {
              return null;
            }

            const basePrice =
              shuffledHorsesByAge[age]?.price ||
              oldHorse.price ||
              20000;

            const sellPrice =
              Math.round(
                basePrice *
                Math.pow(
                  1.25,
                  oldHorse.wins || 0
                )
              );

            return {
              oldHorse,
              replacement: availableReplacement,
              sellPrice
            };
          })
          .filter(Boolean)
          .sort(
            (a, b) =>
              a.sellPrice - b.sellPrice
          );

      if (possibleReplacements.length > 0) {

        const replacementPlan =
          possibleReplacements[0];

        const horseToSell =
          replacementPlan.oldHorse;

        const sellPrice =
          replacementPlan.sellPrice;

        const replacementHorse =
          replacementPlan.replacement;

        // -----------------------------------------------
        // SÆLG DEN GAMLE HEST
        // -----------------------------------------------

        stable =
          stable.filter(
            h => h.name !== horseToSell.name
          );

        nextPlayerHorses[player] =
          stable;

        cash += sellPrice;

        nextPlayerStats[player].money =
          cash;

        // Den solgte årgang er nu fri.
        ownedAges.delete(
          Number(horseToSell.age)
        );

        updateBank(
          -sellPrice,
          `Banken køber hesten ${horseToSell.name} fra ${player}`
        );

        addBankMessages(
          `🤖 ${player} solgte ${horseToSell.name} for ${sellPrice.toLocaleString()} kr. for at kunne købe en gyldig hest til Løb 9.`
        );

        // -----------------------------------------------
        // VÆLG DEN NYE HEST
        // -----------------------------------------------

        chosen = {
          ...replacementHorse,
          position: 0
        };

        addBankMessages(
          `🤖 ${player} skal købe ${chosen.name}, som har 0 sejre, til Løb 9.`
        );
      }
    }


    // --------------------------------------------------
    // 2) HVIS AI IKKE HAR EN HEST:
    // FIND EN HEST PÅ MARKEDET
    // --------------------------------------------------

    if (!chosen) {

      const globallyOwnedNames =
        getOwnedNames();

      const availableMarketHorses =
        Object.entries(
          shuffledHorsesByAge || {}
        )
        .flatMap(([ageKey, data]) => {

          const age =
            Number(ageKey);

          // AI må ikke købe endnu en hest
          // i en årgang, som den allerede ejer.
          if (ownedAges.has(age)) {
            return [];
          }

          return (data?.names || [])
            .filter(name =>
              !globallyOwnedNames.includes(name)
            )
            .map(name => {

              const wins =
                horseWins[name] || 0;

              const base =
                data.price;

              const price =
                wins > 0
                  ? Math.floor(
                      base *
                      Math.pow(1.25, wins)
                    )
                  : base;

              return {
                name,
                age,
                wins,
                price,
                position: 0
              };
            });
        });


      // ------------------------------------------------
      // FILTRÉR PÅ DET AKTUELLE LØBS BETINGELSER
      // ------------------------------------------------

      let validMarketHorses =
        availableMarketHorses.filter(h =>
          raceProgram[
            derivedRaceIndex
          ].condition(
            {
              age: h.age,
              wins: h.wins
            },
            currentRound
          )
        );


      // Løb 9:
      // Kun heste uden sejre.
      if (currentRace === 9) {

        validMarketHorses =
          validMarketHorses.filter(
            h => (h.wins || 0) === 0
          );
      }


      // ------------------------------------------------
      // LØB 10:
      // PRØV ALTID 5-ÅRING FØRST
      // ------------------------------------------------

      if (currentRace === 10) {

        const fiveYearOld =
          validMarketHorses.find(
            h => Number(h.age) === 5
          );

        if (fiveYearOld) {
          chosen = fiveYearOld;
        }
      }


      // ------------------------------------------------
      // LØB 8:
      // PRØV ALTID 4-ÅRING FØRST
      // ------------------------------------------------

      if (
        !chosen &&
        currentRace === 8
      ) {

        const fourYearOld =
          validMarketHorses.find(
            h => Number(h.age) === 4
          );

        if (fourYearOld) {
          chosen = fourYearOld;
        }
      }


      // ------------------------------------------------
      // HVIS DER STADIG IKKE ER VALGT:
      // VÆLG ÆLDSTE VALGBARE HEST
      // ------------------------------------------------

      if (
        !chosen &&
        validMarketHorses.length > 0
      ) {

        chosen =
          [...validMarketHorses].sort(
            (a, b) =>
              Number(b.age || 0) -
                Number(a.age || 0) ||
              (b.wins || 0) -
                (a.wins || 0)
          )[0];
      }
    }


    // --------------------------------------------------
    // 3) AI MANGLER LØBSHEST
    // --------------------------------------------------

    const needsRaceHorse =
      !existingRaceHorse;


    // --------------------------------------------------
    // 4) KØB DEN NØDVENDIGE LØBSHEST
    // --------------------------------------------------

    if (
      needsRaceHorse &&
      chosen &&
      !stable.some(
        h => h.name === chosen.name
      )
    ) {

      // -----------------------------------------------
      // HVIS AI MANGLER PENGE:
      // LÅN ALTID DET NØDVENDIGE BELØB.
      //
      // Det er tilladt selv om AI allerede har gæld.
      // Det er også tilladt i sidste løb.
      // -----------------------------------------------

      if (cash < chosen.price) {

        const diff =
          chosen.price - cash;

        loan += diff;
        cash += diff;

        nextPlayerLoans[player] =
          loan;

        updateBank(
          -diff,
          `Lån til ${player} til køb af nødvendig løbshest`
        );

        addBankMessages(
          `🤖 ${player} lånte ${diff.toLocaleString()} kr. til nødvendig løbshest.`
        );
      }


      // -----------------------------------------------
      // KØB HESTEN
      // -----------------------------------------------

      cash -= chosen.price;

      nextPlayerStats[player].money =
        cash;

      nextPlayerHorses[player] = [
        ...stable,
        {
          ...chosen,
          position: 0
        }
      ];

      stable =
        nextPlayerHorses[player];

      addBankMessages(
        `🤖 ${player} købte ${chosen.name} som løbshest for ${chosen.price.toLocaleString()} kr.`
      );

      updateBank(
        +chosen.price,
        `Køb af nødvendig løbshest til ${player}`
      );
    }


    // --------------------------------------------------
    // 5) VÆLG LØBSHEST IGEN EFTER EVENTUELT KØB
    // --------------------------------------------------

    existingRaceHorse =
      selectBestRaceHorse(stable);


    if (existingRaceHorse) {

      chosen =
        existingRaceHorse;

      nextSelectedRaceHorse[player] =
        existingRaceHorse.name;

      nextSelectedBets[player] =
        existingRaceHorse.name;
    }


    // --------------------------------------------------
    // 6) EKSTRA SIKKERHED
    // --------------------------------------------------
    //
    // Hvis AI netop har købt en hest, men den normale
    // udvælgelse ikke fandt den, bruges den købte hest.
    //
    // Dette forhindrer, at AI ender uden valg efter
    // et korrekt gennemført køb.
    // --------------------------------------------------

    if (
      needsRaceHorse &&
      chosen &&
      stable.some(
        h => h.name === chosen.name
      )
    ) {

      const chosenIsValid =
        raceProgram[
          derivedRaceIndex
        ].condition(
          chosen,
          currentRound
        ) &&
        (
          currentRace !== 9 ||
          (chosen.wins || 0) === 0
        );

      if (chosenIsValid) {

        nextSelectedRaceHorse[player] =
          chosen.name;

        nextSelectedBets[player] =
          chosen.name;
      }
    }

    // --------------------------------------------------
    // 5) EKSTRA INDSATS PÅ BEDSTE HEST
    // --------------------------------------------------

    const best =
      stable.reduce(
        (a, b) =>
          ((a?.wins || 0) >
           (b?.wins || 0))
            ? a
            : b,
        null
      );

    if (best) {
      nextPlayerExtraBets[player] =
        best.name;
    }
// --------------------------------------------------
    // 9) ALMINDELIGE SELSKABER
    // --------------------------------------------------
    //
    // ALMINDELIGE SELSKABER HAR HØJ PRIORITET.
    //
    // De må købes selv om AI-spilleren har gæld.
    //
    // Det skyldes, at selskaberne skaber løbende
    // kontantstrøm mellem spillerne.
    //
    // Kun BornTAXI, Galopforsikring, Hotel og
    // BronzeCar kræver, at AI'en er gældfri.
    // --------------------------------------------------

    const ownedCompanies =
      Object.entries(nextCompanies)
        .filter(
          ([name, info]) =>
            info.owner === player &&
            !name.includes("Obligation") &&
            !isSpecialCompany(name)
        );

    if (
      racesLeft >= 2 &&
      ownedCompanies.length < 3
    ) {

      const ordinaryCompanies =
        Object.entries(nextCompanies)
          .filter(
            ([name, info]) =>
              !info.owner &&
              !name.includes("Obligation") &&
              !isSpecialCompany(name)
          )
          .map(
            ([name, info]) => {

              const roi =
                info.price > 0
                  ? info.fee / info.price
                  : 0;

              const timeFactor =
                Math.min(
                  1.5,
                  0.7 +
                  racesLeft * 0.08
                );

              return {
                name,
                ...info,

                score:
                  roi * timeFactor
              };
            }
          )
          .sort(
            (a, b) =>
              b.score - a.score
          );

      // AI prøver selskaberne i prioriteret rækkefølge.
      //
      // Hvis det bedste selskab er for dyrt,
      // prøves det næste i stedet for at stoppe.
      //
      // AI må købe op til 3 almindelige selskaber.
      for (
        const company of ordinaryCompanies
      ) {

        if (
          ownedCompanies.length >= 3
        ) {
          break;
        }

        if (
          cash >=
          company.price + investmentBuffer
        ) {

          cash -= company.price;

          nextPlayerStats[player].money =
            cash;

          nextCompanies[company.name] = {
            ...company,
            owner: player
          };

          ownedCompanies.push(
            company
          );

          addBankMessages(
            `🤖 ${player} købte ${company.name} for ${company.price.toLocaleString()} kr.`
          );

          updateBank(
            +company.price,
            `Indtægt: ${player} købte ${company.name}`
          );
        }
      }
    }


    // --------------------------------------------------
    // 10) APS-SELSKABER
    // --------------------------------------------------
    //
    // BornTAXI
    // Galopforsikring
    // Hotel Hesteløkken
    // BronzeCar
    //
    // Disse kræver, at AI'en er GÆLDFRI.
    // --------------------------------------------------

    const specialCompanyCount =
      Object.entries(nextCompanies)
        .filter(
          ([name, info]) =>
            info.owner === player &&
            isSpecialCompany(name)
        )
        .length;

    if (
      loan === 0 &&
      racesLeft >= 2 &&
      specialCompanyCount < 2
    ) {

      const specialCompanies =
        Object.entries(nextCompanies)
          .filter(
            ([name, info]) =>
              !info.owner &&
              isSpecialCompany(name)
          )
          .map(
            ([name, info]) => {

              const roi =
                info.price > 0
                  ? info.fee / info.price
                  : 0;

              const timeFactor =
                Math.min(
                  1.5,
                  0.7 +
                  racesLeft * 0.08
                );

              return {
                name,
                ...info,

                score:
                  roi * timeFactor
              };
            }
          )
          .sort(
            (a, b) =>
              b.score - a.score
          );

      for (
        const company of specialCompanies
      ) {

        if (
          specialCompanyCount >= 2
        ) {
          break;
        }

        if (
          cash >=
          company.price + investmentBuffer
        ) {

          cash -= company.price;

          nextPlayerStats[player].money =
            cash;

          nextCompanies[company.name] = {
            ...company,
            owner: player
          };

          addBankMessages(
            `🤖 ${player} købte ${company.name} for ${company.price.toLocaleString()} kr.`
          );

          updateBank(
            +company.price,
            `Indtægt: ${player} købte ${company.name}`
          );

          break;
        }
      }
    }

    // --------------------------------------------------
    // 6) AFDRAG PÅ GÆLD
    // --------------------------------------------------

    // Gæld prioriteres før investering.
    // Men AI'en beholder en buffer.

    if (loan > 0) {

      const repayBuffer =
        racesLeft <= 2
          ? 30000
          : 25000;

      const repay =
        Math.min(
          loan,
          Math.max(
            0,
            cash - repayBuffer
          )
        );

      if (repay > 0) {

        cash -= repay;
        loan -= repay;

        saveFinancialState();

        updateBank(
          +repay,
          `Afdrag fra ${player}`
        );

        addBankMessages(
          `🤖 ${player} afdrager ${repay.toLocaleString()} kr.`
        );
      }
    }

    // --------------------------------------------------
    // 7) OBLIGATIONER
    // --------------------------------------------------

    const ownedObligations =
      nextObligationOwners[player] || 0;

    if (
      loan === 0 &&
      remainingObligations > 0 &&
      ownedObligations < 4 &&
      racesLeft > 2
    ) {

      const price =
        obligations.price;

      const canAfford =
        cash >=
        price + investmentBuffer;

      if (
        canAfford &&
        Math.random() < 0.75
      ) {

        remainingObligations--;

        nextObligationOwners[player] =
          (nextObligationOwners[player] || 0) + 1;

        cash -= price;

        nextPlayerStats[player].money =
          cash;

        addBankMessages(
          `🤖 ${player} købte 1 obligation (${price.toLocaleString()} kr.)`
        );

        updateBank(
          +price,
          `Salg af obligation til ${player}`
        );
      }
    }

    // --------------------------------------------------
    // 8) TOTO-AKTIER
    // --------------------------------------------------

    const playerShares =
      nextTotoShareOwners[player] || 0;

    const totoPrice =
      35000;

    if (
      loan === 0 &&
      remainingTotoShares > 0 &&
      playerShares < 2 &&
      racesLeft > 2 &&
      cash >= totoPrice + investmentBuffer &&
      Math.random() < 0.90
    ) {

      remainingTotoShares--;

      nextTotoShareOwners[player] =
        (nextTotoShareOwners[player] || 0) + 1;

      cash -= totoPrice;

      nextPlayerStats[player].money =
        cash;

      addBankMessages(
        `🤖 ${player} købte 1 aktie i Totosyndikatet (${totoPrice.toLocaleString()} kr.)`
      );

      updateBank(
        +totoPrice,
        `Salg af aktie til ${player}`
      );
    }
    // --------------------------------------------------
    // 8+) 🏦 ANDELSBANK
    // --------------------------------------------------
    //
    // AI kan højst købe én andel pr. løbsdag.
    //
    // AI må kun købe, hvis den er udtrukket i lodtrækningen.
    //
    // Hvis AI'en ikke har 50.000 kr., må den sælge en
    // anden hest for at skaffe pengene.
    //
    // Den aktuelle løbshest må IKKE sælges for at skaffe
    // penge til Andelsbanken.
    // --------------------------------------------------

    const andelsBankPrice =
      andelsBank?.price || 50000;

    const alreadyBoughtAndel =
      nextAndelsBankBoughtThisRace[player] === true;

    const isLotteryWinner =
      andelsBank?.lotteryPlayer === player;

    if (
      isLotteryWinner &&
      loan === 0 &&
      !alreadyBoughtAndel &&
      remainingAndelsBankShares > 0 &&
      cash < andelsBankPrice
    ) {

      // ------------------------------------------------
      // AI MANGLER PENGE TIL ANDELSBANKEN
      // ------------------------------------------------
      //
      // Find en hest, som kan sælges uden at fjerne
      // AI'ens valgte løbshest.
      // ------------------------------------------------

      const cashNeeded =
        andelsBankPrice - cash;

      const raceHorseName =
        nextSelectedRaceHorse[player];

      const possibleHorsesToSell =
        stable
          .filter(
            h =>
              h.name !== raceHorseName
          )
          .map(h => {

            const age =
              Number(h.age || 2);

            const basePrice =
              shuffledHorsesByAge?.[age]?.price ||
              h.price ||
              20000;

            const sellPrice =
              Math.round(
                basePrice *
                Math.pow(
                  1.25,
                  h.wins || 0
                )
              );

            return {
              horse: h,
              sellPrice
            };
          })
          .filter(
            item =>
              item.sellPrice >= cashNeeded
          )
          .sort(
            (a, b) =>
              a.sellPrice - b.sellPrice
          );

      // ------------------------------------------------
      // SÆLG DEN BILLIGSTE HEST, DER ER NOK TIL
      // AT SKAFFE DE MANGLENDE PENGE
      // ------------------------------------------------

      if (
        possibleHorsesToSell.length > 0
      ) {

        const sale =
          possibleHorsesToSell[0];

        const horseToSell =
          sale.horse;

        const sellPrice =
          sale.sellPrice;

        stable =
          stable.filter(
            h =>
              h.name !== horseToSell.name
          );

        nextPlayerHorses[player] =
          stable;

        cash += sellPrice;

        nextPlayerStats[player].money =
          cash;

        updateBank(
          -sellPrice,
          `Banken køber hesten ${horseToSell.name} fra ${player}`
        );

        addBankMessages(
          `🤖 ${player} solgte ${horseToSell.name} for ${sellPrice.toLocaleString()} kr. for at få råd til en Andelsbank-andel.`
        );
      }
    }


    // ------------------------------------------------
    // KØB ANDELSBANK-ANDEL
    // ------------------------------------------------

    if (
      isLotteryWinner &&
      loan === 0 &&
      !alreadyBoughtAndel &&
      remainingAndelsBankShares > 0 &&
      cash >= andelsBankPrice &&
      Math.random() < 0.80
    ) {

      remainingAndelsBankShares--;

      nextAndelsBankOwners[player] =
        (nextAndelsBankOwners[player] || 0) + 1;

      nextAndelsBankBoughtThisRace[player] =
        true;

      cash -= andelsBankPrice;

      nextPlayerStats[player].money =
        cash;

      addBankMessages(
        `🤖 ${player} købte 1 andel i Andelsbanken (${andelsBankPrice.toLocaleString()} kr.)`
      );

      updateBank(
        +andelsBankPrice,
        `Salg af Andelsbank-andel til ${player}`
      );
    }
	
	// --------------------------------------------------
    // 11) SIDSTE GÆLDSAFDRAG
    // --------------------------------------------------

    // Hvis AI'en stadig har gæld efter sine
    // nødvendige køb, bruges overskydende
    // kontanter på gælden.

    if (loan > 0) {

      const finalBuffer =
        racesLeft <= 2
          ? 30000
          : 25000;

      const finalRepay =
        Math.min(
          loan,
          Math.max(
            0,
            cash - finalBuffer
          )
        );

      if (finalRepay > 0) {

        cash -= finalRepay;
        loan -= finalRepay;

        saveFinancialState();

        updateBank(
          +finalRepay,
          `Afdrag fra ${player}`
        );

        addBankMessages(
          `🤖 ${player} afdrager ${finalRepay.toLocaleString()} kr.`
        );
      }
    }

    // --------------------------------------------------
    // GEM AI-SPILLERENS ENDELIGE ØKONOMI
    // --------------------------------------------------

    nextPlayerStats[player].money =
      cash;

    nextPlayerLoans[player] =
      loan;
  });

  // --------------------------------------------------
  // GEM ALLE AI-ÆNDRINGER
  // --------------------------------------------------

  setObligations(prev => ({
    ...prev,
    total: remainingObligations,
    owners: nextObligationOwners
  }));

  // VIGTIGT:
  // TOTO skal også gemmes efter AI-runden.
  setTotoShares(prev => ({
  ...prev,
  total: prev.total || 10,
  owners: nextTotoShareOwners
}));

  setAndelsBank(prev => ({
    ...prev,
    total: prev.total || 10,
    owners: nextAndelsBankOwners,
    boughtThisRace: nextAndelsBankBoughtThisRace
  }));

  setPlayerStats(nextPlayerStats);
  setPlayerLoans(nextPlayerLoans);
  setPlayerHorses(nextPlayerHorses);
  setCompanies(nextCompanies);
  setSelectedRaceHorse(nextSelectedRaceHorse);
  setSelectedBets(nextSelectedBets);
  setPlayerExtraBets(nextPlayerExtraBets);
};
  // Starter spillet – tildeler spillere, heste og startkapital
const start = () => {
shuffleHorseNames();
  const stats = {};
  const horses = {};
  const raceHorse = {};
  const bets = {};
  const loans = {};
  let available2YearHorses = [...(shuffledHorsesByAge[2]?.names || [])]; 
  
  players.forEach(player => {
    const isAI = aiPlayers.includes(player);

    // Start penge og lån
    stats[player] = { money: 45000, wins: 0 };
    loans[player] = 25000;
    horses[player] = [];

    if (isAI) {
      // AI vurderer pris, antal sejre og vælger hest ud fra "værdi for pengene"
      const affordableHorses = available2YearHorses
        .map(name => {
          const wins = horseWins[name] || 0;
          const basePrice = shuffledHorsesByAge[2].price;
          const price = wins > 0 ? Math.floor(basePrice * (1.25 ** wins)) : basePrice;
          return {
            name,
            wins,
            price,
            score: (1 + wins) / price // bedre heste har højere score
          };
        })
        .filter(h => stats[player].money >= h.price)
        .sort((a, b) => b.score - a.score); // højeste score først

      const bestHorse = affordableHorses[0];

      if (bestHorse) {
        const horse = {
          name: bestHorse.name,
          age: 2,
          wins: bestHorse.wins,
          price: bestHorse.price,
          position: 0
        };

        horses[player].push(horse);
        stats[player].money -= bestHorse.price;
        raceHorse[player] = horse.name;
        bets[player] = horse.name;

        // Fjern valgt hest fra listen
        available2YearHorses = available2YearHorses.filter(name => name !== bestHorse.name);
      } else {
  // Menneskespiller får en 2-årig hest og satser på den
  const horseName = available2YearHorses.shift();
  const horse = {
    name: horseName,
    age: 2,
    wins: 0,
    price: shuffledHorsesByAge[2].price,
    position: 0
  };

  horses[player].push(horse);
  stats[player].money -= horse.price;
  raceHorse[player] = horse.name;
  bets[player] = horse.name;
}
    }
  });

  setPlayerStats(stats);
  setPlayerHorses(horses);
  setPlayerLoans(loans);
  setSelectedRaceHorse(raceHorse);
  setSelectedBets(bets);
  setTotoPayoutGiven(false);
  const firstAndelsLotteryPlayer =
    players.length > 0
      ? players[Math.floor(Math.random() * players.length)]
      : null;

  setAndelsBank({
    total: 6,
    price: 50000,
    owners: {},
    boughtThisRace: {},
    lotteryPlayer: firstAndelsLotteryPlayer
  });

  if (firstAndelsLotteryPlayer) {
    addBankMessages(
      `🎟️ Andelsbanken: ${firstAndelsLotteryPlayer} er udtrukket og får mulighed for at købe 1 andel i dette løb.`
    );
  }
  setAndelsBankShareValues({});
  setAndelsBankCarryover(0);
  setGameStarted(true);
  setRaceStarted(false);
  setFirstPlayerIndex(0);
  setPlayerExtraBets({});
};

useEffect(() => {
  // ❗ Kør KUN hvis spillet er NYT (ikke når spil indlæses)
  if (loadedFromSave) return;

  if (players.length > 0) {
    // Udlån 25.000 til hver spiller ved spilstart
    players.forEach(player => {
      setPlayerLoans(prev => ({
        ...prev,
        [player]: (prev[player] || 0) + 0
      }));
      setPlayerStats(prev => ({
        ...prev,
        [player]: { ...(prev[player] || {}), money: (prev[player]?.money || 0) + 0 }
      }));
      setBankBalance(prev => prev - 25000);
      setBankLog(prev => [...prev, `💸 Udlån 25.000 kr. til ${player}`]);
    });
  }
}, [players, loadedFromSave]);

const updateBank = (amount, text) => {
  setBankBalance(prev => prev + amount);
  const entry = `${amount >= 0 ? "➕" : "➖"} ${text} (${amount >= 0 ? "+" : ""}${kr(amount)} kr.)`;
  setBankLog(prev => [...prev, entry]);
};

  // Vis chancekort-beskeder med fade-effekt
const showChanceMessage = (message) => {
  const id = Date.now(); // unikt id
  const newMsg = { id, text: message, fading: false };

  setChanceMessages((prev) => [...prev, newMsg]);

  // Start fade efter 6 sek
  setTimeout(() => {
    setChanceMessages((prev) =>
      prev.map((msg) =>
        msg.id === id ? { ...msg, fading: true } : msg
      )
    );
  }, 5000);

  // Fjern helt efter 7 sek
  setTimeout(() => {
    setChanceMessages((prev) =>
      prev.filter((msg) => msg.id !== id)
    );
  }, 7000);
};
const activeRaceHorseNames = players.map(player => 
  selectedRaceHorse[player] || (playerHorses[player] && playerHorses[player][0]?.name)
).filter(Boolean);
  
  // Spillere vælger og satser automatisk på deres egen hest
const handleBetsSubmit = () => {
  const baseBet = 500;

  // ==========================================================
  // 🔒 SIKKERHED: ALLE spillere SKAL have en gyldig løbshest
  // før løbet kan starte.
  //
  // Der bruges KUN selectedRaceHorse.
  // Der bruges IKKE længere første hest som fallback.
  // ==========================================================

  // ==========================================================
// 🔒 SIKKERHEDSTJEK FØR LØBSSTART
// ==========================================================
// Alle spillere skal have valgt/eje en hest.
// VIGTIGT: I Løb 6 må en hest med sejr godt være valgt.
// Den skal kun stå stille i de første runder.
// ==========================================================

const invalidPlayers = players.filter(player => {

  const selectedName =
    (selectedRaceHorse[player] || "").trim();

  // Hvis der ikke er valgt en hest, prøv den aktive hest
  // og til sidst spillerens første hest.
  const raceHorseName =
    selectedName ||
    activeHorses[player]?.name ||
    (playerHorses[player] && playerHorses[player][0]?.name);

  // Spilleren har slet ingen hest
  if (!raceHorseName) {
    return true;
  }

  // Find den valgte hest blandt spillerens egne heste
  const horse = (playerHorses[player] || []).find(
    h => h.name === raceHorseName
  );

  // Hesten findes ikke hos spilleren
  if (!horse) {
    return true;
  }

  // ========================================================
  // 🏇 LØB 6
  // ========================================================
  // Alle heste er gyldige til selve løbet.
  // En hest med sejr skal IKKE blokere starten.
  // Den håndteres senere af nextRound(), hvor den
  // står stille i de første runder.
  // ========================================================

  if (derivedRaceIndex === 5) {
    return false;
  }

  // ========================================================
  // Andre løb bruger deres normale løbsbetingelse
  // ========================================================

  const raceCondition =
    raceProgram[derivedRaceIndex]?.condition;

  if (typeof raceCondition === "function") {
    return !raceCondition(horse, 1);
  }

  return false;
});

if (invalidPlayers.length > 0) {
  addBankMessages(
    `❌ Løbet kan ikke starte da en spiller mangler en gyldig hest: ${invalidPlayers.join(", ")}`
  );
  return;
}

  // ==========================================================
  // 🔓 Nyt løb starter – nulstil halt-låsen
  // ==========================================================

  haltLockRef.current = false;
  setHaltAlreadyThisRace(false);

  let newBets = {};
  let newStats = { ...playerStats };
  const newActiveHorses = {};
  const updatedInsurance = { ...insuredHorses };

  // ==========================================================
  // 🐎 Alle spillere deltager med den hest de faktisk har valgt
  // ==========================================================

  players.forEach(player => {
    const raceHorseName = (selectedRaceHorse[player] || "").trim();

    // Denne kontrol burde aldrig fejle efter valideringen ovenfor,
    // men beholdes som ekstra sikkerhed.
    if (!raceHorseName) {
      console.warn(
        `Ingen gyldig hest valgt for ${player} – løbet starter ikke.`
      );
      return;
    }

    // Satser altid på den valgte løbshest
    const betHorse = raceHorseName;
    newBets[player] = betHorse;

    // Træk indsatsen
    if (newStats[player]) {
      newStats[player] = {
        ...newStats[player],
        money:
          (newStats[player].money || 0) - baseBet
      };
    } else {
      newStats[player] = {
        money: -baseBet,
        wins: 0
      };
    }

    updateBank(
      +baseBet,
      `${player} satser på egen hest som vinder`
    );

    // Aktiv hest til det aktuelle løb
    const originalHorse =
      (playerHorses[player] || []).find(
        h => h.name === betHorse
      );

    if (originalHorse) {
      newActiveHorses[player] = {
        ...originalHorse,
        position: 0,
        wins: originalHorse.wins || 0,
        age: originalHorse.age || 2,
        price: originalHorse.price || 0
      };

      // ========================================================
      // 🛡️ Forsikring – eksisterende regler bevares
      // ========================================================

      if (currentRace > 1) {
        if (insuredPlayersThisRace[player]) {
          updatedInsurance[originalHorse.name] = true;

          addBankMessages?.(
            `✅ ${player}s hest ${originalHorse.name} er dækket af forsikring.`
          );
        } else {
          updatedInsurance[originalHorse.name] = false;

          addBankMessages?.(
            `⚠️ ${player}s hest ${originalHorse.name} er IKKE dækket af forsikring.`
          );
        }
      } else {
        updatedInsurance[originalHorse.name] =
          !!updatedInsurance[originalHorse.name];
      }
    }
  });

  // ==========================================================
  // 🎲 Totosyndikatet placerer fast væddemål før løbet starter
  // ==========================================================

  const bet =
    totoSyndicate.betsByRace[currentRace];

  if (bet) {
    setTotoSyndicate(prev => ({
      ...prev,
      balance: prev.balance - bet.amount,
      history: [
        ...prev.history,
        {
          race: currentRace,
          stake: bet.amount,
          colors: bet.colors,
          payout: 0,
          net: -bet.amount
        }
      ]
    }));

    addBankMessages(
      // `🎲 Totosyndikatet satser ${bet.amount.toLocaleString()} kr. på farverne ${bet.colors.join(", ")}.`
    );

    updateBank(
      +bet.amount,
      `Totosyndikatet satser på to jockeyfarver`
    );
  }

  // ==========================================================
  // 🎨 Tildel jockeyfarver til heste og spillere ved løbsstart
  // ==========================================================

  const colors = ["🔴", "🟡", "🔵", "⚪"];

  let newHorseColors = {};
  let newPlayerColors = {};

  players.forEach(player => {
    const raceHorse =
      newActiveHorses[player]?.name;

    if (raceHorse) {
      const color =
        colors[
          Math.floor(
            Math.random() * colors.length
          )
        ];

      newHorseColors[raceHorse] = color;
    }

    const playerColor =
      colors[
        Math.floor(
          Math.random() * colors.length
        )
      ];

    newPlayerColors[player] = playerColor;
  });

  setHorseColors(newHorseColors);
  setPlayerColors(newPlayerColors);

  // ==========================================================
  // 💾 Gem ændringer
  // ==========================================================

setPlayerBets(newBets);
setPlayerStats(newStats);
setActiveHorses(newActiveHorses);
setInsuredHorses(updatedInsurance);

// ✅ Sørg for at nextRound bruger præcis de heste,
// som netop er blevet gjort aktive.
// Uden dette kan nextRound stoppe ved:
// if (!activeHorseName) return;
const raceHorseSelections = {};

players.forEach(player => {
  const raceHorse = newActiveHorses[player]?.name;

  if (raceHorse) {
    raceHorseSelections[player] = raceHorse;
  }
});

setSelectedRaceHorse(raceHorseSelections);

setRaceStarted(true);
setShowBetForm(false);
setCurrentRound(1);
setKriseUsedThisRace(false);
setFremgangUsedThisRace(false);
};
  
  const initialCompanies = {
  "📰 Galoptidende A/S": { owner: null, fee: 2500, price: 80000, image: "https://bornholm-golf.dk/derby/static/galoptidende.png" },
  "⏱️ Præmier og Pokaler A/S": { owner: null, fee: 3000, price: 90000, image: "https://bornholm-golf.dk/derby/static/premier.png" },
  "🐴 Hestepleje og foder A/S": { owner: null, fee: 4500, price: 100000, image: "https://bornholm-golf.dk/derby/static/plejeogfoder.png" },
  "👖 Ryttershoppen A/S": {owner: null, fee: 4000, price: 110000, image: "https://bornholm-golf.dk/derby/static/ryttercloths.png" },
  "🚮 Hestepærer Affald A/S": { owner: null, fee: 4500, price: 115000, image: "https://bornholm-golf.dk/derby/static/affald.png" },
  "🐴 Galopstald A/S": { owner: null, fee: 5000, price: 120000, image: "https://bornholm-golf.dk/derby/static/galopstald.png" },
  "⚕️ Dyrlægegården A/S": { owner: null, fee: 5500, price: 125000, image: "https://bornholm-golf.dk/derby/static/dyrlege.png" },
  "🏇🏼 Jockeytjenesten A/S": { owner: null, fee: 6000, price: 130000, image: "https://bornholm-golf.dk/derby/static/jockeys.png"  },
  "🐴 Hesteagenturet A/S": { owner: null, fee: 6500, price: 135000, image: "https://bornholm-golf.dk/derby/static/agenturet.png" },
  "🐴 Trænertjenesten A/S": { owner: null, fee: 7000, price: 140000, image: "https://bornholm-golf.dk/derby/static/trenertj.png" },
  "🥐 Restaurant Hesteskoen A/S": { owner: null, fee: 8000, price: 145000, image: "https://bornholm-golf.dk/derby/static/hesteskoen.png" },
  "🥬 Horsetrack & Stable A/S": {owner: null, fee: 8500, price: 150000, image: "https://bornholm-golf.dk/derby/static/galopbane.png" },
  "💰 BornTAXI ApS 🚕": {owner: null, fee: 2000, price: 50000, image: "https://bornholm-golf.dk/derby/static/Borntaxi.png" },
  "💰 Galopforsikring ApS️ 🛡️": { owner: null, fee: 1500, price: 150000, image: "https://bornholm-golf.dk/derby/static/forsikring.png" },
  "💰 BronzeCar biler ApS 🚗": { owner: null, fee: 3500, price: 80000, image: "https://bornholm-golf.dk/derby/static/bilservice.png" },
  "💰 Hotel Hesteløkken ApS 🏨": {owner: null, fee: 5000, price: 160000, image: "https://bornholm-golf.dk/derby/static/hotel.png" }
};
  const [companies, setCompanies] = useState(initialCompanies);
  const companyPayoutMap = {
  "🐴 Trænertjenesten A/S": 7000,
  "🐴 Hestepleje og foder A/S": 4500,
  "📰 Galoptidende A/S": 2500,
  "🐴 Hesteagenturet A/S": 6500,
  "🏇🏼 Jockeytjenesten A/S": 6000,
  "🥐 Restaurant Hesteskoen A/S": 8000,
  "🐴 Galopstald A/S": 5000,
  "⏱️ Præmier og Pokaler A/S": 3000,
  "🚮 Hestepærer Affald A/S": 4500,
  "⚕️ Dyrlægegården A/S": 5500,
  "🚕 BornTAXI ApS": 1000,
  "🥬 Horsetrack & Stable A/S": 8500,
  "👖 Ryttershoppen A/S": 4000
};

// 🔔 Obligationer (central pulje, 24 stk., separat fra 'companies')
const [obligations, setObligations] = useState({
  total: 24,              // hvor mange tilbage i puljen
  price: 25000,          // pris per obligation
  interest: 1000,        // fast rente per obligation efter hvert løb
  owners: {},             // { spillerNavn: antal }
  image: "https://bornholm-golf.dk/derby/static/obligation.png"
});

function buyObligation(player) {
  if (!player) {
    setInvestmentMessage("❌ Vælg en spiller før køb.");
    setTimeout(() => setInvestmentMessage(""), 8000);
    return;
  }
  
  function buyTotoShare(player) {
  if (!player) return;

  const loan = playerLoans[player] || 0;
  const money = playerStats[player]?.money || 0;

  const owned = Object.values(
    totoShares.owners || {}
  ).reduce((a, b) => a + b, 0);

  const totoPrice = 35000;

  if (loan > 0) {
    setInvestmentMessage(
      `${player} har gæld og kan ikke købe aktier.`
    );
    setTimeout(() => setInvestmentMessage(""), 8000);
    return;
  }

  if (money < totoPrice) {
    setInvestmentMessage(
      `${player} har ikke råd til en aktie.`
    );
    setTimeout(() => setInvestmentMessage(""), 8000);
    return;
  }

  if (owned >= totoShares.total) {
    setInvestmentMessage(
      "Der er udsolgt af aktier."
    );
    setTimeout(() => setInvestmentMessage(""), 8000);
    return;
  }

  setPlayerStats(prev => ({
    ...prev,
    [player]: {
      ...prev[player],
      money: prev[player].money - totoPrice
    }
  }));

  setTotoShares(prev => ({
    ...prev,
    total: Math.max(
      0,
      prev.total - 1
    ),
    owners: {
      ...(prev.owners || {}),
      [player]:
        ((prev.owners || {})[player] || 0) + 1
    }
  }));

  addBankMessages(
    `💼 ${player} købte 1 aktie i Totosyndikatet for ${totoPrice.toLocaleString()} kr.`
  );

  updateBank(
    +totoPrice,
    `Salg af TOTO-aktie til ${player}`
  );

  setInvestmentMessage(
    `${player} købte 1 aktie i Totosyndikatet.`
  );

  setTimeout(
    () => setInvestmentMessage(""),
    8000
  );
}

  // 📉 Tjek gæld
  if ((playerLoans[player] || 0) > 0) {
    setInvestmentMessage(`${player} har gæld og kan ikke købe obligationer.`);
    setTimeout(() => setInvestmentMessage(""), 8000);
    return;
  }

  // 🏢 Tæl hvor mange særlige ApS'er spilleren allerede ejer
const ownedCompanies = Object.entries(companies).filter(
  ([_, info]) => info.owner === player
);

// Forsikring, TAXI, Hotel og BronzeCar
const numFinancialCompanies = ownedCompanies.filter(
  ([name]) =>
    name.includes("BornTAXI") ||
	name.includes("Hotel") ||
    name.includes("BronzeCar") ||
    name.includes("Galopforsikring")
).length;

// 💶 Antal obligationer spilleren allerede ejer
const numBonds = obligations?.owners?.[player] || 0;

// 🔒 Maks. 4 obligationer
if (numBonds >= 4) {
  setInvestmentMessage(`${player} kan maks eje fire obligationer.`);
  setTimeout(() => setInvestmentMessage(""), 8000);
  return;
}

// 📦 Tjek om der er obligationer tilbage
if ((obligations.total || 0) <= 0) {
  setInvestmentMessage("❌ Der er udsolgt af obligationer.");
  setTimeout(() => setInvestmentMessage(""), 8000);
  return;
}

const price = obligations.price;
const playerMoney = (playerStats[player]?.money) || 0;

if (playerMoney < price) {
  setInvestmentMessage(`${player} har ikke råd til at købe en obligation.`);
  setTimeout(() => setInvestmentMessage(""), 8000);
  return;
}

// 💸 Træk pengene fra spiller
setPlayerStats(prev => ({
  ...prev,
  [player]: {
    ...prev[player],
    money: prev[player].money - price
  }
}));

// 🧾 Opdater obligationspuljen
setObligations(prev => ({
  ...prev,
  total: (prev.total || 0) - 1,
  owners: {
    ...(prev.owners || {}),
    [player]: ((prev.owners || {})[player] || 0) + 1
  }
}));

// 💬 Info-beskeder
addBankMessages(
  `💶 ${player} købte 1 obligation for ${price.toLocaleString()} kr.`
);
updateBank(+price, `Salg af obligation til ${player}`);
setInvestmentMessage(`${player} købte 1 obligation.`);
setTimeout(() => setInvestmentMessage(""), 8000);
}

function buyTotoShare(player) {
  if (!player) return;
  const loan = playerLoans[player] || 0;
  const money = playerStats[player]?.money || 0;
  const owned = Object.values(totoShares.owners).reduce((a,b)=>a+b,0);

  if (loan > 0) {
    setInvestmentMessage(`${player} har gæld og kan ikke købe aktier.`);
    setTimeout(() => setInvestmentMessage(""), 8000);
    return;
  }

  if (money < 35000) {
    setInvestmentMessage(`${player} har ikke råd til en aktie.`);
    setTimeout(() => setInvestmentMessage(""), 8000);
    return;
  }

  if (owned >= totoShares.total) {
    setInvestmentMessage("Der er udsolgt af aktier.");
    setTimeout(() => setInvestmentMessage(""), 8000);
    return;
  }

  setPlayerStats(prev => ({
    ...prev,
    [player]: { ...prev[player], money: prev[player].money - 35000 }
  }));

  setTotoShares(prev => ({
    ...prev,
    owners: { 
      ...prev.owners, 
      [player]: ((prev.owners[player] || 0) + 1)
    }
  }));

  addBankMessages(`💼 ${player} købte 1 aktie i Totosyndikatet for 35.000 kr.`);
  updateBank(+35000, `Salg af aktie til ${player}`);
  setInvestmentMessage(`${player} købte 1 aktie i Totosyndikatet.`);
  setTimeout(() => setInvestmentMessage(""), 8000);
}

// 🏦 KØB ANDEL I ANDELSBANKEN
// -------------------------------------------------------

function buyAndelsBankShare(player) {

  if (!player) {
    setInvestmentMessage(
      "❌ Vælg en spiller før køb."
    );

    setTimeout(
      () => setInvestmentMessage(""),
      8000
    );

    return;
  }

  const price =
    andelsBank.price || 50000;

  const playerMoney =
    playerStats[player]?.money || 0;

  const playerLoan =
    playerLoans[player] || 0;

  // Hvor mange andele har spilleren allerede?
  const ownedShares =
    andelsBank.owners?.[player] || 0;

  // --------------------------------------------------
  // Kun den udtrukne spiller må købe i dette løb
  // --------------------------------------------------

  if (andelsBank.lotteryPlayer !== player) {
    setInvestmentMessage(
      andelsBank.lotteryPlayer
        ? `🎟️ ${andelsBank.lotteryPlayer} har fået købsretten i dette løb.`
        : "🎟️ Der er ingen købsret til en andel i dette løb."
    );

    setTimeout(
      () => setInvestmentMessage(""),
      8000
    );

    return;
  }

  // --------------------------------------------------
  // Kun én Andelsbank-andel pr. spiller pr. løbsdag
  // --------------------------------------------------

  if (
    andelsBank.boughtThisRace?.[player]
  ) {

    setInvestmentMessage(
      `${player} har allerede købt en andel i Andelsbanken på denne løbsdag.`
    );

    setTimeout(
      () => setInvestmentMessage(""),
      8000
    );

    return;
  }

  // --------------------------------------------------
  // Tæl SOLGTE andele
  // --------------------------------------------------

  const soldShares =
    Object.values(
      andelsBank.owners || {}
    ).reduce(
      (a, b) => a + b,
      0
    );

  // --------------------------------------------------
  // Maks. 6 andele i alt
  // --------------------------------------------------

  if (
    soldShares >=
    (andelsBank.total || 6)
  ) {

    setInvestmentMessage(
      "❌ Alle 6 andele i Andelsbanken er solgt."
    );

    setTimeout(
      () => setInvestmentMessage(""),
      8000
    );

    return;
  }

  // --------------------------------------------------
  // Gæld forhindrer køb
  // --------------------------------------------------

  if (playerLoan > 0) {

    setInvestmentMessage(
      `${player} har gæld og kan ikke købe en andel i Andelsbanken.`
    );

    setTimeout(
      () => setInvestmentMessage(""),
      8000
    );

    return;
  }

  // --------------------------------------------------
  // Tjek penge
  // --------------------------------------------------

  if (
    playerMoney < price
  ) {

    setInvestmentMessage(
      `${player} har ikke råd til en andel i Andelsbanken.`
    );

    setTimeout(
      () => setInvestmentMessage(""),
      8000
    );

    return;
  }

  // --------------------------------------------------
  // TRÆK 50.000 KR.
  // --------------------------------------------------

  setPlayerStats(prev => ({
    ...prev,
    [player]: {
      ...prev[player],
      money:
        prev[player].money - price
    }
  }));

  // --------------------------------------------------
  // REGISTRER ANDEL
  //
  // VIGTIGT:
  // total ændres IKKE.
  // total er altid 6.
  // owners fortæller hvor mange der er solgt.
  // --------------------------------------------------

  setAndelsBank(prev => ({
    ...prev,

    total:
      prev.total || 6,

    owners: {
      ...(prev.owners || {}),
      [player]:
        ((prev.owners || {})[player] || 0) + 1
    },

    boughtThisRace: {
      ...(prev.boughtThisRace || {}),
      [player]: true
    }
  }));

  // --------------------------------------------------
  // Banken modtager de 50.000 kr.
  // --------------------------------------------------

  updateBank(
    +price,
    `Salg af Andelsbank-andel til ${player}`
  );

  addBankMessages(
    `🏦 ${player} købte 1 andel i Andelsbanken for ${price.toLocaleString()} kr.`
  );

  setInvestmentMessage(
    `🏦 ${player} købte 1 andel i Andelsbanken.`
  );

  setTimeout(
    () => setInvestmentMessage(""),
    8000
  );
}

const investInCompany = (player, companyName) => {
  if (!players.includes(player)) {
  setInvestmentMessage("❌ Ugyldigt spillernavn!");
  return;
}

  const company = companies[companyName];

  // Hent spillerens gæld (kan være 0)
  const playerDebt = playerLoans[player] || 0;

  // GÆLD: Forhindre køb af obligation, hvis der er gæld
  if (companyName.includes("💰") && playerDebt > 0) {
  setInvestmentMessage(`${player} har gæld (${playerDebt} kr.) og kan derfor ikke købe en Obligation, TAXI, Bilservice, Forsikringsselskab eller Hotel.`);
  setTimeout(() => setInvestmentMessage(""), 8000);
  return;
}

  // Hent alle selskaber spilleren ejer
const owned = Object.entries(companies).filter(([_, info]) => info.owner === player);

// Almindelige selskaber (A/S uden 💰)
const numOwnedCompanies = owned.filter(
  ([name]) => name.includes("A/S") && !name.includes("💰")
).length;

// Finansielle selskaber (TAXI, Biler, Hotel og Forsikring)
const numOwnedFinancials = owned.filter(([name]) =>
  name.includes("💰") || name.includes("BornTAXI") || name.includes("Hotel") || name.includes("Galopforsikring") || name.includes("BronzeCar")
).length;

// Maks 3 almindelige selskaber
if (companyName.includes("A/S") && !companyName.includes("💰") && numOwnedCompanies >= 3) {
  setInvestmentMessage(`${player} kan maks eje tre selskaber.`);
  setTimeout(() => setInvestmentMessage(""), 8000);
  return;
}

// Maks 2 finansielle selskaber
if ((companyName.includes("💰") || companyName.includes("BornTAXI") || companyName.includes("Hotel") || companyName.includes("Galopforsikring") || companyName.includes("BronzeCar")) 
    && numOwnedFinancials >= 2) {
  setInvestmentMessage(`${player} kan maks eje to finansielle selskaber (TAXI, Bilservice, Hotel eller Forsikring).`);
  setTimeout(() => setInvestmentMessage(""), 8000);
  return;
}

  // Tjek penge nok
  if (playerStats[player].money >= company.price) {
    setPlayerStats(prevStats => ({
      ...prevStats,
      [player]: {
        ...prevStats[player],
        money: prevStats[player].money - company.price
      }
    }));
    setCompanies(prevCompanies => ({
      ...prevCompanies,
      [companyName]: { ...company, owner: player }
    }));
	addBankMessages(`💼 ${player} købte ${companyName} for ${company.price.toLocaleString()} kr.`);
  // 🏦 Banken modtager pengene
    updateBank(+company.price, `Indtægt: ${player} købte ${companyName}`);
    setInvestmentMessage(`${player} har investeret i ${companyName}.`);
	setTimeout(() => setInvestmentMessage(""), 8000);
} else {
  setInvestmentMessage(`${player} har ikke nok penge til at investere i ${companyName}.`);
  setTimeout(() => setInvestmentMessage(""), 8000);
}
};
function checkAndApplyLoan(player, cashValue) {
  if (cashValue < 0) {
    const additionalLoan = Math.max(20000, -cashValue);
    cashValue += additionalLoan;

    // Opdater spillerens lån
    setPlayerLoans(prevLoans => ({
      ...prevLoans,
      [player]: (prevLoans[player] || 0) + additionalLoan
    }));

    // Tilføj bankMessage
    addBankMessages(`${player} lånte automatisk ${additionalLoan.toLocaleString()} kr.`);
    updateBank(-additionalLoan, `Yder lån til ${player}`);
  }
  return cashValue;
}
// Denne funktion trækker 'amount' fra spillerens cash og kalder herefter checkAndApplyLoan.
function subtractMoney(player, amount, stats) {
  stats[player].money -= amount;
  if (stats[player].money < 0) {
    stats[player].money = checkAndApplyLoan(player, stats[player].money);
  }
}
const globalActiveRaceHorses = players.flatMap(player => {
  // Brug den hest, spilleren har valgt, eller fallback til den første hest i deres stald
  const activeName = selectedRaceHorse[player] || (playerHorses[player] && playerHorses[player][0]?.name);
  if (!activeName) return []; // Hvis ingen hest findes, returner tom array
  // Find objektet for den aktive hest (for den enkelte spiller)
  return playerHorses[player].filter(horse => horse.name === activeName);
});

 // Gennemfør en runde i løbet
const nextRound = () => {
  if (raceWinner) return;
  const upcomingRound = currentRound + 1;
  setCurrentRound(prev => prev + 1);

  let newHorses = { ...playerHorses };
  let newStats = { ...playerStats };
  let newPlayerExtraBets = { ...playerExtraBets };
  let chanceMessages = [];
  let gallopMessages = [];
  let newPendingGalop = [...pendingGalopCards];
  let bankMessages = [];
  let standStillMessages = [];
  let haltFlag = haltAlreadyThisRace;
  
  players.forEach(player => {
    
    // ✅ NY KODE: mild handicap + aldersbonus
    // ------------------------------------------------------------------
    // 🎲 Basis-move (1–5)
    let move = Math.floor(Math.random() * 5) + 1;

    const activeHorseName = selectedRaceHorse[player];
    if (!activeHorseName) return;

    const activeIndex =
      playerHorses[player]?.findIndex(h => h.name === activeHorseName);
    if (activeIndex === -1) return;

    const horse = newHorses[player][activeIndex];

// 🏆 Mild sejrshandicap
const wins = horse.wins || 0;

    if (move >= 3 && wins > 0) {
      move -= 1;          // 4→3 og 5→4
    }
    if (move === 5 && wins > 1) {
      move -= 1;          // ekstra straf for 2+ sejre
    }

    // 🎂 Aldersbonus
    let ageBonus = 0;
    switch (horse.age) {
      case 3: ageBonus = 0.4; break;
      case 4: ageBonus = 0.7;   break;
      case 5: ageBonus = 1; break;
      default: ageBonus = 0;  break;
    }

    move = move + ageBonus;

    // afrund OPAD → bonus giver effekt
    move = Math.ceil(move);

    // sikkerhed
    move = Math.max(1, move);
    // ------------------------------------------------------------------

    let canMove = true;

// Løb 6:
// En hest med mindst én sejr står over i 1. og 2. runde.
// Det gælder KUN denne hest – de øvrige heste skal fortsætte.
if (derivedRaceIndex === 5) {
  canMove = upcomingRound > 2 || (horse.wins || 0) === 0;
} else {
  canMove = raceProgram[derivedRaceIndex].condition(
    horse,
    upcomingRound
  );
}

    if (canMove) {
      horse.position += move;
      horse.justMoved = true;

      // 🐎 Galopfelt
      if (galopFields.includes(horse.position)) {
        const galopCard = galopCards[Math.floor(Math.random() * galopCards.length)];
        gallopMessages.push(`${horse.name}${galopCard.text}`);

        const effect = galopCard.effect || 0;
        setTimeout(() => {
          horse.position += effect;
          setActiveHorses({ ...newHorses });
        }, 500);

        setTimeout(() => {
          const reset = { ...activeHorses };
          Object.values(reset).forEach(h => h.justMoved = false);
          setActiveHorses(reset);
        }, 300);

        newPendingGalop.push({ player, card: galopCard, basePosition: horse.position });
      }

    } else if (derivedRaceIndex === 5) {
      standStillMessages.push(
        `🛑 ${player}s hest ${horse.name} må stå over i denne runde.`
	)}
	
  // 🎲 Chancefelt
  if (chanceFields.includes(horse.position)) {
    const card = chanceCards[Math.floor(Math.random() * chanceCards.length)];
    const text = card.text;
    const amount = card.effect;

    const companyPayment = (companyKey, amount, fallbackName) => {
  const company = companies[companyKey];
  const receiver = company?.owner;

  subtractMoney(player, amount, newStats);

  if (receiver) {
    // Betaling til ejer
    newStats[receiver].money += amount;
    chanceMessages.push(`${player} betaler ${amount.toLocaleString()} kr. til ${receiver} ${fallbackName}`);
  } else {
    // Betaling til banken
    addBankMessages(`${player} betaler ${amount.toLocaleString()} kr. til banken ${fallbackName}`);
    updateBank(+amount, `Banken modtager betaling for ${fallbackName} fra ${player}`);
  }
};

    // 📥 BANKKORT
    if (text.startsWith("💰")) {
      if (text.includes("Krise")) {
        if (kriseUsedThisRace) {
          addBankMessages("😉 Krisen blev afværget – Det er jo ikke skatteopkrævning 😉.");
        }  else {
          setKriseUsedThisRace(true);
          let kriseMsg = "💥 Krise: Alle spillere mister 40% af deres kontanter, dog højst 200.000 kr.: 💥\n";
		  let totalIndtægt = 0;
          players.forEach(p => {
            const før = newStats[p].money;
   const tab = Math.min(Math.round(før * 0.40), 200000);
   newStats[p].money = checkAndApplyLoan(p, før - tab);
   const tabt = før - newStats[p].money;
			totalIndtægt += tabt;
            kriseMsg += `• ${p} mister ${kr(tabt)} kr.\n`;
          });
          addBankMessages(kriseMsg.trim());
		 updateBank(+totalIndtægt, `Krise: Banken modtager samlet`);
        }
      } else if (text.includes("Fremgang")) {
  if (fremgangUsedThisRace) {
    addBankMessages("📈 Fremgang: Kun en gang i hvert løb - Det er jo ingen gavebod! 💰");
  } else {
    setFremgangUsedThisRace(true);
	let totalUdbetaling = 0;
    const fremMsg = players.map(p => {
      const kontant = Math.max(0, newStats[p].money);
      const gevinst = Math.min(Math.max(Math.round(kontant * 0.40), 20000), 50000);
      newStats[p].money += gevinst;
	  totalUdbetaling += gevinst;
      return `• ${p} modtager ${kr(gevinst)} kr.`;
    }).join("\n");
    addBankMessages(`💰 Fremgang:\n${fremMsg}`);
	updateBank(-totalUdbetaling, `Fremgang: Banken udbetaler samlet`);
  }
  } else if (text.toLowerCase().includes("totosyndikatet giver afkast")) {
		if (totoPayoutGiven) {
    setShowTotoSharePopup({
      message: "💰 Totosyndikatet har allerede givet gevinst i dette løb.",
      updates: [],
      remainingBalance: totoSyndicate.balance || 0
    });
    return;
  }  
  // Beregn afkast nøjagtigt som før
  const totalShares = Object.values(totoShares.owners || {}).reduce((a,b)=>a+b,0);
  const totalBalance = totoSyndicate.balance || 0;
  if (totalShares === 0) {
    setShowTotoSharePopup({
      message: "💼 Ingen aktieejere – ingen udlodning denne gang.",
      updates: [],
      remainingBalance: totalBalance
    });
  } else if (totalBalance <= 100000) {
    setShowTotoSharePopup({
      message: "💼 Saldo under 100.000 kr. i Totosyndikatet – ingen udlodning denne gang.",
      updates: [],
      remainingBalance: totalBalance
    });
  } else {
    const payoutPerShare = totalBalance * 0.05;
    const remainingBalance = Math.max(0, totalBalance - payoutPerShare * totalShares);
    const newValues = { ...(totoShareValues || {}) };
    const updates = [];

    Object.entries(totoShares.owners).forEach(([pl, count]) => {
      const gain = payoutPerShare * count;
      newValues[pl] = (newValues[pl] || 0) + gain;
      updates.push(`${pl}: +${kr(gain)} kr. (${count} aktie${count>1?"r":""})`);
    });

    setTotoShareValues(newValues);
    setTotoSyndicate(prev => ({ ...(prev||{}), balance: remainingBalance }));
    setShowTotoSharePopup({
      message: "💰 Totosyndikatet udlodder gevinst, der indsættes på aktiekontoen!",
      updates,
      remainingBalance
    });
	setTotoPayoutGiven(true);
  }
  return;
} else if (text.includes("Staldtips")) {
  const leadingHorse = Object.values(newHorses)
    .flat()
    .reduce(
      (a, b) => (a?.position || 0) > (b?.position || 0) ? a : b,
      null
    );

  if (!leadingHorse) {
    addBankMessages(`${player} kunne ikke satse – ingen heste på banen.`);
  } else if (newStats[player].money < 1000) {
    addBankMessages(`👎🏼${player} har ikke råd til at satse på staldtips.`);
  } else {
    // 🔒 Bloker gentaget staldtip på samme hest i samme løb
    if (
      Array.isArray(newPlayerExtraBets[player]) &&
      newPlayerExtraBets[player][0] === leadingHorse.name
    ) {
      addBankMessages(
        `⚠️ ${player} har allerede sat staldtip på ${leadingHorse.name} i dette løb.🔒`
      );
      return;
    }

    // ✔️ Gennemfør satsning
    newStats[player].money -= 1000;
    newPlayerExtraBets[player] = [leadingHorse.name];

    setStaldtipsMessages(prev => [
      ...prev,
      `🍀 ${player} satser 1000 kr. på ${leadingHorse.name}. 🍀`
    ]);

    updateBank(+1000, `Banken modtager beløb for staldtips fra ${player}`);
  }
} else if (text.includes("halt")) {

        // ======================================================
        // 🔒 HÅRD SIKKERHED:
        // Kun ÉN hest må blive halt i hvert løb.
        //
        // haltLockRef bruges i stedet for kun React state,
        // fordi flere chancekort kan blive behandlet meget tæt
        // på hinanden/asynkront.
        // ======================================================

        if (haltLockRef.current || haltFlag) {
          addBankMessages(
            `❎ ${player}s hest fortsætter i løbet – én hest er allerede udgået i dette løb.❎`
          );
          return;
        }

        // Lås straks – før nogen async/state-opdatering kan nå
        // at blive udført.
        haltLockRef.current = true;
        haltFlag = true;
        setHaltAlreadyThisRace(true);

        const stable = newHorses[player] || [];
        const injuredHorseIndex =
          stable.findIndex(
            h => h.name === activeHorseName
          );

        if (injuredHorseIndex === -1) {
          // Hvis hesten ikke længere findes, må vi ikke lave
          // en ny halt-hændelse.
          return;
        }

        const injuredHorse =
          stable[injuredHorseIndex];

        // --- Sælger/fjerner den halte hest fra stalden
        newHorses[player] =
          stable.filter(
            h => h.name !== activeHorseName
          );

        // --- Fjern forsikringstegningen
        const isInsured =
          !!insuredHorses[activeHorseName];

        delete insuredHorses[activeHorseName];

        const totalErstatning =
          isInsured ? 50000 : 5000;

        let bankMessage = "";

        // --- Eksisterende erstatningslogik bevares
        const forsikringsEntry =
          Object.entries(companies).find(
            ([name]) =>
              name.includes("Galopforsikring")
          );

        if (isInsured) {

          if (forsikringsEntry) {

            const [navn, info] =
              forsikringsEntry;

            const ejer = info.owner;

            let ejerBetaling = 0;

            if (ejer) {

              // Forsikringsselskabets ejer betaler
              // maksimalt 10.000 kr.
              ejerBetaling = Math.min(
                10000,
                newStats[ejer]?.money || 0
              );

              newStats[ejer].money -=
                ejerBetaling;

              newStats[player].money +=
                ejerBetaling;

              addBankMessages(
                `🏦 ${ejer} betaler Galopforsikring ApS´s andel af erstatning ${ejerBetaling.toLocaleString()} kr. til (${navn}).`
              );

              // Banken betaler resten
              const bankBetaling =
                totalErstatning -
                ejerBetaling;

              newStats[player].money +=
                bankBetaling;

              updateBank(
                -bankBetaling,
                `Banken udbetaler erstatningen til ${player}`
              );

              bankMessage =
                `✅ Forsikringen dækker: ${player} modtager i alt ${totalErstatning.toLocaleString()} kr.
( ${ejer} betaler ${ejerBetaling.toLocaleString()} kr. i erstatningsandel – banken betaler ${kr(bankBetaling)} kr. )`;

            } else {

              // Banken ejer forsikringen
              newStats[player].money +=
                totalErstatning;

              updateBank(
                -totalErstatning,
                `Banken udbetaler hele erstatningen til ${player}`
              );

              bankMessage =
                `✅ Banken ejer forsikringsselskabet og betaler hele erstatningen på ${totalErstatning.toLocaleString()} kr.`;
            }

          } else {

            // Ingen ejer fundet
            newStats[player].money +=
              totalErstatning;

            updateBank(
              -totalErstatning,
              `Banken dækker hele erstatningen til ${player}`
            );

            bankMessage =
              `✅ Forsikringen dækker (ingen ejer) – ${totalErstatning.toLocaleString()} kr.`;
          }

        } else {

          // Uforsikret hest
          newStats[player].money +=
            totalErstatning;

          updateBank(
            -totalErstatning,
            `Banken betaler erstatning for uforsikret hest`
          );

          bankMessage =
            `❌ Hesten var ikke forsikret – ${totalErstatning.toLocaleString()} kr. udbetales fra banken.`;
        }

        // ======================================================
        // 🛑 Hesten fjernes fra det aktuelle løb
        //
        // MEN:
        // - spilleren bliver i løbet
        // - playerBets beholdes
        // - playerExtraBets beholdes
        // - ingen ny hest indsættes
        // ======================================================

        addBankMessages(
          `🛑 ${player}s hest ${activeHorseName} er halt og tages ud af løbet.`
        );

        addBankMessages(bankMessage);

        setSelectedRaceHorse(prev => {
          const copy = { ...(prev || {}) };

          if (
            copy[player] &&
            copy[player] === activeHorseName
          ) {
            delete copy[player];
          }

          return copy;
        });

        setActiveHorses(prev => {
          const copy = { ...(prev || {}) };

          if (
            copy[player] &&
            copy[player].name === activeHorseName
          ) {
            delete copy[player];
          }

          return copy;
        });

        // Popup med info om halt hest
        setShowHaltPopup({
          player,
          horseName: activeHorseName,
          wasInsured: isInsured,
          insurancePaid: totalErstatning,
          chanceText: text,
          bankInfo: bankMessage
        });

        // Ingen anden hest sættes ind i dette løb.
        return;
      } else {
        // Simpel bankeffekt
        if (amount < 0) {
    // Spilleren betaler → banken modtager
    const payment = -amount;
    subtractMoney(player, payment, newStats);
    addBankMessages(`${player} betaler ${payment.toLocaleString()} kr. ${text}`);
    updateBank(+payment, `Banken modtager betaling fra ${player}`);
}

else if (amount > 0) {
    // Spilleren modtager → banken betaler
    newStats[player].money += amount;
    addBankMessages(`${player} modtager ${amount.toLocaleString()} kr. ${text}`);
    updateBank(-amount, `Banken betaler overskud/gevinst til ${player}`);
}
      }  
    } else if (text.endsWith("💰")) {
      if (text.includes("Dyrlægeregning")) {
        companyPayment("⚕️ Dyrlægegården A/S", 6000, "for regning til Dyrlægegården A/S");
      } else if (text.includes("Stald-leje")) {
        companyPayment("🐴 Galopstald A/S", 5500, "for staldleje hos Galopstald A/S");
      } else if (text.includes("Jockeybetaling")) {
        companyPayment("🏇🏼 Jockeytjenesten A/S", 6500, "for ryttergebyr til Jockeytjenesten A/S");
      } else if (text.includes("Banen må repareres")) {
        companyPayment("🥬 Horsetrack & Stable A/S", 8500, "for banereparation til Horsetrack & Stable A/S");
      } else if (text.includes("Galoptidende")) {
        companyPayment("📰 Galoptidende A/S", 2000, "for salgsannonce til Galoptidende A/S");
      } else if (text.includes("BornTAXI ApS")) {
        companyPayment("🚕 BornTAXI ApS", 1000, "for TAXI kørsel til BornTAXI ApS");
      } else if (text.includes("Pokaler")) {
        companyPayment("⏱️ Præmier og Pokaler A/S", 3000, "for pokaler fra Præmier og Pokaler A/S");
      } else if (text.includes("spisning")) {
        companyPayment("🥐 Restaurant Hesteskoen A/S", 8000, "for middagsselskab hos Restaurant Hesteskoen A/S");
      } else if (text.includes("Hestepleje")) {
        companyPayment("🐴 Hestepleje og foder A/S", 4000, "for seletøj hos Hestepleje og foder A/S");
      } else if (text.includes("Handelsplads")) {
        companyPayment("🐴 Hesteagenturet A/S", 6700, "for handelsplads hos Hesteagenturet A/S");
      } else if (text.includes("Hestepærer")) {
        companyPayment("🚮 Hestepærer Affald A/S", 4500, "for håndtering af affald til Hestepærer Affald A/S");
      } else if (text.includes("Ryttershoppen")) {
        companyPayment("👖 Ryttershoppen A/S", 4000, "for ny beklædning hos Ryttershoppen A/S");
	  } else if (text.includes("Trænertjenesten")) {
        companyPayment("🐴 Trænertjenesten A/S", 7000, "for træning hos Trænertjenesten A/S");
      } else {
        // fallback
        if (amount < 0) {
          subtractMoney(player, -amount, newStats);
          chanceMessages.push(`${player} betaler ${(-amount).toLocaleString()} kr. ${text}`);
        } else if (amount > 0) {
          newStats[player].money += amount;
          chanceMessages.push(`${player} modtager ${amount.toLocaleString()} kr. ${text}`);
        }
      }
    }

    // 🤷‍♀️ Øvrige tekstkort
    else {
        chanceMessages.push(`${player}: ${text}`);
      
    }
  }
});
   
  // Vindertjek
const finishedPlayers = players.filter(player => {
  const name = (selectedRaceHorse[player] || "").trim();
  if (!name) {
    return false;
  }
  const horse =
    newHorses[player]?.find(
      h => h.name === name
    );
  return (
    horse &&
    horse.position >= trackLength
  );
});
const baseBet = 500;
if (finishedPlayers.length > 0) {
  const sortedFinished = [...finishedPlayers].sort((a, b) => {
  const nameA = (selectedRaceHorse[a] || "").trim();
  const nameB = (selectedRaceHorse[b] || "").trim();
    const horseA = newHorses[a]?.find(h => h.name === nameA);
    const horseB = newHorses[b]?.find(h => h.name === nameB);
    const posA = horseA?.position || 0;
    const posB = horseB?.position || 0;

    // 1) højeste position først
    if (posB !== posA) return posB - posA;

    // 2) tie-break: honnør rækkefølge (🍀) — den der ligger tidligst efter firstPlayerIndex vinder
    const orderA = (players.indexOf(a) - firstPlayerIndex + players.length) % players.length;
    const orderB = (players.indexOf(b) - firstPlayerIndex + players.length) % players.length;
    return orderA - orderB;
  });

  const winner = sortedFinished[0];
  const winnerHorseName = (selectedRaceHorse[winner] || "").trim();
  const horseColor = horseColors[winnerHorseName] || "⚫";
  const winnerHorse = newHorses[winner]?.find(h => h.name.trim() === winnerHorseName);

  const totalPrize = firstPrize + secondPrize + thirdPrize + forthPrize;

  setRaceWinner(winner);
  
  setPlayerHorses(newHorses);
setActiveHorses(
  players.reduce((acc, p) => {
    const h = newHorses[p]?.find(hh => hh.name === selectedRaceHorse[p]);
    if (h) acc[p] = h;
    return acc;
  }, {})
);

  // Beregn odds baseret på forskel mellem vinder og nr. 2
  let odds = 20;
let diff = 0;

// Find alle heste med deres aktuelle position
const allHorses = players
  .map(p => {
    const horseName =
      (selectedRaceHorse[p] || "").trim();

    if (!horseName) {
      return null;
    }

    const horseObj =
      newHorses[p]?.find(
        h => h.name === horseName
      );

    if (!horseObj) {
      return null;
    }

    return {
      player: p,
      position: horseObj.position || 0
    };
  })
  .filter(Boolean);

// Sortér efter position (højeste først)
const sortedByPos = [...allHorses].sort((a, b) => b.position - a.position);

if (sortedByPos.length > 1) {
  const winnerPos = sortedByPos[0].position;
  const secondPos = sortedByPos[1].position;
  diff = Math.max(0, winnerPos - secondPos);

  // Odds: starter ved 25 når hestene er side om side, falder 1 pr. felt afstand
  odds = Math.max(5, Math.min(25, 25 - diff));
}
  setRaceOdds(odds);

  // Byg raceMessage (præmier + odds)
  let raceMessage = `<div style='text-align:center; color:#AD8C22; font-weight:bold; font-size:26px; margin-bottom:8px;'>
💰 Samlet præmiesum for løbet: ${totalPrize.toLocaleString()} kr.💰
</div>`;
  raceMessage += `Tillykke med sejren til ${winner}, med ${horseColor} hjelmfarve.\n🥇 ${winnerHorseName} vinder løbet og ${winner} modtager førstepræmien på ${firstPrize.toLocaleString()} kr.`;
  // Opdater vinderens stats (som før)
  newStats[winner].wins += 1;
  newStats[winner].money += firstPrize;

  // Opdater vinderens hest (som før)
  newHorses[winner] = newHorses[winner].map(h => {
    if (h.name.trim().toLowerCase() === winnerHorseName.toLowerCase()) {
      return { ...h, wins: h.wins + 1, price: Math.floor(h.price * 1.25) };
    }
    return h;
  });
updateBank(-totalPrize, `Udbetalt samlet præmiesum`);
  // Beregn 2.,3.,4. pladser + præmier (lad din eksisterende logik køre uændret)
   let remainingPlayers = players.filter(p => {
    if (p === winner) {
      return false;
    }

    const horseName =
      (selectedRaceHorse[p] || "").trim();

    if (!horseName) {
      return false;
    }

    const horse =
      newHorses[p]?.find(
        h => h.name === horseName
      );

    return !!horse;
  });

  remainingPlayers.sort((a, b) => {
    const horseA =
      newHorses[a]?.find(
        h =>
          h.name ===
          (selectedRaceHorse[a] || "")
      );

    const horseB =
      newHorses[b]?.find(
        h =>
          h.name ===
          (selectedRaceHorse[b] || "")
      );

    // Hent positionerne fra de faktisk valgte løbsheste
    const posA = horseA?.position || 0;
    const posB = horseB?.position || 0;

    // 1) Højeste position først
    if (posA !== posB) {
      return posB - posA;
    }

    // 2) Tie-break: honnør rækkefølge
    const indexA =
      (players.indexOf(a) -
        firstPlayerIndex +
        players.length) %
      players.length;

    const indexB =
      (players.indexOf(b) -
        firstPlayerIndex +
        players.length) %
      players.length;

    return indexA - indexB;
  });

  if (remainingPlayers.length >= 1) {
    const second = remainingPlayers[0];

    const secondHorseName =
      (selectedRaceHorse[second] || "").trim();

    raceMessage +=
      `\n🥈 ${secondHorseName} bliver nummer 2 og ${second} modtager andenpræmien på ${secondPrize.toLocaleString()} kr.`;

    newStats[second].money += secondPrize;
  }

  if (remainingPlayers.length >= 2) {
    const third = remainingPlayers[1];

    const thirdHorseName =
      (selectedRaceHorse[third] || "").trim();

    raceMessage +=
      `\n🥉 ${thirdHorseName} bliver nummer 3 og ${third} modtager tredjepræmien på ${thirdPrize.toLocaleString()} kr.`;

    newStats[third].money += thirdPrize;
  }

  if (remainingPlayers.length >= 3) {
    const forth = remainingPlayers[2];

    const forthHorseName =
      (selectedRaceHorse[forth] || "").trim();

    raceMessage +=
      `\n🎖️ ${forthHorseName} bliver nummer 4 og ${forth} modtager fjerdepræmien på ${forthPrize.toLocaleString()} kr.`;

    newStats[forth].money += forthPrize;
  }

  if (finishedPlayers.length > 1) {
    raceMessage +=
      `\n\n🏁 Flere heste nåede målstregen samtidigt eller er på linje. ${winner} havde honnøren og vinder!`;
  }

  // Opdater UI-beskeder og totalisator-gevinster (brug din eksisterende logik videre)
  setWinningMessage(raceMessage);

  // Totalisator / farvesats beregning
  let updatedStats = { ...newStats };
  let winnersList = [];

  players.forEach(player => {
    const betHorse = (playerBets[player] || "").trim().toLowerCase();
    const stableTip = ((playerExtraBets[player] && playerExtraBets[player][0]) || "").trim().toLowerCase();
    const winHorseLower = winnerHorseName.trim().toLowerCase();

    let totalPayout = 0;
    let payoutDetails = [];

    if (betHorse === winHorseLower) {
      const payout = baseBet * odds;
      totalPayout += payout;
      payoutDetails.push(`egen hest ${payout.toLocaleString()} kr.`);
    }
    if (stableTip === winHorseLower) {
      const payout = baseBet * 4 * odds;
      totalPayout += payout;
      payoutDetails.push(`staldtip ${payout.toLocaleString()} kr.`);
    }
    const playerColor = playerColors[player];
    const winningColor = horseColors[winnerHorseName];
    if (playerColor && winningColor && playerColor === winningColor) {
      const payout = baseBet * odds;
      totalPayout += payout;
      payoutDetails.push(`jockeyfarve ${payout.toLocaleString()} kr.`);
    }

    if (totalPayout > 0) {
      if (!updatedStats[player]) updatedStats[player] = { money: 0, wins: 0 };
      updatedStats[player].money += totalPayout;
      winnersList.push(`${player} (${payoutDetails.join(", ")}, i alt ${totalPayout.toLocaleString()} kr.)`);
      if (typeof addBankMessages === "function") {
        addBankMessages(`💰 ${player} modtager ${totalPayout.toLocaleString()} kr. (odds ${odds})`);
		updateBank(-totalPayout, `Banken udbetaler gevinst til ${player}`);
      }
    }
  });
  setPlayerStats(updatedStats);
  if (winnersList.length > 0) {
    setBetWinnersMessage(
  `<div>🪙 <span style="font-size: 24px;">Totalisatorgevinst til odds: ${odds}</span></div>
   <div style="font-size: 20px;">${winnersList.join("<br>")}</div>`
);
  } else {
    setBetWinnersMessage("Ingen totalisatorgevinst i dette løb.");
  }
  
 // 🎯 Beregn Totosyndikatets gevinst efter løbet
const betThisRace = totoSyndicate.betsByRace[currentRace];
if (betThisRace) {
  let payout = 0;
  const winnerColor = horseColors[winnerHorseName];
  
  if (betThisRace.colors.includes(winnerColor)) {
    // Brug samme odds som spillerne
    payout = Math.round(betThisRace.amount * odds);
  }

  const net = payout - betThisRace.amount;

  setTotoSyndicate(prev => ({
    ...prev,
    balance: prev.balance + payout,
    history: prev.history.map(h =>
      h.race === currentRace ? { ...h, payout, net } : h
    )
  }));

  if (payout > 0) {
    addBankMessages(
      `💰 Totosyndikatet vandt ${kr(payout)} kr. på farve ${winnerColor}!`
    );
	updateBank(-payout, `Banken udbetaler til Totosyndikatet`);
  } else {
    addBankMessages(`🎲 Totosyndikatet tabte denne omgang.`);
  }
}

// 💶 Udbetal rente på obligationer efter hvert løb
if (Object.keys(obligations.owners).length > 0) {
  const newStats = { ...playerStats };
  let msg = "💶 Obligationsrente:\n";
  let totalPayout = 0; // 👈 Samler bankens samlede renteudgift

  Object.entries(obligations.owners).forEach(([player, count]) => {
    if (!newStats[player]) return; // sikkerhed
    const payout = count * obligations.interest;
    newStats[player].money += payout;
    totalPayout += payout; // 👈 læg beløbet til bankens udgift
    msg += `• ${player}: ${payout.toLocaleString()} kr. (${count} stk.)\n`;
  });

  setPlayerStats(newStats);
  addBankMessages(msg.trim());
  updateBank(-totalPayout, `Banken udbetaler renter på obligationer `);
}
}  
  // Vis beskeder
  const allGalopText = [...gallopMessages, ...standStillMessages].join("\n");
if (allGalopText) {
  addGallopMessages(allGalopText);
}
if (chanceMessages.length > 0) {
  showChanceMessage(chanceMessages.join("\n"));
}
if (bankMessages.length > 0) {
  bankMessages.forEach(msg => {
    addBankMessages(msg); // styrer selv fading + fjernelse
  });
}

  	// ➕ Tilskriv renter til alle spillere efter løbet
if (interestAppliedRace !== currentRace) {
  setPlayerLoans(prev => {
    const updated = {};
    players.forEach(player => {
      const oldLoan = prev[player] || 0;
      if (oldLoan > 0) {
  const newLoan = Math.round(oldLoan * 1.025);
  updated[player] = newLoan;
  const rente = newLoan - oldLoan;
  addLoanInterestMessage(
    `💸 ${player}s lån er blevet tillagt ${kr(rente)} kr. i renter`
  );
  // 🏦 Banken får renteindtægt //updateBank(+rente, `Renteindtægt fra ${player}`);
} else {
        updated[player] = 0;
      }
    });
    return updated;
  });
  setInterestAppliedRace(currentRace); // husk at vi har kørt renter for dette løb
  }
  // Opdater state samlet – alle ændringer i newHorses, newStats osv. bliver nu sat
  setPlayerHorses(newHorses);
  setPlayerStats(newStats);
  setPlayerExtraBets(newPlayerExtraBets);
  setPendingGalopCards(newPendingGalop);
  setCurrentRound(prev => prev + 1);
};
  // Starter næste løb – her roterer vi firstPlayerIndex, så en anden spiller får førsteretten
const startNextRace = () => {
  payInterestsAndDividends();  // renter og hotelafkast
  payInsurancePremiums();
  setTotoPayoutGiven(false);
  setFinalInterestPaid(true);
  haltLockRef.current = false;
  setHaltAlreadyThisRace(false);
  setHaltOccurred(false);
  if (currentRace >= totalRaces) {
    setGameOver(true);
    return;
  }
  // 1️⃣ Ryk ALLE heste i stalden (fjern fra banen)
  setSelectedRaceHorse({});
  setActiveHorses({});

  // 2️⃣ Nulstil heste-positioner
  const resetHorses = { ...playerHorses };
  for (const player in resetHorses) {
    resetHorses[player] = resetHorses[player].map(hest => ({
      ...hest,
      position: 0,
    }));
  }
  setPlayerHorses(resetHorses);

  // 3️⃣ Nulstil diverse løbsdata
  setRaceWinner(null);
  setWinningMessage("");
  setBetWinnersMessage("");
  setCurrentRound(0);
  setPlayerBets({});
  setPlayerExtraBets({});
  setRaceStarted(false);

  // 🎟️ Lodtrækning om Andelsbankens købsret i dette løb.
  // En spiller, der allerede har købt i dag, kan ikke trækkes igen.
  const andelsLotteryPlayer = drawAndelsBankBuyer(
    andelsBank.owners || {}
  );

  setAndelsBank(prev => ({
    ...prev,
    lotteryPlayer: andelsLotteryPlayer
  }));

  if (andelsLotteryPlayer) {
    addBankMessages(
      `🎟️ Andelsbanken: ${andelsLotteryPlayer} er udtrukket og får mulighed for at købe 1 andel i dette løb.`
    );
  }

  // 4️⃣ Skift til næste løb
setCurrentRace(prev => prev + 1);
setFirstPlayerIndex(prev => (prev + 1) % players.length);
setRaceCount(prev => prev + 1);

  // 5️⃣ VIS dropdown-formular – først her får vi hestene ud af stalden igen
  setShowBetForm(true);
};
  
const repayLoan = (player, amount) => {
  // Sikring: ugyldige værdier
  if (!player || isNaN(amount) || amount <= 0) return;

  // Sørg for ikke at afdrage mere end lånesaldoen
  const currentLoan = playerLoans[player] || 0;
  const payment = Math.min(amount, currentLoan);

  if (payment <= 0) {
    addBankMessages(`ℹ️ ${player} har ingen gæld at afdrage.`);
    return;
  }

  // 💸 Spilleren betaler – træk penge fra spillerens konto
  setPlayerStats(prevStats => ({
    ...prevStats,
    [player]: {
      ...prevStats[player],
      money: prevStats[player].money - payment
    }
  }));

  // 🔄 Reducer lånet
  setPlayerLoans(prevLoans => ({
    ...prevLoans,
    [player]: Math.max(0, (prevLoans[player] || 0) - payment)
  }));

  // 🏦 Banken får pengene (positiv bevægelse)
  updateBank(+payment, `Afdrag på lån fra ${player} (${payment.toLocaleString()} kr.)`);

  // 💬 Besked i Derby Banken
  addBankMessages(`💸 ${player} har afdraget ${payment.toLocaleString()} kr. på sit lån.`);
};

const [repayPlayer, setRepayPlayer] = useState("");
const [repayAmount, setRepayAmount] = useState("");

  // -------------------------------------------------------
  // TRÆK EN ANDELSBANK-KØBER FØR HVERT LØB
  // -------------------------------------------------------
  const drawAndelsBankBuyer = (owners = {}) => {
    const sold = Object.values(owners).reduce(
      (sum, count) => sum + count,
      0
    );

    if (sold >= 6) return null;

    const eligiblePlayers = players.filter(
      player => !owners[player]
    );

    if (eligiblePlayers.length === 0) return null;

    return eligiblePlayers[
      Math.floor(Math.random() * eligiblePlayers.length)
    ];
  };

  // -------------------------------------------------------
  // START NÆSTE LØBSDAG – samme sæson
  // -------------------------------------------------------
  const startNextRaceDay = () => {
    if (seasonHistory.length >= seasonLength) {
      startNewSeason();
      return;
    }

    // Kun netto kontanter videreføres. Gæld nulstilles til 0.
    const nextStats = {};
    players.forEach(player => {
      const money = playerStats[player]?.money || 0;
      const loan = playerLoans[player] || 0;

      nextStats[player] = {
        ...(playerStats[player] || {}),
        money: money - loan,
        wins: 0
      };
    });

    // Hestene er dagsbaserede og tildeles på ny.
    const nextHorses = {};
    const nextRaceHorses = {};
    const nextBets = {};
    let available2YearHorses = [...(shuffledHorsesByAge[2]?.names || [])];

    players.forEach(player => {
      nextHorses[player] = [];

      const horseName = available2YearHorses.shift();
      if (!horseName) return;

      const horse = {
        name: horseName,
        age: 2,
        wins: 0,
        price: shuffledHorsesByAge[2]?.price || 20000,
        position: 0
      };

      nextHorses[player].push(horse);
      nextStats[player].money -= horse.price;
      nextRaceHorses[player] = horse.name;
      nextBets[player] = horse.name;
    });

    // Bankens normale startsaldo + den del af Andelsbanken,
    // som ikke blev udbetalt på den foregående løbsdag.
    const bankStart = players.length * 28000 * totalRaces;
    const carryover = Math.max(0, andelsBankCarryover || 0);
    const bankStartWithCarryover = bankStart + carryover;

    setBankBalance(bankStartWithCarryover);
    setBankLog([
      `🏦 Andelsbanken starter med saldo: ${bankStart.toLocaleString()} kr. (${totalRaces} løb × ${players.length} spillere)` +
       (carryover > 0 ? ` + ${kr(carryover)} kr. fra den overførte banksaldo` : "")
    ]);

    setCurrentRace(1);
    setCurrentRaceIndex(0);
    setCurrentRound(0);
    setRaceWinner(null);
    setRaceStarted(false);
    setRaceCount(0);
    setShownRaces([]);
    setActiveHorses({});
    setRaceOdds({});
    setPlayerStats(nextStats);
    setPlayerLoans(Object.fromEntries(players.map(player => [player, 0])));
    setPlayerHorses(nextHorses);
    setHorseWins({});
    setSelectedRaceHorse(nextRaceHorses);
    setSelectedBets(nextBets);
    setPlayerBets({});
    setPlayerExtraBets({});
    setSelectedAge(2);

    // Dagsdata nulstilles.
    setInsuredPlayersThisRace({});
    setInsuredHorses({});
    setInsuranceMessages([]);
    setGallopMessages([]);
    setChanceMessages([]);
    setFadeOutChance(false);
    setPendingGalopCards([]);
    setHaltOccurred(false);
    setHaltAlreadyThisRace(false);
    setKriseUsedThisRace(false);
    setFremgangUsedThisRace(false);
    setLoanMessages([]);
    setBonusGiven({});
    setRaceInfoShown(false);
    setStaldtipsMessages([]);
    setInvestmentMessage("");
    setShowRaceView(false);
    setShowBetForm(false);
    setShowSeasonBox(false);
    setGameOver(false);
    setTotoPayoutGiven(false);

    // Toto-aktier er dagsbaserede.
    setTotoShares({
      total: 10,
      owners: {}
    });
    setTotoShareValues({});
    setTotoSyndicate(prev => ({
      ...prev,
      balance: 0,
      history: []
    }));

    // Andelsbanken er også dagsbaseret: 6 nye andele hver løbsdag.
    // Kun carryover føres videre – ikke ejerskab eller aktieværdier.
    const firstAndelsLotteryPlayer =
      players.length > 0
        ? players[Math.floor(Math.random() * players.length)]
        : null;

    setAndelsBank({
      total: 6,
      price: 50000,
      owners: {},
      boughtThisRace: {},
      lotteryPlayer: firstAndelsLotteryPlayer
    });
    setAndelsBankShareValues({});
    setAndelsBankCarryover(0);

    // Selskabernes ejere ændres IKKE – de gælder hele sæsonen.
    setGameStarted(true);
  };
  // -------------------------------------------------------
  // START HELT NY SÆSON
  // -------------------------------------------------------
  const startNewSeason = () => {
    localStorage.removeItem("derbySeason");
    localStorage.removeItem("derbySave");

    setSeasonHistory([]);
    setSeasonResults([]);

    // Alt spiller-/dagdata nulstilles.
    setPlayers([]);
    setAiPlayers([]);
    setPlayerName("");
    setNumPlayers(4);
    setLoadedFromSave(false);
    setPlayerStats({});
    setPlayerLoans({});
    setPlayerHorses({});
    setHorseWins({});
    setSelectedRaceHorse({});
    setSelectedBets({});
    setPlayerBets({});
    setPlayerExtraBets({});
    setPlayerColors({});
    setHorseColors({});
    setBonusGiven({});
    setSelectedAge(2);

    // Selskabernes ejerskab nulstilles ved ny sæson,
    // men selskabernes navne, priser, gebyrer og billeder bevares.
    setCompanies(prev =>
      Object.fromEntries(
        Object.entries(prev).map(([name, company]) => [
          name,
          { ...company, owner: null }
        ])
      )
    );

    setObligations({
      total: 24,
      price: 25000,
      interest: 1000,
      owners: {},
      image: "https://bornholm-golf.dk/derby/static/obligation.png"
    });
    setTotoShares({
      total: 10,
      owners: {}
    });
    setTotoShareValues({});
    setTotoSyndicate(prev => ({
      ...prev,
      balance: 0,
      history: []
    }));
    setAndelsBank({
      total: 6,
      price: 50000,
      owners: {},
      boughtThisRace: {},
      lotteryPlayer: null
    });
    setAndelsBankShareValues({});
    setAndelsBankCarryover(0);

    setCurrentRace(1);
    setCurrentRaceIndex(0);
    setCurrentRound(0);
    setRaceCount(0);
    setRaceWinner(null);
    setRaceStarted(false);
    setGameOver(false);
    setShowRaceView(false);
    setShowBetForm(false);
    setShowSeasonBox(false);
    setBankBalance(0);
    setBankLog([]);
	 // En ny sæson skal starte på opstartsskærmen, så spillerne
    // igen kan vælge spillere/AI og sæsonens løbsindstillinger,
    // før første løbsdag og de nye heste oprettes.
    setGameStarted(false);
  };

  // Bevar eksisterende kald andre steder i spillet.
  const resetGame = startNextRaceDay;

  // Returnerer en sorteret resultatliste (baseret på formue)
const getResultsList = () => {
  return players.map(player => {
    const stats = playerStats[player] || {};
    const money = stats.money || 0;
    const loan = playerLoans[player] || 0;

    // 🐎 Hesteværdi
    const horses = [
      ...new Map(
        (playerHorses[player] || []).map(h => [h.name, h])
      ).values()
    ];

    const horsesValue = horses.reduce((sum, h) => {
      const age = h.age ?? 2;
      const wins = h.wins ?? 0;

      const basePrice =
        shuffledHorsesByAge?.[age]?.price ??
        horseStartPrice?.[age] ??
        h.price ??
        20000;

      return (
        sum +
        Math.round(
          basePrice * Math.pow(1.25, wins) * 1.10
        )
      );
    }, 0);

    // 🎯 Selskaber
    const entries = Object.entries(companies).filter(
      ([_, info]) => info.owner === player
    );

    const companyValue = entries
      .filter(([name]) => !name.includes("💰"))
      .reduce(
        (sum, [_, info]) =>
          sum + Math.round(info.price * 0.75),
        0
      );

    const bondValue = entries
      .filter(([name]) => name.includes("💰"))
      .reduce(
        (sum, [_, info]) =>
          sum + Math.round(info.price * 0.80),
        0
      );

    // 💶 Obligationer
    const numBonds =
      obligations?.owners?.[player] || 0;

    const bondsValue = Math.round(
      numBonds *
        (obligations?.price || 25000) *
        0.80
    );

    // 💼 TOTO – kun dagens afkast tæller
    const totoValue =
      totoShareValues?.[player] || 0;

    // 🏦 Andelsbanken – KUN AFKASTET TÆLLER
    const andelsBankTotalValue =
      andelsBankShareValues?.[player] || 0;

    // 🏦 Kun gevinsten fra bankens saldo tæller.
    // Købsprisen på 50.000 kr. er allerede betalt ved købet
    // og skal ikke indgå i spillerens formue.
    const andelsBankValue = andelsBankTotalValue;

    // 💼 Samlet investering
    const investment =
      companyValue +
      bondValue +
      bondsValue +
      totoValue +
      andelsBankValue;

    // 💰 Samlet formue
    const totalWealth =
      money +
      investment +
      horsesValue -
      loan;

    return {
      name: player,
      cash: money,
      netCash: money - loan,
      investment,
      companyValue,
      secureInvestmentValue: bondValue,
      obligationValue: bondsValue,
      bondValue: bondValue + bondsValue,
      shareValue: totoValue,

      // 🏦 Kun Andelsbankens AFKAST
      andelsBankValue,

      horsesValue,
      debt: loan,
      totalWealth,

      // Dagens heste + dagens TOTO-afkast
      // + dagens Andelsbank-afkast.
      seasonDayValue:
        horsesValue +
        totoValue +
        andelsBankValue
    };
  }).sort(
    (a, b) => b.totalWealth - a.totalWealth
  );
};

// Bestemmer den samlede vinder baseret på formue
const getOverallWinner = () => {
  const results = getResultsList();
  const winner = results[0];
  return winner
    ? `🏆 ${winner.name} vinder løbsdagen med en formue på ${Math.round(winner.totalWealth).toLocaleString()} kr. 🏆`
    : "Ingen vinder";
};

useEffect(() => {
  if (!gameOver) return;
// -------------------------------------------------------
// 1) TOTOSYNDIKAT
// -------------------------------------------------------
const totoOwners = totoShares.owners || {};
const totalTotoShares = Object.values(totoOwners).reduce(
  (a, b) => a + b,
  0
);
const totoBalanceBefore =
  Number(totoSyndicate.balance) || 0;

let newShareValues = {
  ...(totoShareValues || {})
};
let remainingTotoBalance =
  totoBalanceBefore;
let finalBankBalance =
  Number(bankBalance) || 0;
// -------------------------------------------------------
// TOTO-GEVINST
// -------------------------------------------------------

if (
  totalTotoShares > 0 &&
  totoBalanceBefore > 0
) {
  const payoutPerShare =
    totoBalanceBefore * 0.05;
  const totalTotoPayout =
    payoutPerShare * totalTotoShares;
  remainingTotoBalance =
    Math.max(
      0,
      totoBalanceBefore - totalTotoPayout
    );
  Object.entries(totoOwners).forEach(
    ([pl, count]) => {
      const gain =
        payoutPerShare * count;
      newShareValues[pl] =
        (newShareValues[pl] || 0) + gain;
    }
  );
  // Restsaldoen fra TOTO føres tilbage til banken.
  if (remainingTotoBalance > 0) {
    finalBankBalance +=
      remainingTotoBalance;
    addBankMessages(
      `🏦 ${kr(remainingTotoBalance)} kr. fra Totosyndikatet føres tilbage til Derby Banken.`
    );
    remainingTotoBalance = 0;
  }
}
// -------------------------------------------------------
// INGEN TOTO-AKTIER SOLGT
// Hele TOTO-puljen føres tilbage til banken.
// -------------------------------------------------------
else if (
  totalTotoShares === 0 &&
  totoBalanceBefore > 0
) {
  finalBankBalance +=
    totoBalanceBefore;
  addBankMessages(
    `🏦 ${kr(totoBalanceBefore)} kr. fra Totosyndikatet føres tilbage til Derby Banken, da ingen TOTO-aktier blev solgt.`
  );

  remainingTotoBalance = 0;
}
setTotoShareValues(
  newShareValues
);
setTotoSyndicate(prev => ({
  ...prev,
  balance: remainingTotoBalance
}));

  // -------------------------------------------------------
// 2) ANDELSBANK 
// -------------------------------------------------------

const andelsOwners = andelsBank?.owners || {};

const totalAndelsSold = Object.values(andelsOwners).reduce(
  (a, b) => a + b,
  0
);

const andelsBankStartBalance = finalBankBalance;

// Her gemmes den FAKTISKE slutværdi af spillerens andele.
// De 50.000 kr. som blev betalt ved køb, skal IKKE
// lægges til igen her.
const newAndelsBankShareValues = {};

let remainingAndelsBankBalance =
  andelsBankStartBalance;


// -------------------------------------------------------
// BEREGN ANDELSBANKENS UDBETALING
// -------------------------------------------------------

if (
  totalAndelsSold > 0 &&
  andelsBankStartBalance > 0
) {

  // 15 % af bankens aktuelle saldo pr. solgt andel.
  const payoutPerShare =
    andelsBankStartBalance * 0.15;

  const totalAndelsPayout =
    payoutPerShare * totalAndelsSold;

  remainingAndelsBankBalance =
    Math.max(
      0,
      andelsBankStartBalance - totalAndelsPayout
    );


  // -----------------------------------------------------
  // GEM DEN FAKTISKE SLUTVÆRDI FOR HVER SPILLER
  // -----------------------------------------------------

  Object.entries(andelsOwners).forEach(
    ([pl, count]) => {

      // DETTE ER DEN ENDELIGE VÆRDI AF SPILLERENS
      // ANDELSBEVISER.

      newAndelsBankShareValues[pl] =
        count * payoutPerShare;
    }
  );


  addBankMessages(
    `🏦 Andelsbanken: ${totalAndelsSold} solgte andele. ` +
    `Hver andel giver ${kr(payoutPerShare)} kr.`
  );


  addBankMessages(
    `🏦 Andelsbanken udbetaler samlet ` +
    `${kr(totalAndelsPayout)} kr. ` +
    `Ny banksaldo: ${kr(remainingAndelsBankBalance)} kr.`
  );

} else {

  // -----------------------------------------------------
  // INGEN POSITIV BANKSALDO
  // -----------------------------------------------------

  remainingAndelsBankBalance =
    Math.max(
      0,
      andelsBankStartBalance
    );


  // Hvis banken ikke har penge nok, er resultatet 0.
  Object.entries(andelsOwners).forEach(
    ([pl, count]) => {

      newAndelsBankShareValues[pl] = 0;
    }
  );


  if (
    totalAndelsSold > 0 &&
    andelsBankStartBalance <= 0
  ) {

    addBankMessages(
      "🏦 Andelsbanken: Banken havde ingen positiv saldo – " +
      "ingen udbetaling til andelshaverne."
    );
  }
}


// -------------------------------------------------------
// GEM ANDELSBANKENS SLUTVÆRDIER
// -------------------------------------------------------

setAndelsBankShareValues(
  newAndelsBankShareValues
);

setAndelsBankCarryover(
  remainingAndelsBankBalance
);

setBankBalance(
  remainingAndelsBankBalance
);


// -------------------------------------------------------
// LOG DEN ENDELIGE BANKSALDO
// -------------------------------------------------------

addBankMessages(
  `🏦 Derby Banken sluttede løbsdagen med ` +
  `${remainingAndelsBankBalance.toLocaleString()} kr.`
);


// -------------------------------------------------------
// 3) BEREGN DAGSRESULTAT
// -------------------------------------------------------

const currentResults = players
  .map(player => {

    const stats =
      playerStats[player] || {};

    const money =
      stats.money || 0;

    const loan =
      playerLoans[player] || 0;


    // ---------------------------------------------------
    // HESTEVÆRDI
    // ---------------------------------------------------

    const horses = [
      ...new Map(
        (playerHorses[player] || [])
          .map(h => [h.name, h])
      ).values()
    ];


    const horsesValue =
      horses.reduce(
        (sum, h) => {

          const age =
            h.age ?? 2;

          const wins =
            h.wins ?? 0;

          const basePrice =
            shuffledHorsesByAge?.[age]?.price ??
            horseStartPrice?.[age] ??
            h.price ??
            20000;

          const valueWithWins =
            basePrice *
            Math.pow(1.25, wins);

          return (
            sum +
            Math.round(
              valueWithWins * 1.10
            )
          );
        },
        0
      );


    // ---------------------------------------------------
    // SELSKABER
    // ---------------------------------------------------

    const entries =
      Object.entries(companies)
        .filter(
          ([_, info]) =>
            info.owner === player
        );

    const companyValue =
      entries
        .filter(
          ([n]) =>
            !n.includes("💰")
        )
        .reduce(
          (a, [_, i]) =>
            a +
            Math.round(
              i.price * 0.75
            ),
          0
        );

    const bondValue =
      entries
        .filter(
          ([n]) =>
            n.includes("💰")
        )
        .reduce(
          (a, [_, i]) =>
            a +
            Math.round(
              i.price * 0.8
            ),
          0
        );


    // ---------------------------------------------------
    // OBLIGATIONER
    // ---------------------------------------------------

    const numBonds =
      obligations?.owners?.[player] || 0;

    const bondsValue =
      Math.round(
        numBonds *
        (obligations?.price || 25000) *
        0.80
      );

    // ---------------------------------------------------
    // TOTO-AKTIER
    // ---------------------------------------------------

    const shareValue =
      newShareValues[player] || 0;

    // ---------------------------------------------------
    // ANDELSBANK
    // ---------------------------------------------------

    // 🏦 Andelsbanken – KUN AFKASTET TÆLLER
const andelsBankTotalValue =
  newAndelsBankShareValues[player] || 0;

// Kun gevinsten fra bankens saldo gemmes som Andelsgevinst.
// Købsprisen på 50.000 kr. indgår ikke i formuen.
const andelsBankValue = andelsBankTotalValue;

const investment =
  companyValue +
  bondValue +
  bondsValue +
  shareValue +
  andelsBankValue;

const totalWealth =
  money +
  investment +
  horsesValue -
  loan;

return {
  name: player,
  cash: money,
  netCash: money - loan,
  investment,
  companyValue,
  secureInvestmentValue: bondValue,
  obligationValue: bondsValue,
  bondValue: bondValue + bondsValue,
  shareValue,

  // KUN Andelsbankens afkast gemmes
  andelsBankValue,

  horsesValue,
  debt: loan,
  totalWealth,

  // KUN Andelsbankens afkast tæller i sæsonen
  seasonDayValue:
    horsesValue +
    shareValue +
    andelsBankValue
};
  })
  .sort(
    (a, b) =>
      b.totalWealth -
      a.totalWealth
  );


// -------------------------------------------------------
// 4) GEM I SÆSONHISTORIK
// -------------------------------------------------------

const updatedHistory = [
  ...seasonHistory,
  currentResults
];

setSeasonHistory(
  updatedHistory
);


localStorage.setItem(
  "derbySeason",
  JSON.stringify(
    updatedHistory
  )
);

  // -------------------------------------------------------
  // 4) BEREGN SAMLET SÆSONRESULTAT  andelsBankShareValues
  // -------------------------------------------------------
  const samlet = {};

  updatedHistory.forEach(spil => {
    spil.forEach(entry => {
      const navn = entry.name;

      if (!samlet[navn]) {
        samlet[navn] = {
          total: 0,
          spil: 0,
          netCash: 0,
          companyValue: 0,
          secureInvestmentValue: 0,
          obligationValue: 0,
          totoValue: 0,
		  horsesValue: 0,
          andelsBankValue: 0
        };
      }

      samlet[navn].total +=
        Math.round(
          entry.seasonDayValue ?? 0
        );

      samlet[navn].spil += 1;

      samlet[navn].netCash =
        Math.round(
          entry.netCash ??
          ((entry.cash ?? 0) -
            (entry.debt ?? 0))
        );

      samlet[navn].companyValue =
        Math.round(
          entry.companyValue ?? 0
        );

      samlet[navn].secureInvestmentValue =
        Math.round(
          entry.secureInvestmentValue ?? 0
        );

      samlet[navn].obligationValue =
        Math.round(
          entry.obligationValue ?? 0
        );
		
		samlet[navn].horsesValue +=
  Math.round(
    entry.horsesValue ?? 0
  );

      samlet[navn].totoValue +=
        Math.round(
          entry.shareValue ??
          entry.totoValue ??
          0
        );

      // 🏦 Samlet Andelsgevinst gennem hele sæsonen
      samlet[navn].andelsBankValue +=
        Math.round(
          entry.andelsBankValue ?? 0
        );
    });
  });

  // Andelsbankens dagsværdi er allerede med i seasonDayValue.
  // Den skal derfor IKKE lægges til igen ved sæsonafslutningen.
  if (
    updatedHistory.length >= seasonLength
  ) {
    Object.values(samlet).forEach(data => {
      data.total +=
        Math.round(data.netCash || 0);

      data.total +=
        Math.round(data.companyValue || 0);

      data.total +=
        Math.round(
          data.secureInvestmentValue || 0
        );

      data.total +=
        Math.round(
          data.obligationValue || 0
        );
    });
  }

  const sorteret = Object.entries(samlet)
    .map(([navn, data]) => ({
      navn,
      ...data,

      visningsTotal:
        updatedHistory.length >= seasonLength
          ? data.total
          : data.total +
            (data.netCash || 0) +
            (data.companyValue || 0) +
            (data.secureInvestmentValue || 0) +
            (data.obligationValue || 0)
    }))
    .sort(
      (a, b) =>
        b.visningsTotal - a.visningsTotal
    );

  setSeasonResults(sorteret);
  setShowSeasonBox(true);

}, [gameOver]);

useEffect(() => {
  if (raceStarted && currentRound === 1) {
    const galopLyd = new Audio("https://bornholm-golf.dk/derby/static/galoplyd.mp3");
    galopLyd.volume = 0.08; // juster lydstyrke
    galopLyd.play().catch(() => {
      console.warn("🔇 Kunne ikke afspille galoplyd automatisk.");
    });
  }
}, [raceStarted, currentRound]);

useEffect(() => {
  if (showHaltPopup) {
    const audio = new Audio("https://bornholm-golf.dk/derby/static/vrinsk.m4a"); 
    audio.play().catch((err) =>
      console.log("Kunne ikke afspille lyd:", err)
    );
  }
}, [showHaltPopup]); 

useEffect(() => {
  if (showTotoSharePopup) {
    const audio = new Audio("https://bornholm-golf.dk/derby/static/gevinst.mp3"); 
	audio.volume = 0.6; // juster lydstyrke
	audio.play();
    audio.play().catch((err) => console.log("Kunne ikke afspille lyd:", err));
  }
}, [showTotoSharePopup]);

useEffect(() => {
  if (raceWinner) {
    const applause = new Audio("https://bornholm-golf.dk/derby/static/klapsalver.mp3");
    applause.volume = 0.2; // juster lydstyrke
	applause.play();
  }
}, [raceWinner]);

if (showWelcome) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundImage: 'url("https://bornholm-golf.dk/derby/static/spilstart.png")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        justifyContent: "center",
		alignItems: "center",
        color: "#fff",
        textShadow: "0 2px 6px rgba(0,0,0,0.6)",
        zIndex: 9999
      }}
    >
	<div
        style={{
          backgroundColor: "rgba(219, 245, 215, 0.80)",
          border: "3px solid #7AAD08",
          borderRadius: "16px",
          padding: "10px 30px",
          textAlign: "center",
          maxWidth: "860px",
          color: "#2e3d2f",
          boxShadow: "0 8px 20px rgba(0,0,0,0.35)"
        }}
      >
	  <img style={{
      textAlign: "right",
      width: "360px",
      border: "3px solid #000",
      background: "#fff",
	  borderRadius: "6px",
      zIndex: 3000
    }} src="https://bornholm-golf.dk/derby/static/logogalopbane2.png" alt="Galopbanelogo"
  />
      <h1 style={{ fontSize: "48px", marginBottom: "10px" }}>🍀 Velkommen til Galop- og strategi-spillet DERBY 🏆</h1><br/>
      <p style={{ fontSize: "22px", maxWidth: "900px", textAlign: "center", marginBottom: "10px" }}>
        🏆 Oplev spændingen på galopbanen - køb heste, lav handler,<br/>sats dine præmie- og gevinst-penge, bliv løbsdagens Derby-vinder,<br/>
		og vælger du flere løbsdage kan du også kæmpe om at blive sæsonens vinder 🍀<hr/>
		
      <button
        onClick={() => setShowWelcome(false)}
        style={{
          fontSize: "22px",
          backgroundColor: "#",
          color: "#222",
          padding: "12px 24px",
          borderRadius: "10px",
          border: "2px solid #2e7d32",
          cursor: "pointer",
          boxShadow: "0 4px 10px rgba(0,0,0,0.3)"
        }}
		onMouseOver={(e) => (e.target.style.backgroundColor = "#a5d6a7")}
        onMouseOut={(e) => (e.target.style.backgroundColor = "#c8e6c9")}
      >
        ➡️ Gå til Derbyspillet
      </button><br/><br/><p>En oplevelse på galopbanen med spænding og overraskelser<br/>i spillet mod computerspillere.</p>
      </p><a
  href="https://bornholm-golf.dk/derby/static/Derby.pdf"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    display: "inline-block",
    fontSize: "16px",
    backgroundColor: "#c8e6c9",
    color: "#222",
    padding: "12px 24px",
    borderRadius: "10px",
    border: "2px solid #2e7d32",
    textDecoration: "none",
    boxShadow: "0 4px 10px rgba(0,0,0,0.3)"
  }}
  onMouseOver={(e) => (e.target.style.backgroundColor = "#a5d6a7")}
  onMouseOut={(e) => (e.target.style.backgroundColor = "#c8e6c9")}
>
   ↗️ Læs om spillet - pdf
</a>      
	  <p><h4>🐎 *Spillet er udviklet på baggrund af et ældre analogt brætspil - ©️ copyright Allan Juhl - Version 03.10.26 * 🏆</h4></p>
    </div>
	</div>
  );
}

//if (!user) {
//  if (authMode === "login") {
//    return <Login onLogin={(u) => {
//    if (u === "register") setAuthMode("register");
//    else setUser(u);
//  }} />;
// }

//  if (authMode === "register") {
//    return <Register onRegistered={(u) => {
//    if (u === "login") setAuthMode("login");
//    else setUser(u);
//  }} />;
//  }
//}

  return (
  <div>
    <style>
{`
  .fade-out {
    opacity: 1;
    transition: opacity 1s ease-in-out;
  }
  .hidden {
    opacity: 0;
  }
  .game-container {
    display: flex;
    justify-content: space-between;
    gap: 2px;
    margin: 8px 0;
  }

  .player-status {
    flex: 1.3;
    padding: 10px;
    margin: 10px;
    border: 6px double;
    border-radius: 5px;
    background-color: #d4f8d4;
  }

  .companies {
    flex: 0.8;
    padding: 10px;
    margin: 10px;
    border: 6px double;
    border-radius: 5px;
    background-color: #d4f8d4;
  }

  .companies ul {
    list-style: none;
    padding-left: 0;
    font-size: 16px;
  }

  .companies li {
    margin-bottom: 10px;
    font-size: 16px;
  }

  .setup-section, .setup-companies {
    flex: 1;
    padding: 8px;
    margin: 5px;
    border-radius: 8px;
    border: 6px double;
    background-color: #E9F5C4;
    font-size: 16px;
  }

  .company-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px 20px;
    border: 6px double;
    border-radius: 8px;
    background: rgba(239,240,149,1);
    padding: 10px;
    list-style: none;
  }

  .company-item {
    position: relative;
    display: inline-block;
    font-size: 20px;
    padding: 4px 8px;
    cursor: pointer;
  }

  .company-tooltip {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    z-index: 1000;
    top: 110%;
    left: 0;
	width: 370px;
    background: rgba(65,130,69,0.95);
    color: #fff;
    padding: 10px;
    border-radius: 6px;
    white-space: nowrap;
    transition: opacity 0.15s ease-in-out;
    font-size: 18px;
  }
  
  .obligation-tooptip {
	  visibility: hidden;
    opacity: 0;
    position: absolute;
    z-index: 1000;
    top: 110%;
    left: 0;
	width: 370px;
    background: rgba(65,130,69,0.95);
    color: #fff;
    padding: 10px;
    border-radius: 6px;
    white-space: nowrap;
    transition: opacity 0.15s ease-in-out;
    font-size: 18px;
  }
  
.company-image {
  width: 100%;
  height: auto;
  margin: 8px 0;
  border-radius: 6px;
  border: 1px solid #444;
}

  .company-item:hover .company-tooltip {
    visibility: visible;
    opacity: 0.95;
  }

  .staldbet-line {
    padding: 2px 8px;
    margin-top: 2px;
    border-radius: 2px;
	color: #ED1C24;
    background: rgba(247,246,144,0.12);
  }
`}
</style>

	{/* Ramme omkring opstart */}
        <div
          style={{
            textAlign: 'center',
			color: "#ffffff",
			border: "1px dashed #7AAD08",
			background: "#79A65D",//🎨 Overskriften
            borderRadius: "8px",
            fontSize: "1.1em",
			padding: "2px",
            margin: "12px"
          }}
        >
    <h2>🏆   DERBY - Hestevæddeløb på Nordskovens Galopbane med præmier og spænding gennem en hel sæson   🏆</h2>
    
</div>

{/* 🔓 Kun når login er OK vises konfigurationen */}
{!gameStarted ? (
  <div
    style={{  
      border: "1px dashed #7AAD08",
      background: "#D2E0B2",//🎨 Stor rammer under overskrift
	  borderRadius: "12px",
      padding: "20px",
      margin: "12px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
      color: "#212E22"
    }}
  >

{/* Spillere og antal løb */}
        <div className="game-container">
          <div className="setup-section">
  <h2> <img src={`https://bornholm-golf.dk/derby/static/navngron.png`} alt="Farteffekt"
                  style={{ height: "70px", marginRight: "10px", verticalAlign: "middle" }} /> <img src={`https://bornholm-golf.dk/derby/static/hestyellow.gif?${Date.now()}`}
                  alt="Galophest" style={{ height: "100px", marginRight: "16px", verticalAlign: "middle" }} />   Konfigurer spillet:</h2>
   <h3 style={{padding: "6px"}}>Valgene bestemmer spillets længde. Den her side vises ved opstart af et spil, og ved nulstilling af sæson.<br/>
  Indtast dit navn i feltet herunder. Vælg antal modstandere, antal løb på dagen og sæsonlængden.<br/><br/>
 Spillernavn: <input
  autoFocus
  style={{
    marginLeft: "2px",
    color: "#000000",
    fontSize: "18px",
    fontWeight: "italic",
    backgroundColor: "#EFF095",//🎨 Vælg spiller
    border: "2px solid #44570B"
  }}
  type="text"
  value={playerName}
  onChange={(e) => setPlayerName(e.target.value)}
  placeholder="Indtast spillerens navn"
/>
<label style={{padding: "9px 6px"}}><br/> Vælg antal modstandere: </label>
<select style={{
	marginLeft: "2px",
    color: "#000000",
    fontSize: "18px",
    border: "2px solid #44570B"
  }}
  value={numAIs}
  onChange={(e) => setNumAIs(Number(e.target.value))}
>
  {[3,4,5].map(n => (
    <option key={n} value={n}>
      {n} 🤖 AI spillere
    </option>
  ))}
</select><br/>
  
    <label style={{ marginRight: "10px" }}>Antal løb pr. løbsdag: </label>
    <select style={{
    marginLeft: "2px",
    color: "#000000",
    fontSize: "18px",
    border: "2px solid #44570B"
  }}
      value={totalRaces} 
      onChange={(e) => setTotalRaces(parseInt(e.target.value))}>
      {Array.from({ length: 5 }, (_, i) => i + 6).map(n => (
        <option key={n} value={n}>{n}</option>
      ))}
    </select> løb<br/>
    <label style={{ marginRight: "10px", textAlign: "italic", fontSize: "18px"}}>Sæsonlængde: </label>
    <select style={{
    marginLeft: "2px",
    color: "#000000",
    fontSize: "18px",
    border: "2px solid #44570B"
  }}
      value={seasonLength}
      onChange={(e) => {
        const value = parseInt(e.target.value);
        setSeasonLength(value);
        localStorage.setItem("seasonLength", value);
      }}
    >
	  <option value={1}>Kun dagens løb</option>
      <option value={2}>2 løbsdage</option>
	  <option value={3}>3 løbsdage</option>
	  <option value={4}>4 løbsdage</option>
      <option value={5}>5 løbsdage</option>
      <option value={6}>6 løbsdage</option>
      <option value={8}>8 løbsdage</option>
      <option value={10}>10 løbsdage</option>
    </select></h3>
  
{playerName.trim() !== "" && (
  <button style={{
        backgroundColor: "#86D693",
		color: "#fff",
		fontSize: "22px",
        border: "1px solid #388e3c",
        padding: "6px 12px",
        borderRadius: "6px"
      }}
  onClick={() => {
    if (!playerName.trim()) return;

    const humanName = playerName.trim();
	localStorage.setItem("playerName", humanName);
    const aiList = ["Hennie", "Casey", "Daniella", "Wannesa", "Lorentz", "Simone"];
    const selectedAIs = aiList.slice(0, numAIs);
    const allPlayers = [humanName, ...selectedAIs];

    const updatedStats = {};
    const updatedLoans = {};
    const updatedHorses = {};
    const updatedRaceHorses = {};
    const updatedBets = {};

    let availableHorses = [...shuffledHorsesByAge[2].names];

    allPlayers.forEach(player => {
      const isAI = selectedAIs.includes(player);

      updatedStats[player] = { money: 45000, wins: 0 };
      updatedLoans[player] = 25000;
      updatedHorses[player] = [];

      const horseName = availableHorses.shift();
      const horse = {
        name: horseName,
        age: 2,
        wins: 0,
        price: shuffledHorsesByAge[2].price,
        position: 0
      };

      updatedHorses[player].push(horse);
      updatedStats[player].money -= horse.price;
      updatedRaceHorses[player] = horse.name;
      updatedBets[player] = horse.name;
    });
	
	// -----------------------------------------------
// BANKENS KORREKTE STARTSALDO baseret på løbsdag
// -----------------------------------------------
const antalLoeb = totalRaces;            // valgt i dropdown
const antalSpillere = allPlayers.length; 

const bankStart = antalSpillere * 28000 * antalLoeb;

setBankBalance(bankStart);
setBankLog([
  `🏦 Banken starter med saldo: ${bankStart.toLocaleString()} kr. (${antalLoeb} løb × ${antalSpillere} spillere)`
]);

    // Nu sæt alt samlet i state:
    setPlayers(allPlayers);
    setAiPlayers(selectedAIs);
    setPlayerStats(updatedStats);
    setPlayerLoans(updatedLoans);
    setPlayerHorses(updatedHorses);
    setSelectedRaceHorse(updatedRaceHorses);
    setSelectedBets(updatedBets);
    setNumPlayers(4);
    setRaceInfoShown(false);
    setGameStarted(true);
    setRaceStarted(false);
    setFirstPlayerIndex(Math.floor(Math.random() * allPlayers.length));
    setPlayerExtraBets({});
    setPlayerName("");
	payInsurancePremiums(1, updatedStats, allPlayers /*, companies hvis nødvendigt */);
  }}
  onMouseOver={(e) => (e.target.style.backgroundColor = "#2771A8")}
  onMouseOut={(e) => (e.target.style.backgroundColor = "#72A82B")}
>
  ➡️ Start spillet og glæd dig til spændende sæson på galopbanen med væddeløb, investeringer og chancer 🐎
</button>
)}
  <ul>
    {players.map((player, index) => (
  <li key={index}>
    {player} {aiPlayers.includes(player) && <span>🤖</span>} 
    <span style={{ marginLeft: "8px", fontSize: "22px" }}>
      {playerColors[player] || "⚫"}
    </span>
  </li>
))}
  </ul>
{playerName.trim() === "" && (
  <h4>
    Når dit navn er indtastet bliver knappen "Start spillet...." synlig og spillet kan gå i gang. God fornøjelse!
  </h4>
)}
    <button style={{ marginLeft: "10px", fontSize: "16px", color: "#fffd55", backgroundColor: "#B489C2", border: "1px solid #0023f5" }} onClick={() => setShowRaceProgram(true)}>Vis dagens løbsprogram 🏁
	</button>
	<button style={{ marginLeft: "10px", fontSize: "16px", color: "#fffd55", backgroundColor: "#B489C2", border: "1px solid #0023f5" }} onClick={() => setShowProgram(true)}>Hvad går spillet ud på📚</button>
    <button style={{ marginLeft: "10px", fontSize: "16px", color: "#fffd55", backgroundColor: "#B489C2", border: "1px solid #0023f5" }} onClick={loadGame}>🔁 Indlæs tidligere spil</button>
	<button style={{ marginLeft: "10px", fontSize: "16px", color: "#fffd55", backgroundColor: "#B489C2", border: "1px solid #0023f5" }} onClick={() => setShowSeasonBox(true)}>🚶🏼‍➡️Vis sæsonstilling</button><br/>
	<h4>💡 Spillets ide og regler kan ses ved tryk på knapperne herover 💡 - Reducer evt. browservinduet til 75%, så giver det bedre overblik!</h4>
</div>
	{showRaceProgram && (
  <div
    style={{
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      background: "#FFECD0",
      border: "12px double #C47B24",
      borderRadius: "8px",
      padding: "20px",
      zIndex: 1000,
      maxWidth: "80%",
      maxHeight: "80%",
      overflowY: "auto",
    }}
  >
    <h2>🏇 Dagens løbsprogram på Nordskovens Galopbane 📝</h2><h3>🏁 Dagens program er løbsdag nr. {Math.min(seasonHistory.length + (gameOver ? 0 : 1), seasonLength)} ud af sæsonens {seasonLength} løbsdage 🏁</h3><hr/>
    <hr />
	 {raceProgram.map((race, index) => (
  <p key={index}>🐴 {race.name} - {race.description}<br/>
	Præmiestørrelser: 🥇 {race.prizes.first} kr, 🥈 {race.prizes.second} kr, 🥉 {race.prizes.third} kr, 🎖️ {race.prizes.forth} kr
  </p>
))}
<hr />
<button
      style={{
        backgroundColor: "#c8e6c9",
        border: "1px solid #388e3c",
		borderRadius: "6px",
        padding: "6px 12px",
        fontSize: "16px"
      }} onClick={() => setShowRaceProgram(false)}>Luk</button>
  </div>
)}
{showSeasonBox && (
  <div style={{
    marginTop: "6px",
	textAlign: "left",
    padding: "10px",
    backgroundColor: "#ffffff",
    border: "6px double #90caf9",
    borderRadius: "6px"
  }}>
    <h3>📊 Sæsonstillingen (efter {seasonHistory.length} løbsdag{seasonHistory.length === 1 ? "" : "e"})</h3>
    <h4>Efter hvert spil gemmes resultaterne for hver spiller. Sæsonen løber over i alt {seasonLength} løbsdage</h4>
    <div style={{ fontSize: "18px", fontWeight: "bold", margin: "6px 0 10px" }}>
      🏁 Løbsdag {Math.min(seasonHistory.length + (gameOver ? 0 : 1), seasonLength)} af {seasonLength}
    </div>
    {seasonHistory.length >= seasonLength && (
      <div style={{ fontSize: "16px", fontWeight: "bold", margin: "4px 0 10px", padding: "6px 8px", backgroundColor: "#fff9c4", borderRadius: "6px" }}>
        🏆 Ved sæsonafslutningen er netto kontanter, selskabsformue, finansielle selskaber og obligationer lagt til sæsonscoren.
<br/>
Hesteværdier, TOTO-gevinster og Andelsgevinster er allerede medregnet løbsdag for løbsdag.
      </div>
    )}
    <ol>
  {seasonResults.map((p, i) => (
    <li
      key={i}
      style={{
        marginBottom: "18px",
        padding: "10px",
        background: "#fffdf3",
        border: "1px solid #c8c8c8",
        borderRadius: "8px"
      }}
    >
      <div
        style={{
          fontSize: "20px",
          fontWeight: "bold",
          marginBottom: "8px"
        }}
      >
        🏁 {p.navn}
      </div>
<div
        style={{
          marginTop: "10px",
          padding: "8px",
          background: "#E8F5E9",
          border: "2px solid #81C784",
          borderRadius: "6px",
          fontSize: "18px"
        }}
      >
        💼 <strong>Samlet sæsonformue:</strong>{" "}
        <strong>
          {Math.round(
            p.visningsTotal ?? 0
          ).toLocaleString()} kr.
        </strong>
      </div>
      <div
        style={{
          fontSize: "17px",
          lineHeight: "1.55"
        }}
      >
Heraf udgør: <br />
💵 Netto kontanter {Math.round(p.netCash ?? 0).toLocaleString()} kr. |{" "}
🏢 Selskabsformue {Math.round(p.companyValue ?? 0).toLocaleString()} kr. |{" "}
🛡️ Sikker investering {Math.round(p.secureInvestmentValue ?? 0).toLocaleString()} kr. |{" "}
💶 Obligationer {Math.round(p.obligationValue ?? 0).toLocaleString()} kr. | {" "}<br />
🐴 Samlet hesteværdi {Math.round(p.horsesValue ?? 0).toLocaleString()} kr. |{" "}
🎯 Samlet TOTO-gevinst {Math.round(p.totoValue ?? 0).toLocaleString()} kr. |{" "}
🏦 Samlet Andelsgevinst {Math.round(p.andelsBankValue ?? 0).toLocaleString()} kr.
        <br /> 
      </div>

      <div
        style={{
          marginTop: "5px",
          fontSize: "14px",
          color: "#555"
        }}
      >
        Efter {p.spil ?? "?"} løbsdag
        {p.spil === 1 ? "" : "e"}
      </div>
    </li>
  ))}
</ol>

    {seasonHistory.length >= seasonLength && (
  <div style={{
    marginTop: "10px",
    padding: "12px",
    backgroundColor: "#fff9c4",
    border: "2px solid #fbc02d",
    borderRadius: "12px",
    textAlign: "center",
    boxShadow: "0 0 10px rgba(0,0,0,0.3)"
  }}>
     <div style={{ fontSize: "48px" }}><img src="https://bornholm-golf.dk/derby/static/Pokal.jpg" alt="Pokal" style={{ maxWidth: "50%", borderRadius: "2px" }} />
   </div>
	<h2 style={{ margin: "10px 0", color: "#2e7d32" }}>
      Sæsonen er slut!
    </h2>
    <p style={{ fontSize: "18px" }}>
      🥇 <strong>{seasonResults[0].navn}</strong> vinder med {seasonResults[0].total.toLocaleString()} kr.
    </p>
    <p style={{ marginBottom: "10px" }}>
      Tryk herunder for at starte en ny sæson.
    </p>
    <button
      style={{
        backgroundColor: "#c8e6c9",
        border: "1px solid #388e3c",
        padding: "6px 12px",
        borderRadius: "6px"
      }}
      onClick={startNewSeason}
    >
      Start ny sæson
    </button>
  </div>
)}

    <div style={{ marginTop: "10px" }}>
      <button 
	  style={{
          textAlign: "center",
		  marginLeft: "10px",
          backgroundColor: "#aacdd2",
		  fontSize: "18px",
		  borderRadius: "6px",
          border: "1px solid #d32f2f"
        }}
	  onClick={() => setShowSeasonBox(false)}>Luk</button>
      <button
        style={{
          marginLeft: "10px",
		  textAlign: "center",
		  fontSize: "18px",
          backgroundColor: "#ffcdd2",
		  borderRadius: "6px",
          border: "1px solid #d32f2f"
        }}
        onClick={() => {
  localStorage.removeItem("derbySeason");
  localStorage.removeItem("playerName");
  setSeasonHistory([]);
  setSeasonResults([]);
}}
      >
        Nulstil sæsonresultater </button>
	  <p style={{
  textAlign: "center",
  fontWeight: "bold",
  fontSize: "18px",
  color: "#2e7d32",
  margin: "6px 0"
}}><hr/>

<br/><br/><img style={{
      textAlign: "center",
      width: "300px",
      border: "3px solid #000",
      background: "#fff",
	  borderRadius: "6px",
      zIndex: 3000
    }} src="https://bornholm-golf.dk/derby/static/logogalopbane2.png" alt="Galopbanelogo"
  /></p>
    </div>
  </div>
)}
	{showProgram && (
  <div
    style={{
      position: "fixed",
      top: "50%",
      left: "40%",
      transform: "translate(-50%, -50%)",
      background: "#D0E8D4",//🎨 Baggrund ved hjælp til spillet
      border: "8px inset #ccc",
      borderRadius: "10px",
      padding: "20px",
      zIndex: 1000,
      maxWidth: "2000px",
      maxHeight: "95%",
      overflowY: "auto",
    }}
  >
    <h2>📝Hvad går spillet ud på 📝</h2><hr/>
    <h4>DERBY er et galopspil, hvor hver spiller får en hest og tager et banklån på kr. 25.000. Hesten har man i første løb. Man kan købe nye heste, passende til de forskellige løb. 
	Der er bonus på 30.000, hvis man har tre heste i sin stald og endnu en bonus på 30.000, hvis man også har en 5-åring - altså fuld stald.</h4>
<p>🏣 Spillet går ud på at den deltagende spiller, ifølge spillets galopprogram, som ses ved tryk på anden knap, skal tilmelde en af sine heste i alle løb, 
købe de rigtige heste og selskaber og forøge sin formue, for til sidst at vinde spillet. 🤖 Man spiller mod et antal computeranimerede spillere,
 der selv gør handler og vælger heste.<br/> 
Før løbet starter satser man på sin egen hest som vinderhest. Når alle spillere har tilmeldt en hest til løbet, vises knappen "...og starten er gået - Gå til galopbanen". 
Tryk på knappen og løbet starter automatisk og afvikles af sig selv. Hvert løb består af så mange runder, der skal til, for at hestene når målstregen ved felt 75 (52 i sprinterløbet). 
I hvert løb lander hestene på galopfelter, og så rykker ens hest lidt ekstra frem eller bliver stående, alt efter held.</p>
<p>På andre felter er det chancehandlinger der skal efterleves, hvilket spillet gør af sig selv. Man får bare besked om hvad der sker. 
Det foregår i en lind strøm og vises i bankfeltet eller i chancefeltet. Chancehandlinger er betaling eller modtagelse af kontanter fra banken, 
og mulighed for at satse på en vinderhest ud fra "staldtips" undervejs i løbet. Spilleren satser automatisk på den førende hest i løbet.<br/>
Man kommer også ud for at skulle betale for en ydelse til et selskab. Spillernes kontantbeholdning vises løbende under et løb. Man kan undervejs gå til Spiloversigten. 
Løbet sættes på pause og man kan gøre handler mv., og så vende tilbage til løbet. Det gælder derfor om at eje selskaber, så betaling går til spillerne indbyrdes, 
i stedet for til banken, der modtager ydelser, så længe selskaberne ikke er solgt. Får man underskud af kontanter undervejs i et løb, tildeles man automatisk 
et lån på kr. 20.000, som sammen med startlånet, kan afdrages undervejs, når man igen kommer til kontanter.</p>

<p>I hvert løb tildeles hver jockey en hjelmfarve og spillerne får også en tilfældig hjelmfarve. Har en spiller fået tildelt samme hjelmfarve som vinderhesten, er der gevinst. 
Gevinsten bestemmes ud fra odds. Der er også et Totosyndikat der satser på to hjelmfarver i hvert løb og gevinsterne indgår i Totosyndikatets saldo. 
Spillerne kan så ved køb af aktier (højst to) få del i totosyndikatets formue. Hver aktie giver 5% i afkast, 
hvis en chancehandling bestemmer at der skal udloddes afkast og saldoen er over 100000 kr. Når sidste løb er afsluttet udloddes altid 5% af saldoen pr. solgt aktie. Restbeløbet tilfalder banken.<br/><br/>

Der kan opstå "Krise" for galopspillet, og så må alle spillere betale 40% af deres kontanter til banken (dog højst 200.000), eller der kan opstå "Fremgang", så får alle spillere forøget 
deres kontantbeholdning med 40%, dog mindst 20.000 og højst 50.000. Begge dele kun en gang i hvert løb.<br/><br/>
En hest kan blive halt under et løb og i 1. løb er der ingen forsikring , men efter første løb forsikres din hest til de efterfølgende løb. 
Det vises med dette symbol 🛡️ved hver hest og det koster kr. 1.500 pr. løb og der betales automatisk til banken eller til ejeren af Galopforsikring ApS. 
Grunden er, at en chancehandling kan indebære, at din hest bliver halt under et løb, tages ud af løbet og sælges for 5.000 kroner. Er du så forsikret får du yderligere 45.000 kr. i erstatning.<br/>

<br/>Der skal også købes flere heste, så man har en valgbar hest til alle løb. Det sker i Hestemarkedet. Har man ikke kontanter nok, kan man låne et beløb, 
der gør at man kan købe en valgbar hest til næste eller kommende løb. Der kan lånes mellem 10 og 50 tusinde. Man kan også sælge heste og prisen afhænger om hesten har vundet løb. 
Der skal betales renter af lån efter hvert løb (2,5%).<br/>
Aktier, Andele, Obligationerne, Forsikringsselskabet, TAXI-selskabet, BronzeCar og Hotellet (kun 2-4 pr. deltager) kan kun erhverves af spillere, der på købstidspunktet er gældfrie. 
Der udbetales 1.000 kr. i obligationsrenter, 5.000 kr. i afkast til hotellejeren, 2.000 til BornTAXI og 3.500 i serviceindtægt til BronzeCar efter hvert løb. Galopforsikring ApS modtager kr. 1.500 fra hver forsikret hest før hvert løb. 
Før hvert løb får en spiller ved lodtrækning mulighed for at købe en andel. En andel koster kr. 50.000 og er rent sats, da afkastet udelukkende er 15% af slutsaldoen i banken efter hver løbsdag.</p>

<p>Spilleren der har førsteret i hvert løb har dette firkløver 🍀 foran sit navn. Rækkefølgen har betydning, hvis flere heste kommer over målstregen i samme runde eller er på linje om de øvrige placeringer.</p>

<p>Vinderen af løbsdagen er den spiller, der har størst formue efter sidste løb. Bemærk at alle selskabsinvesteringer gælder for hele sæsonen og tæller med 75% af købsværdien og tæller først med ved sæsonopgørelsen. Obligationer, Forsikringsselskab, BornTAXI, BronzeCar og Hotel tæller med 
80% ved sæsonopgørelse og er investeringer med fast afkast efter hvert løb. Andele og Heste tæller med i formueopgørelsen efter hver løbsdag med deres opnåede værdi for sejre plus 10%.
En god investering på løbsdagen er aktier, men også usikker, da afkastet afhænger at Totosyndikatets formue.<br/>
Efter hver løbsdag gemmes spillernes formue, mens kontantbeholdningen samt købte selskaber overføres til næste løbsdag. Man kan altså spare op til investeringer i selskaber der ikke kan erhverves med indtjeningen på en enkelt løbsdag.
Efter sidste løbsdag tillægges kontanter og selskabsformue til den eksisterende sæsonsaldo, og så kan se en samlet sæsonvinder efter det valgte antal løbsdage, og den samlede sæsonvinder hyldes.</p>

<p><strong>Lidt insiderviden! En hest der har vundet får lidt handicap i de løb den deltager i efterfølgende. En spiller der har honnøren er lidt bedre stillet i opløbet. 
Vurder hvor mange kontanter du vil have. Der kan komme tvunget reduktion (40%) ved chancehandling, men også forøgelse (40%) ved chancehandling.</strong></p>
<img src="https://bornholm-golf.dk/derby/static/animated-horse-image-0326.gif" alt="hest ved PC" style={{ maxWidth: "10%", borderRadius: "2px" }} />
<hr/>
	 <button
      style={{
        backgroundColor: "#c8e6c9",
        border: "1px solid #388e3c",
		borderRadius: "6px",
        padding: "6px 12px",
        fontSize: "16px"
      }} onClick={() => setShowProgram(false)}>
    Luk</button>
  </div>
)}
   <div className="setup-companies">
  <h2>🪙 Oversigt over selskaber der kan købes ejerskab til i løbet af hele sæsonen</h2>
  <ul className="company-grid">
  {Object.entries(companies).map(([companyName, info]) => {
    const isHotel = companyName.includes("Hotel");
    const isTAXI = companyName.includes("BornTAXI");
	const isBiler = companyName.includes("BronzeCar");
    const isInsurance = companyName.includes("Galopforsikring");

    const value = (isHotel || isTAXI || isInsurance || isBiler)
  ? info.price * 0.80
  : info.price * 0.75;

    return (
      <li key={companyName} className="company-item">
        {companyName}

        {/* Tooltip */}
        <div className="company-tooltip">
		  {info.image && (
    <img
      src={info.image}
      alt={companyName}
      className="company-image"
    />
  )}<br/>
          Pris: {info.price.toLocaleString()} kr.<br/>
          Slutværdi: {Math.round(value).toLocaleString()} kr.<br/>
          {isBiler
            ? `Serviceindtægt: ${info.fee.toLocaleString()} kr. efter hvert løb.`
            : isHotel
            ? `Afkast: ${info.fee.toLocaleString()} kr. efter hvert løb.`
            : isInsurance
            ? `Præmieindtægt: ${info.fee.toLocaleString()} kr. fra hver spiller før løb.`
			: isTAXI
            ? `Afkast: ${info.fee.toLocaleString()} kr. efter hvert løb.`
            : `Chancekort-afkast: ${info.fee.toLocaleString()} kr.`}
        </div>
      </li>
    );
  })}
</ul>
  <ul>
  <li className="company-item"></li>
  <li className="company-item">📜 Sikker investering: Køb obligationer<div className="company-tooltip">
  <img src="https://bornholm-golf.dk/derby/static/obligation.png" alt="Obligation" style={{maxWidth: "100%", borderRadius: "2px" }} /><br/>
  Der kan også investeres i obligationer<br/> til 25.000 pr. stk., hvis man er gældfri.<br/>Slutværdi: 20.000 for hver obligation man ejer.<br/> 💶 Renter efter hvert løb på kr. 1.000</div></li>

<li className="company-item"></li>
  <li className="company-item">🏦 Andelsbanken: Køb en andel<div className="company-tooltip">
  <img src="https://bornholm-golf.dk/derby/static/Andel.png" alt="Andel" style={{maxWidth: "100%", borderRadius: "2px" }} /><br/>
  Vinder man købsretten i et løb, kan der satses<br/> på en bankandel til 50.000, hvis man er gældfri.<br/>Slutværdi: 💶 15% af bankens saldo efter hver<br />løbsdag.</div></li>

<li className="company-item"></li>
<li className="company-item">🪙 Køb aktier i Totosyndikatet<div className="company-tooltip">
<img src="https://bornholm-golf.dk/derby/static/aktier.png" alt="Aktier" style={{maxWidth: "100%", borderRadius: "2px" }} /><br/>
Man kan satse på aktier á 35.000<br/> i Totosyndikatet, hvis man er gældfri. <br/>💸 5% afkast af puljen ved hver udlodning<br/>og ved slutopgørelse efter hver løbsdag.</div></li>
</ul>
</div>
        </div>
   	<div
	style={{
    textAlign: 'center',
	border: "2px solid #D2E0B2",
    background: "#D2E0B2",//🎨 Ramme rundt om billede ved konfigration
    borderRadius: "8px",
    padding: "3px",
    margin: "2px",
   }}
  >
	 <img src="https://bornholm-golf.dk/derby/static/totalisator.png" alt="Galopløb" style={{ maxWidth: "90%", borderRadius: "10px" }} />
  </div>
  </div>
    ) : gameOver ? (
      <>
        {/* Ramme omkring samlet vinder og resultatliste */}
        <div
  style={{
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    gap: "20px",
    padding: "10px",
    margin: "10px",
    background: "#E0D6A5",
    border: "2px solid #ccc",
    borderRadius: "8px"
  }}
>
  {/* Resultatliste */}
<div className="game-container">
  <div className="setup-section">
    <h2>📢 Løbsdagen på galopbanen i DERBY-spillet er slut!</h2>
    <h3>
      <p>{getOverallWinner()}</p>
      Resultatliste med samlet formue:
    </h3>
    <ol>
  {getResultsList().map(
    ({
      name,
      cash,
      companyValue,
      secureInvestmentValue,
      obligationValue,
      shareValue,
      andelsBankValue,
      horsesValue,
      debt,
      totalWealth
    }) => {
      const numBonds =
        obligations?.owners?.[name] || 0;

      const numAndelsBankShares =
        andelsBank?.owners?.[name] || 0;

      const numShares =
        totoShares?.owners?.[name] || 0;

      return (
        <li
          key={name}
          style={{
            marginBottom: "18px",
            padding: "10px",
            background: "#fffdf3",
            border: "1px solid #c8c8c8",
            borderRadius: "8px"
          }}
        >
          <div
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              marginBottom: "8px"
            }}
          >
            🏁 {name}
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "minmax(220px, 1fr) minmax(220px, 1fr)",
              gap: "4px 20px",
              lineHeight: "1.5"
            }}
          >
            {/* KONTANTER OG GÆLD */}
            <div>
              💰 Kontanter:
              <strong>
                {" "}
                {Math.round(cash).toLocaleString()} kr.
              </strong>
            </div>

            <div>
              🧾 Gæld:
              <strong>
                {" "}
                {debt
                  ? `-${Math.round(debt).toLocaleString()} kr.`
                  : "Ingen"}
              </strong>
            </div>

            {/* SELSKABER */}
            <div>
              🏢 Selskaber:
              <strong>
                {" "}
                {Math.round(
                  companyValue
                ).toLocaleString()} kr.
              </strong>
            </div>

            {/* FINANSIELLE SELSKABER */}
            <div>
              🛡️ Finansielle (80%):
              <strong>
                {" "}
                {Math.round(
                  secureInvestmentValue || 0
                ).toLocaleString()} kr.
              </strong>
            </div>

            {/* OBLIGATIONER */}
            <div>
              💶 Obligationer:
              <strong>
                {" "}
                {Math.round(
                  obligationValue || 0
                ).toLocaleString()} kr.
              </strong>

              {numBonds > 0 && (
                <span>
                  {" "}
                  ({numBonds}{" "}
                  {numBonds === 1
                    ? "stk."
                    : "stks."}
                  )
                </span>
              )}
            </div>

            {/* TOTO */}
            <div>
              💼 TOTO:
              <strong>
                {" "}
                {numShares > 0
                  ? `${numShares} ${
                      numShares === 1
                        ? "aktie"
                        : "aktier"
                    } (${Math.round(
                      shareValue || 0
                    ).toLocaleString()} kr.)`
                  : "Ingen"}
              </strong>
            </div>

            {/* ANDELSBANK */}
            <div>
              🏦 Andelsbanken:
              <strong>
                {" "}
                {numAndelsBankShares > 0
                  ? `${numAndelsBankShares} ${
                      numAndelsBankShares === 1
                        ? "andel"
                        : "andele"
                    } (${Math.round(
                      andelsBankValue || 0
                    ).toLocaleString()} kr.)`
                  : "Ingen"}
              </strong>
            </div>

            {/* HESTE */}
            <div>
              🐴 Heste:
              <strong>
                {" "}
                {Math.round(
                  horsesValue
                ).toLocaleString()} kr.
              </strong>
            </div>
          </div>

          {/* SAMLET FORMUE */}
          <div
            style={{
              marginTop: "10px",
              padding: "8px",
              background: "#E8F5E9",
              border: "2px solid #81C784",
              borderRadius: "6px",
              fontSize: "18px"
            }}
          >
            💼 <strong>Samlet formue:</strong>{" "}
            <strong>
              {Math.round(
                totalWealth
              ).toLocaleString()} kr.
            </strong>
          </div>
        </li>
      );
    }
  )}
</ol>
  </div>
{showSeasonBox && (
  <div style={{
    marginTop: "6px",
	textAlign: "left",
    padding: "10px",
    backgroundColor: "#ffffff",
    border: "6px double #90caf9",
    borderRadius: "6px"
  }}>
  {seasonHistory.length >= seasonLength && (
  <div style={{
    marginTop: "10px",
    padding: "8px",
    backgroundColor: "#fff9c4",
    border: "2px solid #fbc02d",
    borderRadius: "12px",
	textAlign: "center",
    boxShadow: "0 0 10px rgba(0,0,0,0.3)"
  }}>
	 <img src="https://bornholm-golf.dk/derby/static/Pokal.jpg" alt="Pokal" style={{ maxWidth: "50%", borderRadius: "2px" }} />
    <h2 style={{ margin: "10px 0", color: "#2e7d32" }}>
      Derbysæsonen er slut på Nordskovens Galopbane!
    </h2>
    <p style={{ fontSize: "22px" }}>
      🥇 <strong>{seasonResults[0].navn}</strong> vinder med {seasonResults[0].total.toLocaleString()} kr.
    </p>
    <p style={{ marginBottom: "10px" }}>
      Tryk herunder for at starte en ny sæson.
    </p>
    <button style={{ backgroundColor: "#c8e6c9", border: "1px solid #388e3c", padding: "6px 12px", borderRadius: "6px", fontSize: "22px" }}
      onClick={startNewSeason}
    >
      Start ny sæson
    </button>
  </div>
)}
{seasonHistory.length < seasonLength && (
    <div><h3>📊 Sæsonstilling (efter {seasonHistory.length} løbsdag{seasonHistory.length === 1 ? "" : "e"})</h3>
    <h4>Efter hvert spil gemmes resultaterne for hver spiller. Sæsonen løber over i alt {seasonLength} løbsdage</h4>
	</div>)}
    <div style={{ fontSize: "18px", fontWeight: "bold", margin: "6px 0 10px" }}>
      🏁 Løbsdag {Math.min(seasonHistory.length + (gameOver ? 0 : 1), seasonLength)} af {seasonLength}
    </div>
    {seasonHistory.length >= seasonLength && (
      <div style={{ fontSize: "18px", fontWeight: "bold", margin: "4px 0 10px", padding: "6px 8px", backgroundColor: "#fff9c4", borderRadius: "6px" }}>
        🏆 Dette var sæsonens sidste løbsdag og alle spillernes værdier er gjort op. 💰<br/> 🪎 Håber det har været spændende og du er klar til en ny løbssæson på Nordskovens Galopbane. 🏆
      </div>
    )}
    <ol>
  {seasonResults.map((p, i) => (
    <li
      key={i}
      style={{
        marginBottom: "18px",
        padding: "10px",
        background: "#fffdf3",
        border: "1px solid #c8c8c8",
        borderRadius: "8px"
      }}
    >
      <div
        style={{
          fontSize: "20px",
          fontWeight: "bold",
          marginBottom: "8px"
        }}
      >
        🏁 {p.navn}
      </div>
<div
        style={{
          marginTop: "10px",
          padding: "8px",
          background: "#E8F5E9",
          border: "2px solid #81C784",
          borderRadius: "6px",
          fontSize: "18px"
        }}
      >
        💼 <strong>Samlet sæsonformue:</strong>{" "}
        <strong>
          {Math.round(
            p.visningsTotal ?? 0
          ).toLocaleString()} kr.
        </strong>
      </div>
      <div
        style={{
          fontSize: "17px",
          lineHeight: "1.55"
        }}
      >
Heraf udgør: <br />
💵 Netto kontanter {Math.round(p.netCash ?? 0).toLocaleString()} kr. |{" "}
🏢 Selskabsformue {Math.round(p.companyValue ?? 0).toLocaleString()} kr. |{" "}
🛡️ Sikker investering {Math.round(p.secureInvestmentValue ?? 0).toLocaleString()} kr. |{" "}
💶 Obligationer {Math.round(p.obligationValue ?? 0).toLocaleString()} kr. | {" "}<br />
🐴 Samlet hesteværdi {Math.round(p.horsesValue ?? 0).toLocaleString()} kr. |{" "}
🎯 Samlet TOTO-gevinst {Math.round(p.totoValue ?? 0).toLocaleString()} kr. |{" "}
🏦 Samlet Andelsgevinst {Math.round(p.andelsBankValue ?? 0).toLocaleString()} kr.
        <br /> 
        
      </div>

      

      <div
        style={{
          marginTop: "5px",
          fontSize: "14px",
          color: "#555"
        }}
      >
        Efter {p.spil ?? "?"} løbsdag
        {p.spil === 1 ? "" : "e"}
      </div>
    </li>
  ))}
</ol>

    <div style={{fontSize: "16px", marginTop: "10px" }}>
      <button style={{ marginLeft: "10px", fontSize: "18px", backgroundColor: "#ffcdd2", borderRadius: "6px", border: "1px solid #d32f2f" }}
		onClick={() => setShowSeasonBox(false)}>Luk</button><hr/>
      <button style={{ marginLeft: "10px", fontSize: "18px", borderRadius: "6px", border: "1px solid #d32f2f" }}
        onClick={startNewSeason}>
    Nulstil sæsonresultater </button>
	{/* 🏦 BANKENS LØBSDAGS-AFSLUTNING */}
<div
  style={{
    marginTop: "12px",
    padding: "10px",
    backgroundColor: "#eef7ee",
    border: "2px solid #81C784",
    borderRadius: "8px"
  }}
>
  <h3
    style={{
      margin: "4px 0 10px",
      color: "#2e7d32"
    }}
  >
    🏦 Andelsbanken – løbsdagens afslutning
  </h3>

<div
  style={{
    fontSize: "17px",
    lineHeight: "1.55"
  }}
>
  <strong>Saldo efter sidste løb:</strong>{" "}
{kr(
  bankBalance +
  Object.values(andelsBankShareValues || {}).reduce(
    (sum, value) => sum + (value || 0),
    0
  )
)}{" "}
kr.
</div>

  <div
    style={{
      marginTop: "8px",
      paddingTop: "8px",
      borderTop: "1px solid #bdbdbd"
    }}
  >
    <strong>
      🏦 Andelsbanken – fordeling af dagens gevinst
    </strong>
  </div>

  {Object.entries(andelsBank?.owners || {}).filter(
    ([, count]) => count > 0
  ).length > 0 ? (
    <>
      <div
        style={{
          marginTop: "6px",
          fontSize: "16px"
        }}
      >
        <strong>
          {Object.values(andelsBank?.owners || {}).reduce(
            (sum, count) => sum + count,
            0
          )}
        </strong>{" "}
        andele fik gevinst:
      </div>

      <ul
        style={{
          marginTop: "6px",
          marginBottom: "8px"
        }}
      >
        {Object.entries(andelsBank?.owners || {})
          .filter(([, count]) => count > 0)
          .map(([player, count]) => {
            const baseValue =
              count * (andelsBank?.price || 50000);

            const totalValue =
              andelsBankShareValues?.[player] || 0;

            const gain = totalValue;

            return (
              <li key={player}>
                <strong>{player}</strong>:{" "}
                {count}{" "}
                {count === 1 ? "andel" : "andele"} →{" "}
                <strong>{kr(gain)} kr.</strong>{" "}
                i gevinst
              </li>
            );
          })}
      </ul>

      <div
        style={{
          padding: "7px 8px",
          backgroundColor: "#ffffff",
          borderRadius: "6px",
          fontSize: "16px"
        }}
      >
        💶 <strong>Samlet gevinst udbetalt:</strong>{" "}
        {kr(
          Object.entries(andelsBank?.owners || {}).reduce(
            (sum, [player, count]) => {
              const baseValue =
                count * (andelsBank?.price || 50000);

              const totalValue =
                andelsBankShareValues?.[player] || 0;

              const gain = totalValue;

              return sum + gain;
            },
            0
          )
        )}{" "}
        kr.
      </div>
    </>
  ) : (
    <div
      style={{
        marginTop: "6px"
      }}
    >
      Ingen andele fik gevinst denne løbsdag.
    </div>
  )}
  <div
    style={{
      marginTop: "10px",
      padding: "8px",
      backgroundColor: "#E8F5E9",
      border: "2px solid #66BB6A",
      borderRadius: "6px",
      fontSize: "18px"
    }}
  >
    🏦 <strong>Slutsaldo til næste løbsdag:</strong>{" "}
    <strong>{kr(bankBalance)} kr.</strong>
  </div>
</div>
    </div>
  </div>
)}
  {/* Podie */}
<div className="setup-companies">
<div style={{ display: "flex", justifyContent: "center", alignItems: "flex-end", height: "320px", gap: "10px" }}>
  <p><h3>🏆 Podie – Top 3 i dagens løbsprogram<hr/></h3>
  </p>
    {[1, 0, 2].map((resultIndex, visualIndex) => {
      const player = getResultsList()[resultIndex];
      if (!player) return null;

      const heights = [80, 100, 60];
      const colors = ["#C0C0C0", "#FFD700", "#CD7F32"];
      const labels = ["🥈", "🥇", "🥉"];

      return (
        <div
          key={player.name}
          style={{
            backgroundColor: colors[visualIndex],
            width: "100px",
            height: `${heights[visualIndex]}px`,
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
            borderRadius: "4px",
            position: "relative"
          }}
        >
          <div style={{ position: "absolute", top: "-15px", fontSize: "1.1em" }}>
            {labels[visualIndex]} <br />{player.name}
          </div>
          <div style={{ paddingBottom: "5px", fontWeight: "bold" }}>
            {Math.round(player.totalWealth / 1000)}°
          </div>
	</div>
      );
    })}
	</div><br/><img src={`https://bornholm-golf.dk/derby/static/spurt2.png`} alt="Heste" style={{ maxWidth: "98%", borderRadius: "10px" }} /><br/>
   <div style= {{ textAlign: "center"}}>
    <h2>Løbsdagen er slut - Tak for nu! 🐎
    <button style={{ marginLeft: "10px", fontSize: "18px", backgroundColor: "#ffcdd2", borderRadius: "6px", border: "1px double #d32f2f" }} onClick={startNextRaceDay}>
      {seasonHistory.length >= seasonLength ? "Start ny sæson" : "Start næste løbsdag"}
    </button></h2>
	<img src="https://bornholm-golf.dk/derby/static/logogalopbane2.png" alt="starten" style={{ textAlign: "center", maxWidth: "90%", borderRadius: "6px"}}/>
	</div>
    </div>
  </div>
</div>
      </>
    ) : (
      <>
        {/* Ramme omkring starten af løbet */}
<div
  style={{
    textAlign: 'center',
	color: "000000",
	border: "2px double #ccc",
    height: `${startFrameHeight}px`,
    background: "#AADBA0",//🎨 baggrund ved hestevalg
    borderRadius: "8px",
    padding: "10px",
    margin: "10px",
  }}
>

{/* Hvis løbet endnu ikke er startet, vis valg af hest + indsatsformular */}
{!raceStarted ? (
  showBetForm ? (
    <div>
      {/* Spillere vælger deres hest til løbet */}
{players
  .reduce((rows, player, index) => {
    if (index % 3 === 0) rows.push([player]);
    else rows[rows.length - 1].push(player);
    return rows;
  }, [])
  .map((pair, rowIndex) => (
    <div
      key={rowIndex}
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1000px",
        gap: "10px",
        marginBottom: "14px",
        alignItems: "center"
      }}
    >
      {pair.map(player => {
        const isRestrictedRace = [0, 2, 3, 4, 7, 8, 9].includes(derivedRaceIndex);
        const eligibleHorses = isRestrictedRace
          ? (playerHorses[player] || []).filter(h =>
              raceProgram[derivedRaceIndex].condition(h, currentRound)
            )
          : playerHorses[player] || [];

        return (
          <div
            key={player}
            style={{
              display: "grid",
              gridTemplateColumns: "80px 1fr",
              alignItems: "center",
              gap: "10px"
            }}
          >
            <label style={{ fontSize: "18px", fontWeight: "bold", color: "#000" }}>
              {player}:
            </label>

            <select
              style={{
                fontSize: "16px",
                width: "400px",
                color: "darkgreen"
              }}
              value={selectedRaceHorse[player] || ""}
              onChange={e =>
                setSelectedRaceHorse({
                  ...selectedRaceHorse,
                  [player]: e.target.value
                })
              }
            >
              <option value="">Vælg din hest</option>
              {eligibleHorses.map(horse => {
                const extraNote =
                  derivedRaceIndex === 5 && horse.wins > 0
                    ? " – Står over i 1. runde."
                    : " - er klar til start";

                return (
                  <option key={horse.name} value={horse.name}>
                    {horse.name} ({horse.age} år, 🏆 {horse.wins} sejre)
                    {extraNote}
                  </option>
                );
              })}
            </select>
          </div>
        );
      })}
    </div>
  ))}
<div
  style={{
  textAlign: "center",
        fontSize: "1.2em",
        fontWeight: "bold",
        color: "5C6FF0" }}
>
<h3>
  📝 Dagens program på galopbanen: Løb {raceCount + 1} af {totalRaces} med præmier på 🏆 {currentPrizes.first} til vinderen, {currentPrizes.second} til andenpladsen, {currentPrizes.third} til tredjepladsen og {currentPrizes.forth} til fjerdepladsen 🏇
</h3>
<h3>🧾 Betingelser: {raceProgram[derivedRaceIndex].description}</h3>
  {!players.some(player => !selectedRaceHorse[player]) && (
    <button style={{
	backgroundColor: "#AADBA0",//🎨 Baggrund ved ....og starten er gået
	color: "#000",
    border: "3px dotted #fff",
    borderRadius: "12px",
    zIndex: 9999,
    maxWidth: "950px",
    boxShadow: "0 0 15px rgba(0,0,0,0.5)"}}
    onClick={() => {
      handleBetsSubmit();
      setShowRaceView(true); setShowHorseMarket(null); setHoverImage(null);
    }}
	onMouseEnter={() => setHoverImage("https://bornholm-golf.dk/derby/static/Allankommenterergalop.jpg")}
  onMouseLeave={() => setHoverImage(null)}
  ><img src="https://bornholm-golf.dk/derby/static/startboks3.png" alt="starten" style={{ maxWidth: "100%", borderRadius: "6px"}} />
	</button> 
)}
 {hoverImage && (
  <img
    src={hoverImage}
    alt="preview"
    style={{
      position: "fixed",
      top: "10%",
      left: "85%",
      width: "260px",
      border: "3px solid #000",
      background: "#fff",
      zIndex: 3000
    }}
  />
)}
</div>
</div>
  ) : (
    <button onClick={() => setShowBetForm(true)} style={{ marginLeft: "10px", borderRadius: "8px", color: "#000000", fontSize: "1.0em", backgroundColor: "#D0E8D4", border: "1px solid #44570B" }}
  onMouseEnter={() => setHoverImage("https://bornholm-golf.dk/derby/static/hest.png")}
  onMouseLeave={() => setHoverImage(null)}
  ><h2>
  📝 Dagens program på galopbanen: Løb {raceCount + 1} af {totalRaces} med en præmiesum på 🏆 {currentPrizes.first} til vinderen, {currentPrizes.second} til andenpladsen, {currentPrizes.third} til tredjepladsen og {currentPrizes.forth} til fjerdepladsen 🏇
</h2><h2>🧾 Betingelser: {raceProgram[derivedRaceIndex].description}<br/></h2><h3>🏁 Dagens program er løbsdag nr. {Math.min(seasonHistory.length + (gameOver ? 0 : 1), seasonLength)} ud af sæsonens {seasonLength} løbsdage 🏁</h3><hr/>
 <img src="https://bornholm-golf.dk/derby/static/totalisator1.png" alt="totalisator" style={{ maxWidth: "75%", borderRadius: "6px" }} />
  {hoverImage && (
  <div
    style={{
      position: "fixed",
      top: "18%",
      left: "3%",
      width: "480px",
      zIndex: 3000
    }}
  >
    <img
      src={hoverImage}
      alt="preview"
      style={{
        width: "100%",
        border: "3px solid #000",
        background: "#fff"
      }}
    />
    {playerHorses[currentPlayer] &&
      playerHorses[currentPlayer][0] &&
      playerHorses[currentPlayer][0].name && (
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            left: "50%",
            transform: "translateX(-50%)",
            background: "rgba(0,0,0,0.7)",
            color: "#fff",
            padding: "6px 14px",
            borderRadius: "8px",
            fontSize: "1.7em",
            fontWeight: "bold",
            letterSpacing: "1px"
          }}
        >
          {playerHorses[currentPlayer][0].name}
        </div>
      )}
  </div>
)}
  </button>
  )
  
) : raceWinner ? (
  <>
   {winningMessage && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.35)",
      zIndex: 9999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
	  animation: "fadeIn 0.8s ease-in-out",
    }}
  >

    <div
      style={{
        background: "rgba(188, 208, 229, 0.95)",
        border: "3px solid #7AAD08",
        borderRadius: "16px",
        padding: "10px",
        width: "96%",
        maxWidth: "1200px",
        color: "#1b3a1b",
        fontSize: "20px",
        boxShadow: "0 0 20px rgba(0,0,0,0.5)",
        textAlign: "center",
		animation: "zoomIn 0.6s ease-out",
      }}
    >
      <h2 style={{ textAlign: "center", marginTop: 0 }}>🏆 Præmier og gevinster 🏆</h2>
      <div style={{
          fontSize: "20px",
          lineHeight: "1.5em",
          fontWeight: "bold",
		  textAlign: "left",
          margin: "0 auto",
          maxWidth: "1100px",
          background: "rgba(215,242,200,0.8)",
          padding: "10px",
          borderRadius: "8px",
        }}
        dangerouslySetInnerHTML={{
          __html: winningMessage.replace(/\n/g, "<br/>"),
        }}
      />

      {betWinnersMessage && (
  <div
    style={{
      marginTop: "5px",
      fontSize: "20px",
	  fontWeight: "bold",
      textAlign: "center",
      lineHeight: "1.5em",
      whiteSpace: "pre-line", // 💡 tillader linjeskift
    }}
    dangerouslySetInnerHTML={{
      __html: betWinnersMessage.replace(/\n/g, "<br/>"),
    }}
  />
)}
      {/* Totosyndikatets resultat */}
{totoSyndicate.history.length > 0 && (
  <div style={{ marginTop: "0px", borderTop: "2px solid #ccc", paddingTop: "6px", color: "darkgreen"}}>
    <h3>🎲 Totosyndikatets sats, gevinster og saldo 🎲</h3>
    {(() => {
      const last = totoSyndicate.history[totoSyndicate.history.length - 1];
      const payoutTxt = last.payout > 0
        ? `Gevinst: ${kr(last.payout)} kr.`
        : `Ingen gevinst i dette løb.`;
      return (
        <>
          <p style={{color: "#821C14"}}>
            <strong>Satsede i løb {last.race} på: {last.colors.join(", ")} | {payoutTxt} | Saldo nu: {kr(totoSyndicate.balance)} kr.</strong></p>
        </>
      );
    })()}
  </div>
)}
      <hr style={{ marginTop: "16px", marginBottom: "16px" }}/>
	  <button onClick={() => {
    setWinningMessage("");
    setShowPrizesBox(true);

  }}
  style={{
    marginLeft: "10px",
    fontSize: "20px",
	maxWidth: "60%",
    color: "#000000",
    borderRadius: "3px",
    backgroundColor: "#E0D6A5",
    border: "1px solid #44570B"
  }}
><img
        src="https://bornholm-golf.dk/derby/static/vinderjubel.png"
        alt="crowd"
        style={{ maxWidth: "95%", borderRadius: "4px", marginTop: "10px" }}
      /><br/>
  Gå til spiloversigt
</button>
      
    </div>
  </div>
)}
  {/* Vis kun næste løbs betingelser, hvis vi ikke er i sidste løb */}
{showPrizesBox && (
  <div>
    <button
      onClick={() => {
        setRaceWinner(null);
        setWinningMessage("");
        setShowPrizesBox(false);

        if (raceCount + 1 === totalRaces) {
          // ✅ Sidste løb — afslut dagen
          setShowRaceView(false);
          setGameOver(true);
        } else {
          // ✅ Ellers fortsæt til næste løb
          startNextRace();
        }
      }}
      style={{
        marginLeft: "10px",
        fontSize: "20px",
        backgroundColor: "#E0D6A5",//🎨 Betingelser for næste løb
		color: "#000000",
        borderRadius: "8px",
        border: "1px double #44570B",
        marginTop: "10px",
        padding: "8px 16px",
        textAlign: "center",
      }}
    >
	{/* ⭐ VIS KUN NÆSTE LØB HVIS DER ER ET ⭐ */}
  {raceCount + 1 < totalRaces && (
    <h3>
      📝 Dagens program på galopbanen: Løb {raceCount + 2} af {totalRaces} med præmier på 🏆 {nextPrizes.first} til vinderen, {nextPrizes.second} til andenpladsen, {nextPrizes.third} til tredjepladsen og {nextPrizes.forth} til fjerdepladsen 🏇
    </h3>
  )}
<h3>🏁 {Math.min(seasonHistory.length + (gameOver ? 0 : 1), seasonLength)}. løbsdag ud af sæsonens {seasonLength} løbsdage 🏁</h3>
  <h3
    style={{
      textAlign: "center",
      fontSize: "22px",
      backgroundColor: "#E0D6A5",//🎨 Knap for næste løb
      fontStyle: "italic",
      textShadow: "2px 1px 2px #fffc0f",
      color: "#5C6FF0",
    }}
  >
    {raceCount + 1 === totalRaces
      ? "Sidste løb er afsluttet"
      : `🧾 Betingelser for løb ${raceCount + 2}: ${
          raceProgram[derivedRaceIndex + 1]?.description || ""
        }`
    }
    
  </h3>

  {raceCount + 1 === totalRaces ? (
    <strong><img
      src="https://bornholm-golf.dk/derby/static/totalisator2.png"
      alt="totalisator"
      style={{ maxWidth: "75%", borderRadius: "6px" }}
    /></strong>
  ) : (
    <strong><img
      src="https://bornholm-golf.dk/derby/static/totalisator3.png"
      alt="totalisator"
      style={{ maxWidth: "75%", borderRadius: "6px" }}
    /></strong>
  )}

</button>
  </div>
)}
  </>
) : (
  <button onClick={() => {setShowRaceView(true) && setIsRacePaused(false)}} style={{ marginLeft: "8px", maxWidth: "38%", borderRadius: "12px", backgroundColor: "#98C48F", border: "2px solid #d32f2f" }}>
  <p style={{ fontStyle: "bold", marginTop: "10px", fontSize: "24px" }}>
     <strong>Galopløbet er i gang!</strong><br/> <img src="https://bornholm-golf.dk/derby/static/vinderjubel.png" alt="crowd" style={{ maxWidth: "50%", borderRadius: "2px" }} /><br/>
🕐 Løbet er midlertidigt sat på pause, så der kan handles eller tilbagebetales lån mv.<br/>
	 <strong> 🌳 Tryk for at vende tilbage til galopbanen 🏇🏼</strong>
	 </p></button>
)}
    </div>
{/* Spillerstatus – samlet oversigt */}
<div className="game-container">
  <div className="player-status">
    <h3>👨🏼‍🦰 Spillerstatus – samlet beholdning for hver spiller</h3>
    <ul>
      {players.map(player => {
        const stats = playerStats[player] || {};
        const money = stats.money || 0;
        const wins = stats.wins || 0;
        const loan = playerLoans[player] || 0;

        /* 🐴 Hesteværdi */
        const horses = playerHorses[player] || [];
        const horseValue = horses.reduce((sum, h) => {
          const base =
            shuffledHorsesByAge?.[h.age]?.price ??
            horseStartPrice?.[h.age] ??
            h.price ??
            20000;
          return sum + Math.round(base * Math.pow(1.25, h.wins || 0));
        }, 0);

        /* 🏢 Almindelige selskaber */
        const ownedCompanies = Object.entries(companies || {}).filter(
          ([name, info]) => info.owner === player && name.includes("A/S")
        );

        /* 💰 Finansielle selskaber */
        const ownedFinancials = Object.entries(companies || {}).filter(
          ([name, info]) =>
            info.owner === player &&
            (name.includes("Galopforsikring") ||
              name.includes("Hotel") ||
			  name.includes("BornTAXI") ||
              name.includes("BronzeCar"))
        );

        /* 💶 Obligationer */
        const obligationCount = obligations?.owners?.[player] || 0;
        const obligationValue = obligationCount * (obligations?.price || 0);

        /* 🪙 Toto-aktier */
        const totoCount = totoShares?.owners?.[player] || 0;
        const totoValue = totoShareValues?.[player] || 0;

        /* 🏦 Andelsbanken */
        const andelsValue = andelsBankShareValues?.[player] || 0;

        /* 💼 Samlet investering */
        const investmentValue =
          investmentForPlayer(player) +
          obligationValue +
          totoValue +
          andelsValue;

        /* 💸 Total formue */
        const total =
          money - loan + horseValue + investmentValue;

        return (
          <li key={player} style={{marginBottom: "6px", position: "relative", paddingRight: "220px" // plads til knappen
  }}>
            <strong>{player}</strong> 💰 Kontanter: <strong>{kr(money)} kr.</strong> | 🧾 Lån: {kr(loan)} kr. | 🏢 Investeringer: {kr(investmentValue)} kr. |  💸 Total:<strong> {kr(total)} kr.</strong>
			<button
  onClick={() => setShowHorseMarket(player)}
  style={{
    position: "absolute",
    top: "4px",
    right: "10px",
    fontSize: "15px",
    padding: "4px 6px",
    background: "#DECDBC",
    border: "1px solid #000",
    borderRadius: "4px",
    cursor: "pointer",
    whiteSpace: "nowrap"
  }}
>
  Hestemarked og lånemarked
</button>
<br />🐴 Hesteværdi: <strong>{horseValue.toLocaleString()} kr.</strong> | 🏆 {wins} sejre | 
        
             <br/>🏢 Selskaber ({ownedCompanies.length}/3):{" "}
                {ownedCompanies.length > 0 ? (
                  ownedCompanies.map(([name, info]) => (
                    <span
                      key={name}
                      onClick={() => {
                        const purchasePrice = info.price || 0;
                        const endValue = Math.round(purchasePrice * 0.75);
                        const payout = companyPayoutMap[name] ?? 0;

                        setShowCompanyDoc({
                          name,
                          owner: player,
                          price: purchasePrice,
                          endValue,
                          payout,
						  image: info.image
                        });
                      }}
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "underline",
                        marginRight: "8px"
                      }}
                    >
                      {name} |</span>
                  ))
                ) : (
                  "Ingen"
                )}<br/>🏦 Andelsbank ({andelsBank?.owners?.[player] || 0} stk.): {kr(andelsValue)} kr. | 💰 Finans invest. ({ownedFinancials.length + obligationCount}/2):{" "}
                {ownedFinancials.length > 0 ? (
                  ownedFinancials.map(([name, info]) => (
                    <span
                      key={name}
                      onClick={() =>
                        setShowFinancialDoc({
                          name,
                          owner: player,
                          price: info.price,
                          value: info.price,
                          payout: info.fee,
                          payoutType: "afkast pr. løb"
                        })
                      }
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "underline",
                        marginRight: "8px"
                      }}
                    >
                      {name} ({info.fee.toLocaleString()} kr.)
                    </span>
                  ))
                ) : (
                  " " 
                )}
              {/* 💶 Obligationer */}
                | 💶 Obligationer:{" "}
                {obligationCount > 0 ? (
                  <span
                    onClick={() =>
                      setShowFinancialDoc({
                        name: "Obligation",
                        owner: player,
                        price: obligations.price,
                        value: obligations.price,
                        payout: obligations.interest,
                        payoutType: "fast rente efter hvert løb"
                      })
                    }
                    style={{
                      cursor: "pointer",
                      color: "blue",
                      textDecoration: "underline"
                    }}
                  >
                    {obligationCount} stk. ({obligationValue.toLocaleString()} kr.)
                  </span>
                ) : (
                  "Ingen"
                )} | 🪙 TOTO-Aktier:{" "}
                {totoCount > 0 ? (
                  <span
                    onClick={() =>
                      setShowFinancialDoc({
                        name: "🪙 Aktie i Totosyndikatet 🪙",
                        owner: player,
                        price: 35000,
                        value: totoValue,
                        payout: totoValue,
                        payoutType: `værdi afhænger af syndikatets saldo (${kr(totoSyndicate.balance)})`
                      })
                    }
                    style={{
                      cursor: "pointer",
                      color: "blue",
                      textDecoration: "underline"
                    }}
                  >
                    {totoCount} stk. ({kr(totoValue)} kr.)
                  </span>
                ) : (
                  "Ingen"
                )}
<hr/>
          </li>
        );
      })}
    </ul>
 <button onClick={() => setShowHelp(true)} style={{ marginLeft: "10px", fontSize: "16px", color: "#fffd55", backgroundColor: "#B489C2", border: "1px solid #0023f5" }}>
    Hjælp til spillet 💁🏼
  </button> 
  {!raceStarted && (
  <button onClick={saveGame} style={{ marginLeft: "10px", fontSize: "16px", border: "1px solid #0023f5" }}>💾 Gem spillet</button>
)}  
  <button onClick={() => setShowRaceProgram(true)} style={{ marginLeft: "10px", fontSize: "16px", color: "#fffd55", backgroundColor: "#B489C2", border: "1px solid #0023f5" }}>
    Vis dagens løbsprogram 🏁</button>
	<button style={{ marginLeft: "10px", fontSize: "16px", color: "#fffd55", backgroundColor: "#B489C2", border: "1px solid #0023f5" }} 
	onClick={() => setShowSeasonBox(true)}>🚶🏼‍➡️Vis sæsonstilling</button>
	
  {showRaceProgram && (
  <div
    style={{
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      background: "#FFECD0",
      border: "8px double #C47B24",
      borderRadius: "10px",
      padding: "20px",
      zIndex: 1000,
      maxWidth: "80%",
      maxHeight: "90%",
      overflowY: "auto",
    }}
  >
    <h2>🏇 Dagens løbsprogram på Nordskovens Galopbane📝</h2><h3>🏁 Dagens program er løbsdag nr. {Math.min(seasonHistory.length + (gameOver ? 0 : 1), seasonLength)} ud af sæsonens {seasonLength} løbsdage 🏁</h3><hr/>
    <ul style={{ listStyle: "none", padding: 0 }}>
  {raceProgram.map((race, index) => (
    <li key={index} style={{ marginBottom: "15px", padding: "10px", borderBottom: "1px solid #ccc" }}>
      <strong>Løb {index + 1}:</strong> {race.description}
      <br />
      <span style={{ fontSize: "1.1em", color: "#333" }}>
      Præmiestørrelser: 🥇 {race.prizes.first} kr, 🥈 {race.prizes.second} kr, 🥉 {race.prizes.third} kr, 🎖️ {race.prizes.forth} kr
      </span>
    </li>
  ))}
</ul>
    <button
      style={{
        backgroundColor: "#c8e6c9",
        border: "1px solid #388e3c",
		borderRadius: "6px",
        padding: "6px 12px",
        fontSize: "16px"
      }} onClick={() => setShowRaceProgram(false)}>Luk</button>
  </div>
  )}
  
  {showSeasonBox && (
  <div
    style={{
      marginTop: "12px",
      padding: "10px",
      textAlign: "left",
      backgroundColor: "#f0f8ff",
      border: "1px solid #90caf9",
      borderRadius: "8px",
      zIndex: 1000,
      maxWidth: "95%"
    }}
  >
    <h3>
      📊 Aktuel sæsonstilling før denne løbsdag
      {" "}
      (efter {seasonHistory.length} løbsdag
      {seasonHistory.length === 1 ? " " : "e "}) {" "} - {" "}

      <button
        style={{
          textAlign: "center",
          marginLeft: "10px",
          backgroundColor: "#aacdd2",
          fontSize: "18px",
          borderRadius: "6px",
          border: "1px solid #d32f2f"
        }}
        onClick={() => setShowSeasonBox(false)}
      >
        Luk box
      </button>
    </h3> 
    <h4>
      Efter hver løbsdag gemmes resultaterne for hver spiller. Sæsonen løber over i alt {seasonLength} løbsdage.
    </h4>

    <div
      style={{
        fontSize: "18px",
        fontWeight: "bold",
        margin: "6px 0 10px"
      }}
    >
      🏁 Løbsdag{" "}
      {Math.min(
        seasonHistory.length +
          (gameOver ? 0 : 1),
        seasonLength
      )}{" "}
      af {seasonLength}
    </div>

    {seasonHistory.length >= seasonLength && (
      <div
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          margin: "4px 0 10px",
          padding: "6px 8px",
          backgroundColor: "#fff9c4",
          borderRadius: "6px"
        }}
      >
        🏆 Ved sæsonafslutningen er netto kontanter, selskabsformue, finansielle selskaber og obligationer lagt til sæsonscoren.
        <br />
        Hesteværdier, TOTO og Andelsbanken er allerede medregnet løbsdag for løbsdag.
      </div>
    )}

    <ol>
      {seasonResults.map((p, i) => (
        <li
          key={i}
          style={{
            marginBottom: "16px",
            padding: "10px",
            backgroundColor: "#ffffff",
            border: "1px solid #c8c8c8",
            borderRadius: "8px"
          }}
        >
          <div
            style={{
              fontSize: "19px",
              fontWeight: "bold",
              marginBottom: "8px"
            }}
          >
            🏁 {p.navn}
          </div>
 <div
            style={{
              marginTop: "10px",
              padding: "8px",
              backgroundColor: "#E8F5E9",
              border: "2px solid #81C784",
              borderRadius: "6px",
              fontSize: "18px"
            }}
          >
            💼 <strong>Sæsonstilling:</strong>{" "}
            <strong>
              {Math.round(
                p.visningsTotal ?? 0
              ).toLocaleString()} kr.
            </strong>
          </div>
          <div
            style={{
              fontSize: "17px",
              lineHeight: "1.55"
            }}
          >
            Heraf udgør: <br />
💵 Netto kontanter {Math.round(p.netCash ?? 0).toLocaleString()} kr. |{" "}
🏢 Selskabsformue {Math.round(p.companyValue ?? 0).toLocaleString()} kr. |{" "}
🛡️ Sikker investering {Math.round(p.secureInvestmentValue ?? 0).toLocaleString()} kr. |{" "}
💶 Obligationer {Math.round(p.obligationValue ?? 0).toLocaleString()} kr. | {" "}<br />
🐴 Samlet hesteværdi {Math.round(p.horsesValue ?? 0).toLocaleString()} kr. |{" "}
🎯 Samlet TOTO-gevinst {Math.round(p.totoValue ?? 0).toLocaleString()} kr. |{" "}
🏦 Samlet Andelsgevinst {Math.round(p.andelsBankValue ?? 0).toLocaleString()} kr.
        <br /> 
          </div>

         

          <div
            style={{
              marginTop: "5px",
              fontSize: "14px",
              color: "#555"
            }}
          >
            Registreret efter {p.spil ?? "?"} løbsdag
            {p.spil === 1 ? "" : "e"}.
          </div>
        </li>
      ))}
    </ol>
  </div>
)}
  <hr />

{showFinancialDoc && (
  <div
    style={{
      position: "fixed",
      top: "23%",
      left: "38%",
      transform: "translate(-50%, -50%)",
      background: "#F4F7CB",
      border: "5px double #767862",
      borderRadius: "12px",
      padding: "20px 30px",
      zIndex: 3000,
      boxShadow: "0 0 20px rgba(0,0,0,0.5)",
      width: "460px",
      fontFamily: "'Times New Roman', serif",
      textAlign: "center",
      marginTop: "16px"
    }}
  >
    <h2 style={{ textAlign: "center" }}>📜 Investeringsdokument 💶</h2>
	<h1>
      <p><strong>{showFinancialDoc.name}</strong></p>
    </h1>
	<h2><strong>Ejer:</strong> {showFinancialDoc.owner}</h2>
    <h3>
      <p>
        <strong>Købspris:</strong> {showFinancialDoc.price.toLocaleString()} kr. |{" "}
        <strong>Slutværdi (80%):</strong> {Math.round(showFinancialDoc.value * 0.80).toLocaleString()} kr.
      </p>
      <p>
        <strong>Afkast:</strong> {showFinancialDoc.payout.toLocaleString()} kr.{" "}
        {showFinancialDoc.payoutType}
      </p>
    </h3>

    {/* Note om maks. 2 af de tre finansselskaber */}
    {(showFinancialDoc.name.includes("Obligation") ||
      showFinancialDoc.name.includes("Hotel") ||
	  showFinancialDoc.name.includes("BornTAXI") ||
	  showFinancialDoc.name.includes("BronzeCar") ||
      showFinancialDoc.name.includes("Galopforsikring")) && (
      <p style={{ fontStyle: "italic", marginTop: "10px", color: "#444" }}>
        🔒 Bemærk: Hver spiller kan maks eje <strong>to</strong> Obligationer og to af Hotel, BornTAXI, Bilservice eller Galopforsikring.
      </p>
    )}

    <div style={{ textAlign: "center", marginTop: "16px" }}>
      <button
        onClick={() => setShowFinancialDoc(null)}
        style={{
          backgroundColor: "#fffd55",
          border: "2px solid #d32f2f",
          borderRadius: "8px",
		  fontSize: "16px",
          padding: "6px 12px",
          cursor: "pointer"
        }}
      >
        Luk dokument
      </button>
    </div>
  </div>
)}


{/* 📜 Popup-dokument */}
{showCompanyDoc && (
  <div
    style={{
      position: "fixed",
      top: "23%",
      left: "15%",
      transform: "translate(-50%, -50%)",
      background: "#F7F18C",
      border: "5px dashed #AB9333",
      borderRadius: "8px",
      padding: "10px 20px",
      zIndex: 2000,
      boxShadow: "0 0 20px rgba(0,0,0,0.5)",
      width: "470px",
      fontFamily: "'Times New Roman', serif",
      animation: "popIn 0.6s ease",
	  textAlign: "center", marginTop: "16px"
    }}
  >
    <h2>📜 Selskabsdokument 💰</h2>
	<img
    src={showCompanyDoc.image}
    alt={showCompanyDoc.name}
    style={{
      width: "220px",
      height: "auto",
      margin: "10px auto",
      display: "block",
      border: "3px solid #AB9333",
      borderRadius: "8px",
      background: "#fff"
    }}
  />
    <h1><strong>{showCompanyDoc.name}</strong></h1>
    <h2><strong>Ejer:</strong> {showCompanyDoc.owner}</h2>
    <h3><p><strong>Købspris:</strong> {showCompanyDoc.price.toLocaleString()} kr. <strong>  |  Slutværdi (75%):</strong> {showCompanyDoc.endValue.toLocaleString()} kr.</p>
    <p>
      Afkast ved chancekort:<strong> {showCompanyDoc.payout.toLocaleString()} kr.</strong>
      <br />
      <em style={{fontSize: "0.9em"}}> (Beløbet modtages når et chancekort kræver betaling til selskabet)</em>
    </p></h3>

    <button onClick={() => setShowCompanyDoc(null)}
	style={{
          backgroundColor: "#fffd55",
          border: "2px solid #dd2f2f",
          borderRadius: "8px",
		  fontSize: "16px",
          padding: "6px 12px",
          cursor: "pointer"
        }}>Luk dokument</button>
      </div>
)}
{showHelp && (
  <div
    style={{
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      background: "#E8F0CD",
      border: "6px double #dd2f2f",
      borderRadius: "10px",
      padding: "20px",
      zIndex: 1000,
      maxWidth: "1800px",
      maxHeight: "95%",
      overflowY: "auto",
    }}
  >
    <h2>📝Hvad går spillet ud på 📝</h2><hr/>
    <h4>DERBY er et galopspil, hvor hver spiller får en hest og tager et banklån på kr. 25.000. Hesten har man i første løb. Man kan købe nye heste, passende til de forskellige løb. 
	Der er bonus på 30.000, hvis man har tre heste i sin stald og endnu en bonus på 30.000, hvis man også har en 5-åring - altså fuld stald.</h4>
<p>🏣 Spillet går ud på at den deltagende spiller, ifølge spillets galopprogram, som ses ved tryk på anden knap, skal tilmelde en af sine heste i alle løb, 
købe de rigtige heste og selskaber og forøge sin formue, for til sidst at vinde spillet. 🤖 Man spiller mod et antal computeranimerede spillere,
 der selv gør handler og vælger heste.<br/> 
Før løbet starter satser man på sin egen hest som vinderhest. Når alle spillere har tilmeldt en hest til løbet, vises knappen "...og starten er gået - Gå til galopbanen". 
Tryk på knappen og løbet starter automatisk og afvikles af sig selv. Hvert løb består af så mange runder, der skal til, for at hestene når målstregen ved felt 75 (52 i sprinterløbet). 
I hvert løb lander hestene på galopfelter, og så rykker ens hest lidt ekstra frem eller bliver stående, alt efter held.</p>
<p>På andre felter er det chancehandlinger der skal efterleves, hvilket spillet gør af sig selv. Man får bare besked om hvad der sker. 
Det foregår i en lind strøm og vises i bankfeltet eller i chancefeltet. Chancehandlinger er betaling eller modtagelse af kontanter fra banken, 
og mulighed for at satse på en vinderhest ud fra "staldtips" undervejs i løbet. Spilleren satser automatisk på den førende hest i løbet.<br/>
Man kommer også ud for at skulle betale for en ydelse til et selskab. Spillernes kontantbeholdning vises løbende under et løb. Man kan undervejs gå til Spiloversigten. 
Løbet sættes på pause og man kan gøre handler mv., og så vende tilbage til løbet. Det gælder derfor om at eje selskaber, så betaling går til spillerne indbyrdes, 
i stedet for til banken, der modtager ydelser, så længe selskaberne ikke er solgt. Får man underskud af kontanter undervejs i et løb, tildeles man automatisk 
et lån på kr. 20.000, som sammen med startlånet, kan afdrages undervejs, når man igen kommer til kontanter.</p>

<p>I hvert løb tildeles hver jockey en hjelmfarve og spillerne får også en tilfældig hjelmfarve. Har en spiller fået tildelt samme hjelmfarve som vinderhesten, er der gevinst. 
Gevinsten bestemmes ud fra odds. Der er også et Totosyndikat der satser på to hjelmfarver i hvert løb og gevinsterne indgår i Totosyndikatets saldo. 
Spillerne kan så ved køb af aktier (højst to) få del i totosyndikatets formue. Hver aktie giver 5% i afkast, 
hvis en chancehandling bestemmer at der skal udloddes afkast og saldoen er over 100000 kr. Når sidste løb er afsluttet udloddes altid 5% af saldoen pr. solgt aktie. Restbeløbet tilfalder banken.<br/><br/>

Der kan opstå "Krise" for galopspillet, og så må alle spillere betale 40% af deres kontanter til banken (dog højst 200.000), eller der kan opstå "Fremgang", så får alle spillere forøget 
deres kontantbeholdning med 40%, dog mindst 20.000 og højst 50.000. Begge dele kun en gang i hvert løb.<br/><br/>
En hest kan blive halt under et løb og i 1. løb er der ingen forsikring , men efter første løb forsikres din hest til de efterfølgende løb. 
Det vises med dette symbol 🛡️ved hver hest og det koster kr. 1.500 pr. løb og der betales automatisk til banken eller til ejeren af Galopforsikring ApS. 
Grunden er, at en chancehandling kan indebære, at din hest bliver halt under et løb, tages ud af løbet og sælges for 5.000 kroner. Er du så forsikret får du yderligere 45.000 kr. i erstatning.<br/>

<br/>Der skal også købes flere heste, så man har en valgbar hest til alle løb. Det sker i Hestemarkedet. Har man ikke kontanter nok, kan man låne et beløb, 
der gør at man kan købe en valgbar hest til næste eller kommende løb. Der kan lånes mellem 10 og 50 tusinde. Man kan også sælge heste og prisen afhænger om hesten har vundet løb. 
Der skal betales renter af lån efter hvert løb (2,5%).<br/>
Aktier, Andele, Obligationerne, Forsikringsselskabet, TAXI-selskabet, BronzeCar og Hotellet (kun 2-4 pr. deltager) kan kun erhverves af spillere, der på købstidspunktet er gældfrie. 
Der udbetales 1.000 kr. i obligationsrenter, 5.000 kr. i afkast til hotellejeren, 2.000 til BornTAXI og 3.500 i serviceindtægt til BronzeCar efter hvert løb. Galopforsikring ApS modtager kr. 1.500 fra hver forsikret hest før hvert løb. 
Før hvert løb får en spiller ved lodtrækning mulighed for at købe en andel. En andel koster kr. 50.000 og er rent sats, da afkastet udelukkende er 15% af slutsaldoen i banken efter hver løbsdag.</p>

<p>Spilleren der har førsteret i hvert løb har dette firkløver 🍀 foran sit navn. Rækkefølgen har betydning, hvis flere heste kommer over målstregen i samme runde eller er på linje om de øvrige placeringer.</p>

<p>Vinderen af løbsdagen er den spiller, der har størst formue efter sidste løb. Bemærk at alle selskabsinvesteringer gælder for hele sæsonen og tæller med 75% af købsværdien og tæller først med ved sæsonopgørelsen. Obligationer, Forsikringsselskab, BornTAXI, BronzeCar og Hotel tæller med 
80% ved sæsonopgørelse og er investeringer med fast afkast efter hvert løb. Andele og Heste tæller med i formueopgørelsen efter hver løbsdag med deres opnåede værdi for sejre plus 10%.
En god investering på løbsdagen er aktier, men også usikker, da afkastet afhænger at Totosyndikatets formue.<br/>
Efter hver løbsdag gemmes spillernes formue, mens kontantbeholdningen samt købte selskaber overføres til næste løbsdag. Man kan altså spare op til investeringer i selskaber der ikke kan erhverves med indtjeningen på en enkelt løbsdag.
Efter sidste løbsdag tillægges kontanter og selskabsformue til den eksisterende sæsonsaldo, og så kan se en samlet sæsonvinder efter det valgte antal løbsdage, og den samlede sæsonvinder hyldes.</p>

<p><strong>Lidt insiderviden! En hest der har vundet får lidt handicap i de løb den deltager i efterfølgende. En spiller der har honnøren er lidt bedre stillet i opløbet. 
Vurder hvor mange kontanter du vil have. Der kan komme tvunget reduktion (40%) ved chancehandling, men også forøgelse (40%) ved chancehandling.</strong></p>
<img src="https://bornholm-golf.dk/derby/static/animated-horse-image-0326.gif" alt="hest ved PC" style={{ maxWidth: "10%", borderRadius: "2px" }} />
<hr/>
    <button
      style={{
        backgroundColor: "#c8e6c9",
        border: "1px solid #388e3c",
		borderRadius: "6px",
        padding: "6px 12px",
        fontSize: "16px"
      }} onClick={() => setShowHelp(false)}>Luk</button>
  </div>
)}

{/* HorseMarket Popup */}
{showHorseMarket && (
  <div className="popup" style={{
    position: "fixed",
    top: "49%",
    left: "58.1%",
    transform: "translate(-50%, -50%)",
    background: "#DECDBC",
    border: "6px groove #CD7F32",
    borderRadius: "8px",
    textAlign: "center",
	padding: "5px",
    zIndex: 1000,
    width: "700px"
  }}>
  <h2>🐴 Hestemarked<br/>
     <button onClick={() => setShowHorseMarket(null)} style={{marginbottom: "10px", borderRadius: "6px", fontSize: "20px" }}>
    <img src="https://bornholm-golf.dk/derby/static/Stalde.png" alt="Stald" style={{ maxWidth: "100%", borderRadius: "6px" }}/>
	<br/>Luk hestemarkedet</button><br/> {showHorseMarket} har disse heste i sin stald 🏘️</h2>
	{bonusGiven[showHorseMarket]?.trio && (
  <p style={{ backgroundColor: "#D0F5A9", padding: "6px", borderRadius: "6px" }}>
    🎁 Staldbonus: Ejer 3 heste årgange – 30.000 kr. tilføjet!
  </p>
)}
{bonusGiven[showHorseMarket]?.fullSet && (
  <p style={{ backgroundColor: "#A9F5D0", padding: "6px", borderRadius: "6px" }}>
    🎁 Ekstra bonus: Har nu fuld stald – yderligere 30.000 kr.!
  </p>
)}
    {(playerHorses[showHorseMarket] || []).map(horse => {
  const basePrice = shuffledHorsesByAge[horse.age].price;
  const wins = horse.wins || 0;
  const value = Math.round(basePrice * Math.pow(1.25, wins));

  return (
    <div key={horse.name} style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      marginBottom: '6px' 
    }}>
      <span style={{marginbottom: "10px", borderRadius: "6px", fontSize: "20px" }}>
        <strong>{horse.name}</strong> ({horse.age} år) — Sejre: {wins} — Værdi: {value.toLocaleString()} kr.
      </span>

      <button
        onClick={() => {
          sellHorse(showHorseMarket, horse);
          updateBank(-value, `Banken køber hesten ${horse.name} fra ${showHorseMarket}`);
        }}
        style={{marginRight: "40px", marginBottom: "10px", borderRadius: "6px",  fontSize: "18px" }}
        onMouseOver={(e) => (e.target.style.backgroundColor = "#a5d6a7")}
        onMouseOut={(e) => (e.target.style.backgroundColor = "#fff8dc")}
      >
        Sælg
      </button>
    </div>
  );
})}
    <hr /><label style={{marginbottom: "10px", borderRadius: "6px", fontSize: "20px" }}>Vælg årgang: </label>
    <select 
      value={selectedAge} 
      onChange={e => setSelectedAge(parseInt(e.target.value))} style={{ marginLeft: "10px", fontSize: "16px"}}
    >
      <option value="">- Vælg årgang -</option>
      {Object.keys(shuffledHorsesByAge).map(age => (
        <option key={age} value={age}>{age}-årige</option>
      ))}
    </select>

    {selectedAge && shuffledHorsesByAge[selectedAge] ? (
      <>
        <h3>Ledige heste ({selectedAge}-årige)</h3>
        {shuffledHorsesByAge[selectedAge].names
          .filter(name => !allOwnedHorses.includes(name))
          .map(name => {
  const basePrice = shuffledHorsesByAge[selectedAge].price;
  const wins = horseWins[name] || 0;
  const value = Math.round(basePrice * Math.pow(1.25, wins));
     return (
    <div key={name} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
    <span>
    <strong>{name}</strong> — Sejre: {wins} — Pris: {basePrice.toLocaleString()} kr. — Værdi: {value.toLocaleString()} kr.
    </span>
    <button style={{marginRight: "40px", marginbottom: "10px", borderRadius: "6px", fontSize: "18px" }}
    onClick={() => {
    buyHorse(showHorseMarket, selectedAge, name);
	updateBank(+value, `Banken sælger hesten ${name} til ${showHorseMarket}`);
    }}
    onMouseOver={(e) => (e.target.style.backgroundColor = "#a5d6a7")}
    onMouseOut={(e) => (e.target.style.backgroundColor = "#fff8dc")}>
                  Køb
                </button>
              </div>
            );
          })
        }
        {shuffledHorsesByAge[selectedAge].names.filter(name => !allOwnedHorses.includes(name)).length === 0 && (
          <p>Ingen ledige {selectedAge}-årige tilbage.</p>
        )}

        {/* 💳 Lån penge felt */}
        <div style={{ marginTop: "10px", fontSize: "18px" }}>
          <hr /><h1>🏦 Derby Banken ☘️</h1><label>💳 Lån penge til valgbar hest eller en anden hest:</label>
          <select
            value={loanSelections[showHorseMarket] || ""}
            onChange={e =>
              setLoanSelections(prev => ({ ...prev, [showHorseMarket]: e.target.value }))
            }
            style={{ marginLeft: "10px", fontSize: "16px"}}
          >
            <option value="">Vælg beløb</option>
            <option value="10000">10.000 kr.</option>
            <option value="20000">20.000 kr.</option>
            <option value="30000">30.000 kr.</option>
            <option value="40000">40.000 kr.</option>
            <option value="50000">50.000 kr.</option>
          </select>
          <button
            onClick={() => {
              const amount = parseInt(loanSelections[showHorseMarket]);
              if (![10000,20000,30000,40000,50000].includes(amount)) {
                alert("Vælg et gyldigt beløb.");
                return;
              }
              setPlayerLoans(prev => ({
                ...prev,
                [showHorseMarket]: (prev[showHorseMarket]||0) + amount
              }));
              setPlayerStats(prev => ({
                ...prev,
                [showHorseMarket]: {
                  ...prev[showHorseMarket],
                  money: prev[showHorseMarket].money + amount
                }
              }));
              //alert(`${showHorseMarket} har lånt ${amount.toLocaleString()} kr.`);
              setLoanSelections(prev => ({ ...prev, [showHorseMarket]: "" }));
            }}
            disabled={!loanSelections[showHorseMarket]}
            style={{ marginLeft: "10px", fontSize: "16px" }}
	onMouseOver={(e) => (e.target.style.backgroundColor = "#a5d6a7")}
    onMouseOut={(e) => (e.target.style.backgroundColor = "#C47B24")}
          >
            Bekræft lån
          </button><p>
		  {horseMarketMessage && (
  <div style={{
    marginTop: "16px",
    padding: "8px",
    backgroundColor: "#FFD40F",
    border: "1px solid #0D0602",
    borderRadius: "6px",
    color: "#0D0602"
  }}>
    {horseMarketMessage}
  </div>
)}
 </p></div>
      </>
    ) : (
      <p>Vælg en årgang for at se heste der er til salg.</p>
    )}

  </div>
)}
</div>

{/* 📉 Afdrag lån og bankoplysninger */}
<div className="repay-loan" style={{ backgroundColor: "#d4f8d4", border: "6px double #000", padding: "10px", margin: "10px", borderRadius: "8px" }}>
  <h3>🏦 Bankinformation: Afdrag lån, og bring gælden ned.<br/>Nyt lån optages i Hestemarked.</h3>

  <label>Spiller:</label>
  <select
    value={repayPlayer}
    onChange={(e) => setRepayPlayer(e.target.value)}
    style={{ marginLeft: "6px", marginBottom: "8px" }}
  >
    <option value="">Vælg spiller</option>
    {players.map(player => (
      <option key={player} value={player}>{player}</option>
    ))}
  </select>  <label>Beløb:</label>
<select
  value={repayAmount}
  onChange={(e) => setRepayAmount(e.target.value)}
  style={{ marginLeft: "10px", marginRight: "10px", width: "120px" }}
>
  <option value="">Vælg afdrag</option>
{playerLoans[repayPlayer] && (
    <option value={playerLoans[repayPlayer]}>
      {playerLoans[repayPlayer].toLocaleString()} kr.
    </option>
  )}
  {[5000, 10000, 15000, 25000, 30000, 50000].map(amount => (
    <option key={amount} value={amount}>{amount.toLocaleString()} kr.</option>
  ))}
</select>
<button
  disabled={!repayPlayer || !playerLoans[repayPlayer]}
  onClick={() => {
    const saldo = playerLoans[repayPlayer];
    setRepayAmount(saldo.toString());
  }}
  style={{
    marginRight: "6px",
    padding: "2px 6px",
    backgroundColor: "#fff200",
    border: "1px solid #8bc34a",
    borderRadius: "4px",
    cursor: "pointer"
  }}
>
  💸 Al gæld
</button>

  <button style={{
          padding: "2px 8px", marginLeft: "10px", backgroundColor: "#ffcdd2", 
		  border: "1px solid #8aa38c",
          borderRadius: "2px"
        }} onClick={() => {
    const amount = parseFloat(repayAmount);

    if (!repayPlayer || isNaN(amount)) {
      alert("Indtast både et gyldigt spillernavn og beløb");
      return;
    }

    if (!playerStats[repayPlayer]) {
      alert("Spilleren findes ikke. Prøv igen.");
      return;
    }

    repayLoan(repayPlayer, amount);
    setRepayPlayer("");
    setRepayAmount("");
  }}>
    Betal
  </button>

  <h4>💰 ➕➖ Bank- og Forsikrings-beskeder før og efter løbet: 🛡️</h4>
{insuranceMessages.length > 0 && (
  <div className="fade-out">
    {insuranceMessages.map((msg) => (
      <p
        key={msg.id}
        style={{
          color: "#000",
          opacity: msg.fading ? 0 : 1,
          transition: "opacity 2s ease-in-out",
          margin: 0
        }}
      >
        {msg.text}
      </p>
    ))}
  </div>
)}
  
  {loanMessages.length > 0 && (
  <div className="fade-out">
  {loanMessages.map(msg => (
    <p
      key={msg.id}
      style={{
        opacity: msg.fading ? 0 : 1,
        transition: "opacity 2s ease-in-out",
        margin: 0
      }}
    >
      {msg.text}
    </p>
  ))}
</div> 
)}<hr/>
<div style={{
  maxHeight: "800px",
  overflowY: "auto",
  backgroundColor: "#f9fff9",
  border: "1px solid #ccc",
  borderRadius: "6px",
  padding: "6px",
  fontSize: "14px"
}}>
  {bankLog.slice(-16).map((line, i) => (
    <p key={i} style={{ margin: "2px 0" }}>{line}</p>
  ))}
</div>
<h3>🏦 Andelsbanken ☘️  <br />
Følg bankens beholdning - Aktuel saldo: {kr(bankBalance)} kr.</h3>

{/* 🏦 Andelsbanken */}
<div
  style={{
    marginTop: "2px",
    border: "2px solid #444",
    borderRadius: "8px",
    padding: "8px 12px",
    background: "#eef8ee",
	fontsize: "16px",
	marginBottom: "6px"
  }}
>
  🏦 <strong>Køb en andel i Andelsbanken</strong> - {" "} 6 andele pr. løbsdag. {" "} <button
    disabled={
      !selectedInvestor ||
      andelsBank.lotteryPlayer !== selectedInvestor ||
      !!andelsBank.boughtThisRace?.[selectedInvestor] ||
      (playerLoans[selectedInvestor] || 0) > 0 ||
      (playerStats[selectedInvestor]?.money || 0) < andelsBank.price ||
      Object.values(andelsBank.owners || {})
        .reduce((a, b) => a + b, 0) >= andelsBank.total
    }
    onClick={() => buyAndelsBankShare(selectedInvestor)}
    style={{
      marginTop: "2px",
      padding: "4px 8px",
      borderRadius: "6px",
      backgroundColor: "#fff8dc",
      border: "1px solid #747833"
    }}
	onMouseOver={(e) =>
      (e.target.style.backgroundColor = "#a5d6a7")
    }
    onMouseOut={(e) =>
      (e.target.style.backgroundColor = "#fff8dc")
    }
  >
    Køb andel (50.000 kr.)
  </button>
  <p style={{ margin: "4px 0", fontWeight: "bold", fontSize: "16"}}>
    🎟️ Købsretten i dette løb går til: <strong>{andelsBank.lotteryPlayer || "Ingen - ikke nok kontanter eller udsolgt"} 💵</strong> 
  </p>
  <p style={{ margin: "4px 0" }}>
     ({andelsBank.total - Object.values(andelsBank.owners || {})
        .reduce((a, b) => a + b, 0)}{" "}
    stk. tilbage af dagens beholdning.)
  </p>

  <p style={{ margin: "4px 0", fontStyle: "italic" }}>
    Kun den udtrukne spiller kan købe 1 andel i dette løb, hvis spilleren har 50.000 kr. og ingen gæld.
  </p>

  {Object.entries(andelsBank.owners || {}).length === 0 ? (
    <p style={{ marginBottom: 0 }}>
      Ingen har endnu købt en andel i dag.
    </p>
  ) : (
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "8px"
      }}
    >
      <thead>
        <tr style={{ textAlign: "left" }}>
          <th>Spiller</th>
          <th>Andele</th>
          <th>Prognogse for nettogevinst (15%).</th>
        </tr>
      </thead>

      <tbody>
        {Object.entries(andelsBank.owners).map(([player, count]) => (
          <tr key={player}>
            <td>{player}</td>
            <td>{count}</td>
            <td>
  {kr(count * (bankBalance * 0.15)-(count * 50000))}{" "} kr.
</td>
          </tr>
        ))}
      </tbody>
    </table>
  )}
</div>


{/* 💼 Aktier i Totosyndikatet */}


<div
  style={{
    marginTop: "2px",
    border: "2px solid #444",
    borderRadius: "8px",
    padding: "4px 8px",
    background: "#fffbe6",
  }}
>

  💼 <strong>Køb aktier i Totosyndikatet -  10 aktier pr. løbsdag.</strong> {" "}
  

  <button
    disabled={
      !selectedInvestor ||
      (playerLoans[selectedInvestor] || 0) > 0 ||
      (playerStats[selectedInvestor]?.money || 0) < 35000 ||
      Object.values(totoShares.owners || {})
        .reduce((a, b) => a + b, 0) >= totoShares.total ||
      (totoShares.owners?.[selectedInvestor] || 0) >= 2
    }
    onClick={() => buyTotoShare(selectedInvestor)}
    style={{
      marginTop: "6px",
      padding: "4px",
      borderRadius: "6px",
      backgroundColor: "#fff8dc",
      border: "1px solid #747833"
    }}
    onMouseOver={(e) =>
      (e.target.style.backgroundColor = "#a5d6a7")
    }
    onMouseOut={(e) =>
      (e.target.style.backgroundColor = "#fff8dc")
    }
  >
    Køb aktie (35.000 kr.)
  </button>
<br />(
  {totoShares.total - Object.values(totoShares.owners || {})
      .reduce((a, b) => a + b, 0)}{" "}
  stk. tilbage af dagens beholdning) Der kan højest købes 2 aktier pr. spiller.
  ){" "}
  <h4 style={{ marginBottom: "6px" }}>
    💼 Aktieværdier i Totosyndikatet {" "} - saldo: {kr(totoSyndicate.balance)} kr.</h4>

  {Object.entries(totoShares.owners || {}).length === 0 ? (
    <p style={{ marginBottom: 0 }}>
      Ingen har endnu erhvervet aktier.
    </p>
  ) : (
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse"
      }}
    >
      <thead>
        <tr style={{ textAlign: "left" }}>
          <th>Spiller</th>
          <th>Aktier</th>
          <th>Foreløbig aktiegevinst</th>
        </tr>
      </thead>

      <tbody>
        {Object.entries(totoShares.owners).map(([player, count]) => {
          const value =
            totoShareValues?.[player] || 0;

          const totalValue = kr(value);

          return (
            <tr key={player}>
              <td>{player}</td>
              <td>{count}</td>
              <td>{totalValue} kr.</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  )}
</div>

</div>
    <div className="companies">
  <h3>🪙 Selskaber og værdipapirer der kan købes af spillerne</h3>

  <label>Vælg investor:</label>
  <select
    value={selectedInvestor}
    onChange={e => setSelectedInvestor(e.target.value)}
    style={{ marginLeft: "10px", marginBottom: "10px", backgroundColor: "#fff8dc", }}
  >
    <option value="">- Vælg spiller -</option>
    {players.map(player => (
      <option key={player} value={player}>{player}</option>
    ))}
  </select>
 {investmentMessage && (
    <div style={{
      marginTop: "10px",
      padding: "8px",
      backgroundColor: "#fff8dc",
      border: "1px solid #747833",
      borderRadius: "6px",
      color: "#515424"
    }}>
      {investmentMessage}
    </div>
  )}
  <ul>
    {Object.entries(companies).map(([companyName, info]) => (
      <li key={companyName}>
        {companyName} – Ejer: {info.owner || "Banken "}
        {!info.owner && (
          <button
            disabled={!selectedInvestor || (playerStats[selectedInvestor]?.money || 0) < info.price }
            onClick={() => investInCompany(selectedInvestor, companyName)}
            style={{ marginbottom: "10px", borderRadius: "6px" }}
	onMouseOver={(e) => (e.target.style.backgroundColor = "#a5d6a7")}
    onMouseOut={(e) => (e.target.style.backgroundColor = "#fff8dc")}
          >
            Invester ({info.price.toLocaleString()} kr.) - Afkast ({info.fee.toLocaleString()})
          </button>
        )}
      </li>
    ))}
  </ul><hr/>
  <p>💶 <strong>Obligationer</strong> {obligations.total} stk. i puljen - Renter efter hvert løb. <button
    disabled={!selectedInvestor || obligations.total <= 0  ||
	(playerLoans[selectedInvestor] || 0) > 0 ||
    (playerStats[selectedInvestor]?.money || 0) < 25000 }
    onClick={() => buyObligation(selectedInvestor)}
    style={{ marginTop: "6px", padding: "4px", borderRadius: "6px", backgroundColor: "#fff8dc", border: "1px solid #747833" }}
    onMouseOver={(e) => (e.target.style.backgroundColor = "#a5d6a7")}
    onMouseOut={(e) => (e.target.style.backgroundColor = "#fff8dc")}
  >
    Køb ({obligations.price.toLocaleString()} kr.) - Renter ({obligations.interest.toLocaleString()})
  </button>
</p>

{Object.keys(obligations.owners || {}).length > 0 ? (
  <ul>
    {Object.entries(obligations.owners).map(([player, count]) => (
      <li key={player}>
        {player}: {count} stk.
      </li>
    ))}
  </ul>
) : (
  <p>Ingen har købt obligationer endnu.</p>
)}
<hr/>

</div>
        </div>
        
      </>
    )}
	
{showRaceView && (
  <div style={{
    position: "fixed",
    top: "7vh", left: 2, right: 2, bottom: 0,
    backgroundColor: "#BCCC9Dcc",
    zIndex: 9999,
    display: "flex",
     justifyContent: "center",
    alignItems: "flex-start",
    paddingTop: "2vh"
  }}>
    <div style={{
  background: "#7FB36A",//D3F28E
  padding: "6px",
  borderRadius: "12px",
  width: "95%",
  maxWidth: "2250px",
  minHeight: "530px",
  maxHeight: "88vh", // 👈 boksen bliver aldrig højere end 88% af skærmen
  overflowY: "auto",
  boxShadow: "0 0 20px rgba(0,0,0,0.4)" // 👈 RETTET version
}}>
      <h1 style={{
        textAlign: "center",
        marginBottom: "8px",
        color: "#333",
        textShadow: "2px 1px 2px #aaa",
        fontSize: "2.3em",
        letterSpacing: "2px"
      }}>
       🍀 🌳 Løbet er i gang på NORDSKOVENS GALOPBANE 🌳 🍀
      </h1>
<h2 style={{
        textAlign: "center",
        fontSize: "1.5em",
        fontStyle: "italic",
        color: "darkgreen"
      }}>
        🧾 Betingelser: {raceProgram[derivedRaceIndex].description}
      </h2>
      <h3 style={{
        textAlign: "center",
        marginBottom: "16px",
        color: "#333",
        textShadow: "2px 1px 2px #aaa",
        fontSize: "1.6em",
        letterSpacing: "2px"
      }}>
        Løb {raceCount + 1} af {totalRaces} med præmier på 🏆 {currentPrizes.first} til vinderen, {currentPrizes.second} til andenpladsen, {currentPrizes.third} til tredjepladsen og {currentPrizes.forth} til fjerdepladsen 🏇
      </h3>

      {/* Galopbanen og publikum */}
      <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-start", gap: "10px" }}>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", height: `${trackHeight}px`, fontSize: "1.3em" }}>
        </div>

        {/* Galopbane */}
<div style={{
  position: "relative",
  width: "100%",
  maxWidth: "1800px",
  height: `${trackHeight}px`,
  backgroundImage:
    "repeating-linear-gradient(90deg, #8BC34A 0px, #8BC34A 60px, #7CB342 60px, #7CB342 120px)",
  border: "4px solid rgba(255,255,255,0.7)",
  boxShadow: "inset 0 0 20px rgba(0,0,0,0.25)",
  borderRadius: "12px",
  overflow: "visible"
}}>
		{/* Startlinje */}
<div style={{
    position: "absolute",
    left: "-3px",
    top: "0",
    bottom: "0",
    width: "6px",
    backgroundColor: "#2e7d32",
    boxShadow: "2px 0 6px rgba(0,0,0,0.3)",
    zIndex: 1000,
  }}
></div>
          {/* Galop- og chancefelter */}
          {[...Array(trackLength).keys()].map(field => {
            const isGalop = galopFields.includes(field);
            const isChance = chanceFields.includes(field);
            if (!isGalop && !isChance) return null;

            const finishLinePercent = (trackLength === 52) ? 50 : 80;
            const leftPercent = (field / trackLength) * finishLinePercent;

            return (
              <div
                key={`field-${field}`}
                style={{
                  position: "absolute",
                  left: `${leftPercent}%`,
                  top: 0,
                  bottom: 0,
                  width: "1%",
                  background: isGalop ? "#" : "#F24D4135",//#6869F255blå
                  zIndex: 0,
                }}
              />
            );
          })}

          {/* Mållinje */}
<div style={{
  position: "absolute",
  left: `${(trackLength === 52) ? 50 : 80}%`,
  top: 0,
  bottom: 0,
  width: "4px",
  background: `
    repeating-linear-gradient(
      to bottom,
      #000 0px,
      #000 10px,
      #fff 10px,
      #fff 20px
    )
  `,
  boxShadow: "0 0 12px rgba(0,0,0,0.6)",
  zIndex: 20
}} />
{/* Slidspor */}
<div style={{
  position: "absolute",
  top: "20%",
  bottom: "20%",
  left: 0,
  right: 0,
  background: "linear-gradient(to bottom, rgba(0,0,0,0.07), transparent, rgba(0,0,0,0.07))",
  pointerEvents: "none",
  zIndex: 1
}} />

{/* Startport ramme */}
<div
  style={{
    position: "absolute",
    left: "-70px",
    top: "-3px",
    width: "65px",
    height: `${players.length * 50}px`,
    background: "#1f5a1f",
    borderRight: "4px solid #0f3c0f",
    borderLeft: "4px solid #0f3c0f",
    borderTop: "6px solid #0f3c0f",
    borderBottom: "6px solid #0f3c0f",
    borderRadius: "4px",
    boxShadow: "4px 0 10px rgba(0,0,0,0.3)",
    zIndex: 4,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "4px 0"
  }}
>
</div>
		  
{/* Startbokse */}
{players.map((player, index) => (
  <div
    key={player}
    style={{
      position: "absolute",
      left: "-60px",        // 🚀 Uden for banen
      top: `${6 + index * 52}px`,
      width: "60px",
      height: "38px",
      border: "2px solid #444",
      borderRadius: "2px",
      background: "#297A28",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "14px",
      zIndex: 5
    }}
  >
    {player.slice(0, 0)}
  </div>
))}

{/* Heste på banen med korrekt heste-GIF per random tildelt hestefarve */}
{players.map((player, index) => {
  const activeHorseName = selectedRaceHorse[player];
  const horse = playerHorses[player]?.find(h => h.name === activeHorseName);

  const finishLinePercent = trackLength === 52 ? 50 : 80;
  const leftPercent = horse
    ? Math.min((horse.position / trackLength) * finishLinePercent, finishLinePercent)
    : 0;

  const hasHonour = players[firstPlayerIndex] === player;
  const insured = horse ? insuredHorses[horse.name] : false;

  const jockeyEmoji = horse ? horseColors[horse.name] || "⚪" : "⚪";  
  const horseGifFile = horseColorGifMap[jockeyEmoji] || "horsered.gif"; // ny GIF i stedet for prik

  const playerEmoji = playerColors[player] || "⚪"; // spillerens eget ikon (jockeydragt)
  
  return (
    <React.Fragment key={player}>

      {/* 🐎 Vis hestens gallop-animation hvis aktiv og ikke haltet */}
      {horse && !horse.halted && (
        <div
  className="horse-step"
  style={{
    position: "absolute",
    left: horse.position === 0 ? "-30px" : `${leftPercent}%`,
    top: `${index * 45 + 10}px`,
    transition: "left 0.5s ease",
    whiteSpace: "nowrap",
    zIndex: 10,
    pointerEvents: "none"
  }}
>
  {/* Jordskygge */}
  <div
    style={{
      position: "absolute",
      left: "18px",
      bottom: "4px",
      width: "50px",
      height: "12px",
      background: "rgba(0,0,0,0.35)",
      filter: "blur(8px)",
      borderRadius: "50%",
      zIndex: -1
    }}
  />
          <img
            src={`https://bornholm-golf.dk/derby/static/${horseGifFile}?${Date.now()}`}
            alt="Galophest"
            style={{
              position: "relative",
  filter: "drop-shadow(0 10px 6px rgba(0,0,0,0.45)) drop-shadow(8px 14px 10px rgba(0,0,0,0.25))",
			  height: "65px",
              marginRight: "6px",
              verticalAlign: "middle"
            }}
          />
        </div>
      )}

      {/* 📊 Spiller/hest info-boks i højre side af banen */}
      <div
        style={{
          position: "absolute",
          right: "10px",
          top: `${6 + index * 48 + 14}px`,
          fontSize: "1.05em",
          color: "#1b3b10",
          background: horse ? "#9DD970" : "#EDEDED",
          padding: "2px 6px",
          borderRadius: "6px",
          opacity: horse?.halted ? 0.8 : 1,
        }}
      >
        {hasHonour && "🍀"}{" "}
        <strong>
          {player} {playerEmoji}
        </strong>

        {horse ? (
          <>
            {" "}→ {horse.name} ({horse.age} år) {insured && "🛡️"}
            {horse.halted && " ⚠️ (Halt)"}
            {/* 👇 hvis du vil se hestens random farve ved siden af navnet kan du fjerne kommentaren */}
            {/* <span style={{ marginLeft: "6px" }}>{jockeyEmoji}</span> */}
          </>
        ) : (
          <> {" "}→ <strong>🏥Hesten Halt og solgt</strong></>
        )}
      </div>

    </React.Fragment>
  );
})}

        </div>

        {/* Publikum højre */}
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", height: `${trackHeight}px`, fontSize: "1.7em" }}>
          {Array(6).fill(0).map((_, i) => <div key={i}>🧍🧑🏼‍🤝‍🧑🏻️‍ 🧑‍🤝‍🧑</div>)}
        </div>
      </div>

      {/* Knapper */}
      <div style={{ textAlign: "center", marginTop: "20px", marginBottom: "20px" }}>
  {!raceWinner && (
    <button
      style={{ marginLeft: "20px", backgroundColor: "#EAEDC0", borderRadius: "3px", border: "2px solid #d32f2f", fontSize: "18px" }}
      onClick={() => {
        setIsRacePaused(true); // pause løbet
        setShowRaceView(false); // vis spiloversigt
      }}
	  onMouseOver={(e) => (e.target.style.backgroundColor = "#a5d6a7")}
  onMouseOut={(e) => (e.target.style.backgroundColor = "#EAEDC0")}
    >
      Sæt løbet på pause! - Gå til spiloversigt<br/>Spilleren med 🍀 har honnøren når heste er på linje - Spillere med 🛡️ er forsikret ved halt hest
    </button>
  )}
  
  {raceWinner && (
  <div
    style={{
      position: "fixed",
      top: "35%",
      left: "15%",
      transform: "translate(-50%, -50%)",
      background: "#EAEDC0",//🎨 Hestene er i mål
      color: "#000",
      border: "3px solid #fff",
      borderRadius: "12px",
      padding: "8px",
      zIndex: 9999,
      maxWidth: "750px",
      boxShadow: "0 0 15px rgba(0,0,0,0.5)"
    }}
  >
    <h1>🏁 Hestene er i mål 🏁</h1>

    {raceWinner && selectedRaceHorse[raceWinner] && (
  <h2 style={{ marginTop: "8px", color: "#9C5312" }}>
    🎉 Tillykke med sejren til{" "}
    <span style={{ fontWeight: "bold" }}>
      {selectedRaceHorse[raceWinner]}
    </span>{" "}
    ejet af{" "}
    <span style={{ fontWeight: "bold" }}>
      {raceWinner}
    </span>
    {raceOdds && (
      <span style={{ color: "#2E7D32", marginLeft: "12px", fontSize: "20px" }}>
        💹 (Odds: <strong>{raceOdds}</strong>)
      </span>
    )}
  </h2>
)}

    <button
      style={{
        marginTop: "10px",
        backgroundColor: "#EAEDC0",
        border: "5px double #ccc",
        borderRadius: "6px",
        color: "#000",
        fontSize: "22px"
      }}
      onClick={() => {
        const applause = new Audio("https://bornholm-golf.dk/derby/static/trump.mp3");
        applause.volume = 0.2;
        applause.play().catch(err => console.log("Kunne ikke afspille trompet:", err));
		setStaldtipsMessages([]);
        setShowRaceView(false);
      }}
    ><br/>{(() => {
      // 🟢 Find vinders hest og dens farve
      const winningHorseName = selectedRaceHorse[raceWinner];
      const winningColor = horseColors[winningHorseName];
      let colorSuffix = "vinder.jpg"; // fallback

      if (winningColor === "🔴") colorSuffix = "vinderrød.png";
      else if (winningColor === "🟡") colorSuffix = "vindergul.png";
      else if (winningColor === "⚪") colorSuffix = "vinderhvid.png";
	  else if (winningColor === "🔵") colorSuffix = "vinderblå.png";

      const imageSrc = `https://bornholm-golf.dk/derby/static/${colorSuffix}`;

      return (
        <img
          src={imageSrc}
          alt={`vinderjockey-${colorSuffix}`}
          style={{
            maxWidth: "80%",
            borderRadius: "6px",
            marginTop: "6px",
            boxShadow: `0 0 25px 3px ${
              winningColor === "🔴"
                ? "rgba(255,0,0,0.5)"
                : winningColor === "🟡"
                ? "rgba(255,215,0,0.6)"
                : winningColor === "⚪"
                ? "rgba(255,255,255,0.7)"
                : "rgba(30,144,255,0.6)" // blå fallback
            }`,
          }}
        />
      );
    })()}<br/><br/>
      🏆 Gå til samlet præmieoversigt 🐎
    <br/><br/></button>
  </div>
)}
</div>

      {/* Beskedbokse */}
<div style={{
  display: "flex",
  justifyContent: "space-between",
  gap: "12px",
  width: "90%",
  height: "500px",
  maxWidth: "2200px",
  margin: "0 auto"
}}>
  
  {/* Galopfelt */}
  <div
    style={{
      flex: 0.8,
      backgroundColor: "#D0E9FF",
      padding: "10px",
      borderRadius: "6px",
      height: "400px",
      display: "flex",
      flexDirection: "column"
    }}
  >
    <h4 style={{ marginTop: 0 }}>💶 Økonomisk udvikling under løbet 💰</h4>

    {/* 💰 Udvikling af kontantbeholdning under løbet */}
    {showRaceView && (
      <div
        style={{
          backgroundColor: "rgba(255,255,255,0.9)",
          border: "2px solid #7AAD08",
          borderRadius: "10px",
          padding: "8px 14px",
          fontSize: "14px",
          color: "#1b3b10",
          minWidth: "180px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          marginTop: "6px"
        }}
      >
        <h4 style={{ margin: "2px 0 6px", textAlign: "center" }}>
          💰 Udvikling af spillernes kontantbeholdning under løbet
        </h4>

        {players.map((p, i) => {
          const richest = Math.max(...players.map(pl => playerStats[pl]?.money || 0));
          const money = playerStats[p]?.money || 0;

          return (
            <div
              key={i}
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: money === richest ? "bold" : "normal",
                color: money === richest ? "#2e7d32" : "#1b3b10",
              }}
            >
              <span>{p}</span>
              <span>{kr(money)} kr.</span>
            </div>
          );
        })}
      </div>
    )}
<h4>💶 Følg bankens beholdning - Aktuel saldo: {kr(bankBalance)} kr.<br/>
🎨 Totosyndikatet satser i dette løb på{" "}
  {totoSyndicate.betsByRace[currentRace]?.colors.join(" og ")} jockeyfarve.<br/>
  💸 Totosyndikatets saldo gennem dette løb: {kr(totoSyndicate.balance)} kr.<br/>
  <p style={{
	marginTop: "6px",
	backgroundColor: "rgba(211,242,112,0.9)",
    borderRadius: "6px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
    fontSize: "15px",
  textAlign: "left"}}
  >
  
	🎲 Staldtips: Giver dobbelt gevinst ved rigtig vinderhest 🏁:
   {staldtipsMessages.map((text, i) => (
      <div key={i} className="staldbet-line">
         {text}
      </div>
    ))}
  </p></h4>

  </div>

        {/* Bankbeskeder */}
<div
  style={{
    flex: 1.2,
    backgroundColor: "#D5FAD0",
    padding: "10px",
    borderRadius: "6px",
    height: "400px",
    overflowY: "auto"
  }}
>
  <h4 style={{ marginTop: 0 }}>💳 Forsikringsbeskeder og Bankbetalinger under løb</h4>

  {bankMessages.map((msg, i) => {

  return (
    <p
      key={msg.id}
      style={{
        opacity: msg.fading ? 0 : 1,
        transition: "opacity 2s ease-in-out",
        margin: 0
      }}
    >
      {msg.text}
    </p>
  );
})}

</div>

        {/* Chancefelt */}
        <div style={{ flex: 1, backgroundColor: "#FFD5D5", padding: "10px", borderRadius: "6px" , height: "400px"}}>
          <h4 style={{ marginTop: 0 }}>🎲 Betalinger under løb til selskaber som ejes af en spiller</h4>
          {chanceMessages.map((msg) => (
  <p
    key={msg.id}
    style={{
      whiteSpace: "pre-wrap",
      opacity: msg.fading ? 0 : 1,
      transition: "opacity 2s ease-in-out",
      margin: 0
    }}
  >
    {msg.text}
  </p>
))}
        </div>
      </div>
    </div>
  </div>
)}

{showHaltPopup && (
  <div style={{
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "#DB3E4F",
	color: "#fff",
    border: "3px solid #DB3E4F",
    borderRadius: "12px",
    padding: "2px",
    zIndex: 9999,
    maxWidth: "800px",
    boxShadow: "0 0 15px rgba(0,0,0,0.5)"
  }}>
    
    <button onClick={() => setShowHaltPopup(null)} style={{ marginTop: "5px" }}
	>
	<h1>🐴 Hest halt og ude af løbet 🏥</h1>
	<img
      src="https://bornholm-golf.dk/derby/static/halt.png"
      alt="Halt"
      style={{ maxWidth: "100%", borderRadius: "6px" }}
    />
    {/* 🎲 Chancekortets originale tekst */}
    {showHaltPopup.chanceText && (
	<p style={{fontStyle: "italic", color: "#000", fontSize: "18px", marginBottom: "12px" }}>
	{showHaltPopup.chanceText}
	</p>
    )}
    <h3>{showHaltPopup.horseName} (ejet af {showHaltPopup.player}) er blevet solgt for 5.000 kr.</h3>
    {showHaltPopup.wasInsured ? (
      <h3>📄 Hesten var forsikret. Der udbetales {showHaltPopup.insurancePaid.toLocaleString()} kr. i erstatning.</h3>
    ) : (
      <h3>⚠️ Hesten var ikke forsikret – der udbetales ingen erstatning.</h3>
    )}
	{showHaltPopup.bankInfo && (
  <p style={{fontStyle: "italic", color: "#000", fontSize: "18px", marginBottom: "12px" }}>{showHaltPopup.bankInfo}</p>
)}
    <p style={{color: "#000", fontSize: "18px", marginBottom: "12px" }}>🕐 Løbet er pauset – tryk for at fortsætte løbet.</p>
    </button>
  </div>
)}

{showTotoSharePopup && (
  <div style={{
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "#EDEDC5",
    border: "3px solid #444",
    borderRadius: "12px",
	textAlign: "center",
    fontSize: "18px",
	padding: "12px 18px",
    zIndex: 9999,
    maxWidth: "600px",
    boxShadow: "0 0 15px rgba(0,0,0,0.5)"
  }}>
    <div style={{ marginTop: "12px", display: "flex", gap: "8px", justifyContent: "center" }}>
      <button
        
		
		onClick={() => {
          // Luk popuppen og fortsæt løbet
          setShowTotoSharePopup(null);
        }}
        style={{
          padding: "8px 4px",
          fontSize: "18px",
		  borderRadius: "8px",
          border: "6px double #DEBE42",
          cursor: "pointer",
          backgroundColor: "#EDEDC5"
        }}
      ><h1 style={{ textAlign:"center"}}>☘️ TOTOSYNDIKATET ☘️</h1>
  
  <h3>👩🏼‍💻Chancehandlingen anmoder om aktieafkast<br/>
    💼 Derby Banken checker om der udloddes afkast!</h3>
	  <img src="https://bornholm-golf.dk/derby/static/aktier.png" alt="Aktier" />
	  <h3>{showTotoSharePopup.message}</h3>

    {showTotoSharePopup.updates?.length > 0 && (
      <ul style={{ textAlign: "left", fontSize: "18px", marginTop: "8px" }}>
        {showTotoSharePopup.updates.map((line, idx) => (
          <li key={idx}>{line}</li>
        ))}
      </ul>
    )}

    {typeof showTotoSharePopup.remainingBalance !== "undefined" && (
      <p style={{textAlign: "center", fontStyle: "italic", fontSize: "20px", marginTop: "8px" }}>
        Restsaldo i Totosyndikatet: {kr(Number(showTotoSharePopup.remainingBalance))} kr.<br/>
      </p>
    )}
        <p style={{textAlign: "center", fontStyle: "italic", fontSize: "20px", marginTop: "8px" }}>Fortsæt løbet</p>
      </button>
    </div>
  </div>
)}
  </div>
);
};
export default DerbyLite;